
const LOCALSTORAGE_KEY_NAME = "welleasy_onboarding_quiz_state";
const QUIZ_DOMPARSER = new DOMParser( );

function WE_QuizTracking_GetState( )
{
    var state = null;
    var raw   = WE_QuizTracking_ReadSessionStorage( "we_quiz_tracking_state" );

    if ( raw )
    {
        try
        {
            state = JSON.parse( raw );
        }
        catch ( e )
        {
            state = null;
        }
    }

    if ( !state )
    {
        state =
        {
            started: false,
            completed: false,
            completedSlides: { },
            resultsProductsOfferedCount: 0
        };
    }

    if ( state.resultsProductsOfferedCount == null )
    {
        state.resultsProductsOfferedCount = 0;
    }

    return state;
}

function WE_QuizTracking_SaveState( state )
{
    WE_QuizTracking_WriteSessionStorage( "we_quiz_tracking_state", JSON.stringify( state ) );
}

function WE_QuizTracking_ResetAttemptState( )
{
    var fresh =
    {
        started: false,
        completed: false,
        completedSlides: { },
        resultsProductsOfferedCount: 0
    };

    WE_QuizTracking_SaveState( fresh );
    try
    {
        sessionStorage.removeItem( "we_quiz_session_id" );
    }
    catch ( e )
    {
    }
}

function WE_QuizTracking_GetQuestionMeta( idx, slideData )
{
    var progress   = null;
    var stepNumber = null;
    var stepId     = "";
    var stepName   = "";
    var result     = { };

    if ( slideData )
    {
        progress = GetQuizProgress( idx );
        if ( progress && progress.currentQuestion != null )
        {
            stepNumber = parseInt( progress.currentQuestion, 10 );
            if ( !( stepNumber >= 1 ) )
            {
                stepNumber = null;
            }
        }

        stepId   = ( slideData.key || ( "slide_" + idx ) );
        stepName = ( slideData.text || "" );

        result =
        {
            step_number: stepNumber,
            step_id: stepId,
            step_name: stepName
        };
    }

    return result;
}

function WE_QuizTracking_HandleSlideView( idx, slideData )
{
    var state  = WE_QuizTracking_GetState( );
    var meta   = null;
    var params = null;

    if ( slideData )
    {
        if ( slideData.slideType == "Question" )
        {
            if ( !state.started )
            {
                WE_QuizTracking_Push( "quiz_start" );
                state.started = true;
            }

            meta = WE_QuizTracking_GetQuestionMeta( idx, slideData );
            params =
            {
                slide_type: slideData.slideType
            };

            if ( meta.step_number != null )
            {
                params.step_number = meta.step_number;
            }
            if ( meta.step_id )
            {
                params.step_id = meta.step_id;
            }
            if ( meta.step_name )
            {
                params.step_name = meta.step_name;
            }

            var progressInfo = GetQuizProgress( idx );
            if ( progressInfo && progressInfo.max > 0 && meta.step_number != null )
            {
                params.question_count   = progressInfo.max;
                params.progress_percent = Math.round( 100 * meta.step_number / progressInfo.max );
            }

            WE_QuizTracking_Push( "quiz_step_view", params );
        }
        else if ( slideData.slideType == "ResultsLoading" || slideData.slideType == "Results" || slideData.slideType == "ResultsExplore" || slideData.slideType == "CartRedirect" )
        {
            if ( !state.completed )
            {
                WE_QuizTracking_Push( "quiz_complete", { slide_type: slideData.slideType } );
                state.completed = true;
            }
        }
    }

    WE_QuizTracking_SaveState( state );
}

function WE_QuizTracking_HandleStepComplete( idx, slideData )
{
    var state         = null;
    var slideKey      = "";
    var selected      = null;
    var selectedCount = 0;
    var meta          = null;
    var params        = null;
    var shouldTrack   = false;

    shouldTrack = slideData && ( slideData.slideType == "Question" );

    if ( shouldTrack )
    {
        state = WE_QuizTracking_GetState( );
        if ( !state.started )
        {
            state.started = true;
        }

        slideKey = String( idx );
        if ( !state.completedSlides[ slideKey ] )
        {
            selected = ( GetQuizState( )[ slideData.key ] || [ ] );
            if ( selected && selected.length != null )
            {
                selectedCount = selected.length;
            }

            meta = WE_QuizTracking_GetQuestionMeta( idx, slideData );
            params =
            {
                slide_type: slideData.slideType,
                answer_count: selectedCount
            };
            if ( meta.step_number != null )
            {
                params.step_number = meta.step_number;
            }
            if ( meta.step_id )
            {
                params.step_id = meta.step_id;
            }
            if ( meta.step_name )
            {
                params.step_name = meta.step_name;
            }

            WE_QuizTracking_Push( "quiz_step_complete", params );
            state.completedSlides[ slideKey ] = true;
        }

        WE_QuizTracking_SaveState( state );
    }
}

function WE_QuizTracking_HandlePageExit( )
{
    var state = WE_QuizTracking_GetState( );

    if ( state.started && !state.completed )
    {
        WE_QuizTracking_Push( "quiz_exit", { exit_reason: "page_unload" } );
    }
}

function WE_QuizTracking_GetShopCurrency( )
{
    var cur = "GBP";

    if ( window.Shopify && window.Shopify.currency && window.Shopify.currency.active )
    {
        cur = window.Shopify.currency.active;
    }

    return cur;
}

function WE_QuizTracking_ParseCardCommerceFields( card )
{
    var parsed = WE_QuizResults_ParseCardPriceAndLabels( card );

    return { item_name: parsed.item_name, item_brand: parsed.item_brand, price: parsed.price };
}

function WE_QuizTracking_PushResultsPageAddToCart( lineItems )
{
    var currency   = WE_QuizTracking_GetShopCurrency( );
    var items      = [ ];
    var value      = 0;
    var i          = 0;
    var row        = null;
    var card       = null;
    var meta       = null;
    var qty        = 1;
    var linePrice  = 0;
    var gaItem     = null;
    var trackState = null;
    var offered    = 0;
    var pushExtra  = null;

    if ( lineItems && lineItems.length > 0 )
    {
        for ( i = 0; i < lineItems.length; i++ )
        {
            row  = lineItems[ i ];
            card = row._card;
            meta = WE_QuizTracking_ParseCardCommerceFields( card );
            qty  = Number( row.quantity );
            if ( qty != qty )
            {
                qty = 1;
            }
            if ( qty < 1 )
            {
                qty = 1;
            }

            linePrice = 0;
            if ( meta.price > 0 )
            {
                linePrice = meta.price;
            }
            value += linePrice * qty;

            gaItem =
            {
                item_id: String( row.id ),
                item_name: meta.item_name || "",
                quantity: qty,
                price: linePrice,
                item_list_id: "quiz_results",
                item_list_name: "quiz_results"
            };

            if ( meta.item_brand )
            {
                gaItem.item_brand = meta.item_brand;
            }

            items.push( gaItem );
        }

        trackState = WE_QuizTracking_GetState( );
        offered    = trackState.resultsProductsOfferedCount;
        pushExtra =
        {
            currency: currency,
            value: value,
            items: items,
            quiz_results_built: true,
            quiz_results_bulk: true,
            quiz_results_items_added: items.length
        };

        if ( offered > 0 )
        {
            pushExtra.quiz_results_products_offered = offered;
            pushExtra.quiz_results_added_vs_offered_pct = Math.min( 100, Math.round( ( 100 * items.length ) / offered ) );
        }

        WE_QuizTracking_Push( "add_to_cart", pushExtra );
    }
}

function WE_QuizTracking_RecordResultsProductsOfferedMax( )
{
    var productsEl = document.querySelector( ".we-onboarding-quiz-results-products" );
    var n          = 0;
    var state      = null;
    var prevMax    = 0;

    if ( productsEl )
    {
        n = productsEl.querySelectorAll( ".we-quiz-card" ).length;
        if ( n == 0 )
        {
            n = productsEl.querySelectorAll( ".ec-product-card, .product-grid__product-card" ).length;
        }
    }

    state   = WE_QuizTracking_GetState( );
    prevMax = state.resultsProductsOfferedCount;
    if ( n > state.resultsProductsOfferedCount )
    {
        state.resultsProductsOfferedCount = n;
        WE_QuizTracking_SaveState( state );
    }

    console.log( "[WE Quiz Debug] RecordResultsProductsOfferedMax", {
        cards_counted_this_run: n,
        resultsProductsOfferedCount_stored: state.resultsProductsOfferedCount,
        bumped_max: n > prevMax
    } );
}

function WE_QuizKlaviyo_GetCardImageUrl( card )
{
    var imageEl  = null;
    var imageUrl = "";

    imageEl = card.querySelector( ".we-quiz-card__image-img, .ec-product-image-container img, .product-card__image img, .product-card__image__img, [id=\"product-card-image-container\"] img" );
    imageUrl = WE_QuizResults_GetMainImageUrl( imageEl );

    return imageUrl;
}

function WE_QuizKlaviyo_GetCardProductUrl( card )
{
    var linkEl     = null;
    var productUrl = "";

    linkEl = card.querySelector( "a[href*=\"/products/\"]" );

    if ( linkEl )
    {
        productUrl = linkEl.href;
    }

    return productUrl;
}

function WE_QuizKlaviyo_BuildProduct( card )
{
    var parsed  = WE_QuizResults_ParseCardPriceAndLabels( card );
    var product =
    {
        title: parsed.item_name || "",
        vendor: parsed.item_brand || "",
        price: parsed.price || 0,
        image: WE_QuizKlaviyo_GetCardImageUrl( card ),
        url: WE_QuizKlaviyo_GetCardProductUrl( card ),
        handle: WE_QuizResults_GetProductHandleFromCard( card ),
        variant_id: WE_QuizResults_GetCardVariantId( card )
    };

    return product;
}

function WE_QuizKlaviyo_TrackResults( productsEl )
{
    var cards    = productsEl.querySelectorAll( ".we-quiz-card, .ec-product-card, .product-grid__product-card" );
    var products = [ ];

    if ( productsEl._weQuizKlaviyoResultsTracked != true && cards.length > 0 && window._learnq )
    {
        productsEl._weQuizKlaviyoResultsTracked = true;

        // Add cards to an array of cards to get more data for
        const productsToWaitFor = Array.from( cards ).map( function( card )
        {
            const variantId = card.dataset.variantId;
            if ( variantId )
            {
                return variantId;
            }
        } );

        console.log( "[WE Quiz Debug] Enhancing tracking data for " + cards.length + " products" );

        // Wait for cards to be populated with more data
        var trackingComplete = false;
        document.addEventListener( "enhancedcommerce:card_prices_ready", function WE_QuizKlaviyo_OnCardEnhance( event )
        {
            const card = event.detail.card;
            var productData;

            try
            {
                productData = JSON.parse( card.dataset.productData );
            }
            catch ( error )
            {
                console.error( "[WE Quiz Debug] Failed to parse product data for Klaviyo tracking" );
            }

            var variantId;
            if ( productData.attributes && productData.attributes.to_cart_variant_id && productData.attributes.to_cart_variant_id.length )
            {
                variantId = productData.attributes.to_cart_variant_id[ 0 ]
            }

            // Card from event is in the array so fetch its data and push to final array
            if ( productsToWaitFor.length > 0 && productData && productsToWaitFor.includes( variantId ) )
            {
                const data = WE_QuizKlaviyo_BuildProduct( card );
                data[ "product_id" ] = productData.attributes.to_cart_product_id[ 0 ];
                products.push( data );

                const index = productsToWaitFor.indexOf( variantId );
                if ( index > -1 )
                {
                    productsToWaitFor.splice( index, 1 );
                }
            }

            // No more products to wait for and results event has not already been tracked
            if ( productsToWaitFor.length == 0 && trackingComplete == false )
            {
                window._learnq.push( [
                    "track",
                    "Quiz Results Ready",
                    {
                        quiz_name: "welleasy_onboarding_quiz",
                        quiz_products_count: products.length,
                        recommended_products: products
                    }
                ] );

                if ( window.customer && window.customer.email )
                {
                    const productIds = products.map( function( product ){ return product.product_id; } );
                    window._learnq.push( [
                        "identify",
                        {
                            quiz_reccs: productIds
                        }
                    ] );
                }

                console.log( "[WE Quiz Debug] Tracked quiz recommendations successfully for " + products.length + " products" );

                // Cleanup
                trackingComplete = true;
                document.removeEventListener( "enhancedcommerce:card_prices_ready", WE_QuizKlaviyo_OnCardEnhance );
            }
        } );
    }
}


function safeGetA( obj, keys )
{
    var result;
    if ( obj ) try
    {
        // sigh. must be a better way of doing this.
        if ( ( keys.length > 0 ) && ( keys[ 0 ].indexOf ) )
        {
            var arStart = keys[ 0 ].indexOf( "[" );
            if ( arStart >= 0 )
            {
                var ar       = keys.shift( );
                var numStart = arStart + 1;
                var arName   = ar.substr( 0, arStart );
                var numEnd   = ar.indexOf( "]" );
                var numStr   = ar.substr( numStart, numEnd - numStart );
                var idx      = Number( numStr );
                keys.splice( 0, 0, idx );
                if ( arStart > 0 )
                {
                    keys.splice( 0, 0, arName );
                }
            }
        }

        if ( keys.length == 1 )
        {
            result = obj[ keys[ 0 ] ];
        }
        else
        {
            var next = keys.shift( );
            if ( obj[ next ] )
            {
                result = safeGetA( obj[ next ], keys );
            }
        }
    }
    catch ( e )
    {
        logger.log( logger.LOG_WARNING, "safeGet failed : " + e.stack );
    }
    return ( result );
}
function SafeGet( obj, keys )
{
    var result;
    if ( keys )
    {
        result = safeGetA( obj, keys.split( "." ) );
    }
    else
    {
        result = obj;
    }
    return ( result );
}

function SpecialiseElement( element, data, getter )
{
    var key = element.getAttribute( "data-key" );
    if ( key )
    {
        var value = getter( data, key );
        var type  = element.getAttribute( "data-type" );
        var api   = element.getAttribute( "data-api" );
        if ( ( value == undefined ) && ( type == "html" ) )
        {
            $( element ).summernote( "code", "" );
        }
        else if ( ( value == undefined ) && ( api ) )
        {
            // another special case for dynamic elements
            // should probably refactor this function
            if ( api )
            {
                SpecialiseDynamicElement( element, value, api );
            }
        }
        else
        {
            if ( type == undefined )
            {
                type = element.type;
            }
            if ( value == undefined )
            {
                value = "";
            }

            if ( type == "id" )
            {
                element.setAttribute( "data-id", value );
            }
            else if ( type == "html" )
            {
                $( element ).summernote( "code", value );
            }
            else if ( type == "proxy" )
            {
                // ignore
            }
            else if ( ( element.tagName == "INPUT" ) || ( element.tagName == "SELECT" ) )
            {
                if ( type == "date" )
                {
                    element.value = Undateify( new Date( value ) );
                }
                else if ( ( type == "select" ) || ( element.tagName == "SELECT" ) )
                {
                    var api = element.getAttribute( "data-api" );
                    if ( api )
                    {
                        SpecialiseDynamicElement( element, value, api );
                    }
                    else
                    {
                        SetSelectedSpecialisedElement( element, value );
                    }
                }
                else if ( type == "datetime" )
                {
                    if ( element.getAttribute( "type" ) == "datetime-local" )
                    {
                        element.value = new Date( value ).toISOString( ).substr( 0, 19 );
                    }
                    else
                    {
                        element.value = new Date( value ).toLocaleString( );
                        element.setAttribute( "data-value", new Date( value ).toISOString( ) );
                    }
                }
                else if (   type == "boolean" )
                {
                    if ( value )
                    {
                        element.checked = "checked";
                    }
                }
                else
                {
                    var it = element.getAttribute( "type" );
                    if ( it == "radio" )
                    {
                        if ( value == element.value )
                        {
                            element.checked = true;
                        }
                        else
                        {
                            element.checked = false;
                        }
                    }
                    else if ( it == "checkbox" )
                    {
                        if ( value )
                        {
                            element.checked = true;
                        }
                        else
                        {
                            element.checked = false;
                        }
                    }
                    else
                    {
                        element.value = value;
                        element.setAttribute( "data-value", value ); // for some reason setting "value" is misbehaving
                    }
                }
            }
            else if ( ( element.tagName == "A" ) && ( type == "link" ) )
            {
                var hr = element.getAttribute( "href" );
                if ( hr == undefined )
                {
                    hr = "";
                }
                hr += value;
                element.setAttribute( "href", hr );
            }
            else if ( element.tagName == "IMG" )
            {
                element.setAttribute( "src", value );
            }
            else if ( element.tagName == "TEXTAREA" )
            {
                element.value = value;
            }
            else
            {
                if ( type == "price" )
                {
                    value = "\u00A3" + value;
                }
                else if ( type == "date" )
                {
                    value = Undateify( new Date( value ) );
                }

                //element.appendChild( document.createTextNode( value ) );
                element.innerText = value;
            }
            element.setAttribute( "data-value", value );
        }
    }
}

function Specialise( root, data )
{
    var dynamicElements = root.querySelectorAll( "[data-key]" );

    for ( var i = 0; i < dynamicElements.length; i++ )
    {
        var element = dynamicElements[ i ];
        SpecialiseElement( element, data, SafeGet );
    }
}

function GetQuizState( )
{
    var result   = { };
    var savedStr = window.localStorage.getItem( LOCALSTORAGE_KEY_NAME );

    if ( ( savedStr ) && ( savedStr.length > 0 ) )
    {
        try
        {
            result = JSON.parse( savedStr );
        }
        catch ( e )
        {
        }
    }
    
    return ( result );
}

function ParseQP( )
{
    var qpd   = { };
    var qp    = window.location.search.substr( 1 );
    var pairs = qp.split( "&" );

    for ( var i = 0; i < pairs.length; i++ )
    {
        var tuple = pairs[ i ].split( "=" );
        if ( ( tuple ) && ( tuple.length == 2 ) )
        {
            var key  = tuple[ 0 ];
            var val  = tuple[ 1 ];
            qpd[ key ] = decodeURIComponent( val );
        }
    }

    return ( qpd );
}

function WE_OnboardingQuiz_FindSlideIdxByPosition( position )
{
    var idx      = -1;
    var i        = 0;
    var slidePos = 0;
    if ( window._onboardingQuizData && window._onboardingQuizData.slides )
    {
        for ( i = 0; i < window._onboardingQuizData.slides.length; i++ )
        {
            slidePos = parseInt( window._onboardingQuizData.slides[ i ].position, 10 );
            if ( !isNaN( slidePos ) && slidePos == position )
            {
                idx = i;
                break;
            }
        }
    }
    return ( idx );
}

/* Progress key as a literal (not SAVE_EXIT_STORAGE_KEY): that const is
   declared far below, and quiz init runs during initial evaluation. */
function WE_OnboardingQuiz_ReadProgressPosition( )
{
    var position = 0;
    var raw      = null;
    var parsed   = null;
    try
    {
        raw = window.localStorage.getItem( "welleasy_onboarding_quiz_progress" );
    }
    catch ( e )
    {
        raw = null;
    }
    if ( raw )
    {
        try
        {
            parsed = JSON.parse( raw );
        }
        catch ( e )
        {
            parsed = null;
        }
        if ( parsed && parsed.slideIndex )
        {
            position = parseInt( parsed.slideIndex, 10 ) || 0;
        }
    }
    return ( position );
}

function WE_QuizProgress_ReadRecord( )
{
    var record = null;
    var raw    = null;
    var parsed = null;
    try
    {
        raw = window.localStorage.getItem( "welleasy_onboarding_quiz_progress" );
    }
    catch ( e )
    {
        raw = null;
    }
    if ( raw )
    {
        try
        {
            parsed = JSON.parse( raw );
        }
        catch ( e )
        {
            parsed = null;
        }
        if ( parsed )
        {
            record =
            {
                position: parsed.position != undefined ? parsed.position : parsed.slideIndex,
                key: parsed.key || null,
                parent: parsed.parent || null
            };
        }
    }
    return record;
}

function WE_QuizConditional_BuildSlide( parentSlide, cslide )
{
    var built = null;
    built =
    {
        "slideType": "Question",
        "position": 0,
        "autoadvanceTime": 0,
        "key": cslide.key,
        "backdrop": parentSlide.backdrop,
        "text": cslide.text,
        "interstitialHeader": "",
        "interstitialBody": "",
        "welcomeBody": "",
        "answerType": cslide.answerType,
        "answers": cslide.answers,
        "_conditional": true,
        "_parentKey": parentSlide.key
    };
    return built;
}

function WE_QuizProgress_NearestIdx( slides, position )
{
    var idx    = 0;
    var i      = 0;
    var target = parseInt( position, 10 );
    var best   = -1;
    var dist   = 0;
    if ( isNaN( target ) )
    {
        target = 0;
    }
    for ( i = 0; i < slides.length; i++ )
    {
        if ( slides[ i ].slideType == "Question" )
        {
            dist = Math.abs( parseInt( slides[ i ].position, 10 ) - target );
            if ( best < 0 || dist < best )
            {
                best = dist;
                idx = i;
            }
        }
    }
    return idx;
}

function WE_QuizProgress_EnsureConditional( slides, record )
{
    var idx    = -1;
    var parent = -1;
    var cslide = null;
    var sub    = null;
    var i      = 0;
    for ( i = 0; i < slides.length; i++ )
    {
        if ( slides[ i ].key == record.key )
        {
            idx = i;
        }
        if ( slides[ i ].key == record.parent )
        {
            parent = i;
        }
    }
    if ( idx < 0 && parent >= 0 && window._onboardingQuizData._csKeyMap )
    {
        cslide = window._onboardingQuizData._csKeyMap[ record.key ];
        if ( cslide )
        {
            sub = WE_QuizConditional_BuildSlide( slides[ parent ], cslide );
            slides.splice( parent + 1, 0, sub );
            idx = parent + 1;
        }
        else
        {
            idx = parent;
        }
    }
    if ( idx < 0 )
    {
        idx = WE_QuizProgress_NearestIdx( slides, 0 );
    }
    return idx;
}

function WE_QuizProgress_ResolveIdx( )
{
    var record = WE_QuizProgress_ReadRecord( );
    var slides = null;
    var idx    = -1;
    var i      = 0;
    slides = ( window._onboardingQuizData && window._onboardingQuizData.slides ) ? window._onboardingQuizData.slides : [ ];
    if ( record )
    {
        if ( record.position == "gift" )
        {
            idx = -2;
        }
        else if ( record.parent )
        {
            idx = WE_QuizProgress_EnsureConditional( slides, record );
        }
        else
        {
            for ( i = 0; i < slides.length; i++ )
            {
                if ( slides[ i ].key == record.key || parseInt( slides[ i ].position, 10 ) == parseInt( record.position, 10 ) )
                {
                    idx = i;
                    break;
                }
            }
            if ( idx < 0 )
            {
                idx = WE_QuizProgress_NearestIdx( slides, record.position );
            }
        }
    }
    return idx;
}

function WE_QuizProgress_WriteForSlide( slideData )
{
    var record = null;
    var slides = null;
    var parent = 0;
    var i      = 0;
    slides = ( window._onboardingQuizData && window._onboardingQuizData.slides ) ? window._onboardingQuizData.slides : [ ];
    if ( slideData )
    {
        if ( slideData._conditional )
        {
            for ( i = 0; i < slides.length; i++ )
            {
                if ( slides[ i ].key == slideData._parentKey )
                {
                    parent = parseInt( slides[ i ].position, 10 );
                }
            }
            record =
            {
                position: parent,
                key: slideData.key,
                parent: slideData._parentKey
            };
        }
        else if ( parseInt( slideData.position, 10 ) > 0 && parseInt( slideData.position, 10 ) < 9999 )
        {
            record =
            {
                position: parseInt( slideData.position, 10 ),
                key: slideData.key,
                parent: null
            };
        }
        if ( record )
        {
            try { window.localStorage.setItem( "welleasy_onboarding_quiz_progress", JSON.stringify( record ) ); } catch ( e ) {}
        }
    }
}

function WE_QuizProgress_WriteGift( )
{
    var record = null;
    record =
    {
        position: "gift",
        key: "gift",
        parent: null
    };
    try { window.localStorage.setItem( "welleasy_onboarding_quiz_progress", JSON.stringify( record ) ); } catch ( e ) {}
}

function MakeQPStr( qpd )
{
    var str = "?";

    for ( var key in qpd )
    {
        if ( str.length > 1 )
        {
            str += "&";
        }
        str += encodeURIComponent( key ) + "=" + encodeURIComponent( qpd[ key ] );
    }

    return ( str );
}

// onboarding quiz version of SendAPIRequest
function OQ_SendAPIRequest( url, method, payload, cb )
{
    // there's a function called SendAPIRequest in rcp-interface.js, so can either wait for that module to be loaded
    // and available, or just duplicate the code here
    // it's probably cleaner to have a duplicate here, since that way the quiz would still work if the rcp module gets
    // removed (separation of concerns)
    // but it's defintely more maintainable - and leads to a smaller codebase - to use the existing routine, although
    // that then introduces a load-order timing issue
    // the obvious third approach is to move SendAPIRequest into some kind of global util file that's guaranteed to be
    // loaded before either rcp-interface.js or this file, but that means changing rcp as part of the quiz dev
    // which introduces additional risk and testing overhead
    
    // for now - because it's easy - just keep the load-time race conditions contained within this routine
    if ( window.SendAPIRequest )
    {
        window.SendAPIRequest( url, method, payload, cb );
    }
    else
    {
        var xhr = new XMLHttpRequest( );

        function OQ_SendAPIRequest_OnReadyStateChange( )
        {
            if ( xhr.readyState == 4 )
            {
                var response;
                var err;

                if ( xhr.status == 200 )
                {
                    if ( ( xhr.responseText ) && ( xhr.responseText.length > 0 ) )
                    {
                        try
                        {
                            response = JSON.parse( xhr.responseText );
                        }
                        catch ( e )
                        {
                            console.log( "error parsing response : " + e.stack );
                            err = { "error": e };
                        }
                    }
                }
                else
                {
                    err = { "error": xhr.status };

                    if ( ( xhr.responseText ) && ( xhr.responseText.length > 0 ) )
                    {
                        try
                        {
                            err.detail = JSON.parse( xhr.responseText );
                        }
                        catch ( e )
                        {
                        }
                    }
                }

                cb( err, response, xhr );
            }
        }

        xhr.onreadystatechange = OQ_SendAPIRequest_OnReadyStateChange;

        if ( method == "GET" )
        {
            var qpStr = "?";
            if ( payload )
            {
                qpStr = MakeQPStr( payload );
            }
            xhr.open( method, url + qpStr, true );
            xhr.send( );
        }
        else
        {
            if ( !payload )
            {
                payload = {};
            }
            xhr.open( method, url, true );
            xhr.setRequestHeader( "Content-Type", "application/json" );
            xhr.send( JSON.stringify( payload ) );
        }
    }
}

function ReallySaveOnboardingQuizState( payload, ecpayload )
{
    OQ_SendAPIRequest( window._onboardingQuizAPIRoot + "/set-custom-data", "POST", payload, function( ) { } );
    if ( ecpayload )
    {
        OQ_SendAPIRequest( "https://app.enhanced-commerce.com/api/v3/customer-data", "POST", ecpayload, function( ) { } );
    }
}

// mw 20260314 : removed all this async timer stuff because it's almost certain to go wrong and/or cause performance issues
//function SaveOnboardingQuizState_SendCallback( err, result )
//{
//}

//function SaveOnboardingQuizState_RunSave( payload, ecpayload )
//{
//    if ( !window.SendAPIRequest ) { return false; }
//    SendAPIRequest( window._onboardingQuizAPIRoot + "/set-custom-data", "POST", payload, SaveOnboardingQuizState_SendCallback );
//    if ( ecpayload )
//    {
//        SendAPIRequest( "https://app.enhanced-commerce.com/api/v3/customer-data", "POST", ecpayload, SaveOnboardingQuizState_SendCallback );
//    }
//    return true;
//}
//
//function SaveOnboardingQuizState_PollTick( payload, ecpayload, intervalRef, attemptsRef, maxAttempts )
//{
//    attemptsRef[ 0 ]++;
//    if ( SaveOnboardingQuizState_RunSave( payload, ecpayload ) || attemptsRef[ 0 ] >= maxAttempts )
//    {
//        clearInterval( intervalRef[ 0 ] );
//    }
//}

function FetchCollectionsFromShopify( collectionHandles, cb )
{
    var collections = [];

    window._onboardingMappingCollections = window._onboardingMappingCollections || {};
    
    function GetOneCollection( idx )
    {
        if( idx < collectionHandles.length )
        {
            var handle      = collectionHandles[ idx ];
            var allProducts = [];
            var payload     = {
                limit: 200
            }

            if( window._onboardingMappingCollections[ handle ] )
            {
                collections.push( window._onboardingMappingCollections[ handle ] );
                GetOneCollection( idx + 1 );
            }
            else
            {
                function FetchPage( pageNum )
                {
                    payload.page = pageNum;
                    OQ_SendAPIRequest( 
                        window.location.origin + '/collections/' + handle + '/products.json', 
                        'GET', 
                        payload, 
                        function( error, data )
                        {
                            if( data && data.products )
                            {
                                allProducts = allProducts.concat( data.products );
                                if( data.products.length == 200 )
                                {
                                    FetchPage( pageNum + 1 );
                                }
                                else
                                {
                                    collections.push( allProducts.map( function( product ) { return product.id; } ) );
                                    window._onboardingMappingCollections[ handle ] = collections[ collections.length - 1 ];
                                    GetOneCollection( idx + 1 );
                                }
                            }
                            else
                            {
                                console.error( 'Failed to fetch collection ' + handle + ': ' + error );
                                GetOneCollection( idx + 1 );
                            }
                        }
                    );
                }
                
                FetchPage( 1 );
            }
        }
        else
        {
            cb( collections );
        }
    }
    
    if( window.SendAPIRequest )
    {
        GetOneCollection( 0 );
    }
}

function IsAnswerInState( stateValues, answerValue )
{
    var i;
    var found = false;
    if ( stateValues && Array.isArray( stateValues ) )
    {
        for ( i = 0; i < stateValues.length; i++ )
        {
            if ( stateValues[ i ] == answerValue || stateValues[ i ].indexOf( answerValue + ":" ) == 0 )
            {
                found = true;
                break;
            }
        }
    }
    return found;
}

function HandleProductMapping( state, ecpayload, slides )
{
    ecpayload.data.inclusiveProductTags = ecpayload.data.inclusiveProductTags || { };
    ecpayload.data.collectionProducts   = ecpayload.data.collectionProducts || { };
    ecpayload.data.collectionHandles    = ecpayload.data.collectionHandles || { };
    ecpayload.data.vendors              = ecpayload.data.vendors || { };

    if ( state.peopleCount && state.peopleCount.length > 0 )
    {
        var people      = Number( state.peopleCount[ 0 ] );
        var targets     = window._onboardingQuizData.peopleCountTargets;
        var targetValue = targets[ String( people ) ];
        if ( targetValue != null )
        {
            ecpayload.data.targetValue = targetValue;
        }
        var targetsMax     = window._onboardingQuizData.peopleCountTargetsMax;
        var targetValueMax = targetsMax ? targetsMax[ String( people ) ] : null;
        if ( targetValueMax != null )
        {
            ecpayload.data.targetValueMax = targetValueMax;
        }
    }

    if ( state.brands )
    {
        state.brands.forEach( function( brand )
        {
            ecpayload.data.vendors[ brand.toLowerCase( ) ] = 1;
        } );
    }

    var collectionHandles = [];

    function HandleProductMappingSlide( slide )
    {
        function HandleProductMappingAnswer( answer )
        {
            var tag = answer.productTag && answer.productTag.trim ? answer.productTag.trim() : ( answer.productTag || "" );
            if ( tag.length > 0 && IsAnswerInState( state[ slide.key ], answer.value ) && ecpayload.data.inclusiveProductTags[ tag ] == null )
            {
                ecpayload.data.inclusiveProductTags[ tag ] = "2";
            }
            else if( answer.productCollection && answer.productCollection.length > 0 )
            {
                for ( var key in state )
                {
                    if ( state[ key ].includes( answer.value ) )
                    {
                        collectionHandles.push( answer.productCollection );
                        ecpayload.data.collectionHandles[ answer.productCollection ] = true;
                    }
                }
            }
        }

        if( slide.slideType == "Question" )
        {
            var answers = slide.answers;
            if( answers.length > 0 )
            {
                answers.forEach( HandleProductMappingAnswer );
            }
        }
    }

    slides.forEach( HandleProductMappingSlide );

    if ( window._onboardingQuizData._csKeyMap )
    {
        for ( var csKey in window._onboardingQuizData._csKeyMap )
        {
            var csSlide = window._onboardingQuizData._csKeyMap[ csKey ];

            if ( csSlide && csSlide.answers && csSlide.answers.length > 0 )
            {
                csSlide.answers.forEach( function handleCsAnswer( answer )
                {
                    if ( answer.productCollection && answer.productCollection.length > 0 )
                    {
                        for ( var stateKey in state )
                        {
                            if ( state[ stateKey ].includes( answer.value ) )
                            {
                                ecpayload.data.collectionHandles[ answer.productCollection ] = true;
                            }
                        }
                    }
                });
            }
        }
    }

    // mw 20260223 : disabled the below for now, it's not working properly...
    //FetchCollectionsFromShopify( collectionHandles, function( collections )
    //{
    //    var productIdCounts = {};
    //    
    //    collections.forEach( function( productIds ) {
    //        productIds.forEach( function( productId ) {
    //            productIdCounts[ productId ] = ( productIdCounts[ productId ] || 0 ) + 1;
    //        });
    //    });
    //    
    //    var sortedEntries = Object.entries( productIdCounts ).sort( function( a, b )
    //    {
    //        return b[ 1 ] - a[ 1 ];
    //    });
    //
    //    ecpayload.collectionProducts = sortedEntries;
    //    console.log( "Sorted Entries: ", sortedEntries );
    //});

    return ecpayload;
}

// send state to the API if logged in (defers until SendAPIRequest is available)
function SaveOnboardingQuizState( )
{
    var quiz       = null;
    var state      = null;
    var payload    = null;
    var ecpayload  = null;
    var i          = 0;
    var entry      = null;
    var parts      = null;
    var levelStr   = null;
    var levelParts = null;
    var diet       = null;
    var attempts   = [ 0 ];
    var intervalRef = [ null ];

    if ( window._onboardingQuizData.auth )
    {
        quiz       = document.querySelector( ".we-onboarding-quiz" );
        state      = GetQuizState( );
        payload    = { "onboardingQuizAnswers" : state, "auth" : window._onboardingQuizData.auth };

        if ( state.diets && state.diets.length > 0 )
        {
            ecpayload = { "auth" : window._onboardingQuizData.auth, "data" : { "inclusiveProductTags" : { }, "collectionProducts" : { } } };
            for ( i = 0; i < state.diets.length; i++ )
            {
                entry      = state.diets[ i ];
                parts      = entry.split( ":" );
                if ( parts.length == 2 )
                {
                    levelStr   = parts[ 1 ];
                    levelParts = levelStr.split( "-" );
                    if ( levelParts.length == 2 )
                    {
                        diet = parts[ 0 ].trim( );
                        if ( ecpayload.data.inclusiveProductTags[ diet ] == null )
                        {
                            ecpayload.data.inclusiveProductTags[ diet ] = levelParts[ 1 ];
                        }
                    }
                }
            }
        }
        if ( !ecpayload )
        {
            ecpayload = { "auth" : window._onboardingQuizData.auth, "data" : { "inclusiveProductTags" : { }, "collectionProducts" : { }, "collectionHandles" : { } } };
        }
        ecpayload = HandleProductMapping( state, ecpayload, window._onboardingQuizData.slides );

        ReallySaveOnboardingQuizState( payload, ecpayload );

        // mw 20260314 : removed all this async timer stuff because it's almost certain to go wrong and/or cause performance issues
        //if ( !SaveOnboardingQuizState_RunSave( payload, ecpayload ) )
        //{
        //    intervalRef[ 0 ] = setInterval( SaveOnboardingQuizState_Interval, 100 );
        //}

        //function SaveOnboardingQuizState_Interval( )
        //{
        //    SaveOnboardingQuizState_PollTick( payload, ecpayload, intervalRef, attempts, 100 );
        //}
    }
}

// save the current answers to localstorage
function SaveOnboardingQuizAnswers( )
{
    try { sessionStorage.removeItem( "we_quiz_added_to_cart" ); } catch ( e ) { }
    var quiz             = document.querySelector( ".we-onboarding-quiz" );
    var qidx             = Number( quiz.getAttribute( "data-idx" ) );
    var slide            = window._onboardingQuizData.slides[ qidx ];
    var data             = GetQuizState( );
    var answersContainer = quiz.querySelector( ".we-onboarding-quiz-answers" );
    var selected         = answersContainer.querySelectorAll( ".we-onboarding-quiz-selected-answer:not( [data-select-all] ):not( .we-onboarding-quiz-none-of-these )" );
    var toSet            = [ ];

    function CollectSelectedAnswer( selection )
    {
        // if answer has additional options, append to the value
        // if option is somehow null, don't add the answer at all
        if ( selection._answerData.selectedOption && selection._answerData.selectedOption != null )
        {
            toSet.push( selection._answerData.value + ":" + selection._answerData.selectedOption );
        }
        else if ( !selection._answerData.selectedOption )
        {
            toSet.push( selection._answerData.value );
        }
    }
    selected.forEach( CollectSelectedAnswer );
    
    data[ slide.key ] = toSet;

    window.localStorage.setItem( LOCALSTORAGE_KEY_NAME, JSON.stringify( data ) );
}


function AnswerClicked( e )
{
    var answer = e.currentTarget;
    var quiz   = answer.closest( ".we-onboarding-quiz" );
    var answersScrollContainer = answer.closest( ".we-onboarding-quiz-answers" );
    var savedAnswersScrollTop  = answersScrollContainer ? answersScrollContainer.scrollTop : 0;
    var savedQuizScrollTop     = quiz ? quiz.scrollTop : 0;
    var qidx   = Number( quiz.getAttribute( "data-idx" ) );
    var slide  = window._onboardingQuizData.slides[ qidx ];

    if ( answer._isNoneOfThese )
    {
        var allAnswers = answer.closest( ".we-onboarding-quiz-answers" ).querySelectorAll( ".we-onboarding-quiz-answer:not( .we-onboarding-quiz-none-of-these )" );
        function DeselectAll( ans )
        {
            ans.classList.remove( "we-onboarding-quiz-selected-answer" );
        }
        allAnswers.forEach( DeselectAll );
        answer.classList.toggle( "we-onboarding-quiz-selected-answer" );
        SaveOnboardingQuizAnswers( );
        return;
    }

    if ( slide.answerType == "Single" )
    {
        if ( answer.classList.contains( "we-onboarding-quiz-selected-answer" ) )
        {
            answer.classList.remove( "we-onboarding-quiz-selected-answer" );
            CloseOptionsPopup( );
        }
        else
        {
            var answers = answer.closest( ".we-onboarding-quiz-answers" ).querySelectorAll( ".we-onboarding-quiz-answer:not( [data-select-all] ):not( .we-onboarding-quiz-none-of-these )" );
            function ToggleSingleAnswer( toCheck )
            {
                if ( toCheck == answer )
                {
                    toCheck.classList.add( "we-onboarding-quiz-selected-answer" );
                }
                else
                {
                    toCheck.classList.remove( "we-onboarding-quiz-selected-answer" );
                }
            }
            answers.forEach( ToggleSingleAnswer );
        }
    }
    else
    {
        answer.classList.toggle( "we-onboarding-quiz-selected-answer" );

        var answers = answer.closest( ".we-onboarding-quiz-answers" ).querySelectorAll( ".we-onboarding-quiz-answer:not( [data-select-all] ):not( .we-onboarding-quiz-none-of-these )" );
        function ToggleMultipleAnswer( toCheck )
        {
            if ( answer._answerData.none )
            {
                if ( ( answer.classList.contains( "we-onboarding-quiz-selected-answer" ) ) && ( answer != toCheck ) )
                {
                    toCheck.classList.remove( "we-onboarding-quiz-selected-answer" );
                }
            }
            else if ( ( toCheck._answerData.none ) && ( answer.classList.contains( "we-onboarding-quiz-selected-answer" ) ) )
            {
                toCheck.classList.remove( "we-onboarding-quiz-selected-answer" );
            }
        }
        answers.forEach( ToggleMultipleAnswer );
    }

    // const cardContent = answer.querySelector( ".we-onboarding-quiz-answer-card-content" );
    // const desc = cardContent ? cardContent.querySelector( ".we-onboarding-quiz-answer-description" ) : answer.querySelector( ".we-onboarding-quiz-answer-description" );
    // if ( desc )
    // {
    //     requestAnimationFrame( function( )
    //     {
    //         if ( answer.classList.contains( "we-onboarding-quiz-selected-answer" ) )
    //         {
    //             desc.style.maxHeight = "500px";
    //             desc.style.padding = "12px 16px";
    //             desc.style.transform = "translateX(0)";
    //             desc.style.opacity = "1";
    //         }
    //         else
    //         {
    //             desc.style.maxHeight = "0";
    //             desc.style.padding = "0 16px";
    //             desc.style.transform = "translateX(-15px)";
    //             desc.style.opacity = "0";
    //         }
    //     } );
    // }
    
    if ( answer.classList.contains( "we-onboarding-quiz-selected-answer" ) )
    {
        quiz.querySelector( ".we-onboarding-quiz-error-prompt" ).classList.add( "hidden" );
    }

    // show additional options if answer has been selected and has options
    var shouldShowOptions = false;
    var optionsData = null;
    var isStrictDiet = ( slide.key == "diets" ) && ( answer._answerData.text == "Vegan" || answer._answerData.text == "Vegetarian" );
    
    if ( answer.classList.contains( "we-onboarding-quiz-selected-answer" ) )
    {
        if ( answer._answerData.optionsQuestion != "" && answer._answerData.options.length > 0 )
        {
            if ( isStrictDiet )
            {
                answer._answerData.selectedOption = answer._answerData.options[ 0 ].value;
            }
            else
            {
                shouldShowOptions = true;
                optionsData = answer._answerData;
            }
        }
        else if ( !answer._answerData.none )
        {
            const allAnswers = answer.closest( ".we-onboarding-quiz-answers" ).querySelectorAll( ".we-onboarding-quiz-answer:not( [data-select-all] ):not( .we-onboarding-quiz-none-of-these )" );
            var answerWithOptions = null;
            for ( var i = 0; i < allAnswers.length; i++ )
            {
                if ( allAnswers[ i ]._answerData.optionsQuestion != "" && allAnswers[ i ]._answerData.options.length > 0 )
                {
                    answerWithOptions = allAnswers[ i ]._answerData;
                    break;
                }
            }
            
            if ( answerWithOptions )
            {
                if ( isStrictDiet )
                {
                    answer._answerData.selectedOption = answerWithOptions.options[ 0 ].value;
                }
                else
                {
                    shouldShowOptions = true;
                    optionsData = {
                        optionsQuestion: "How strictly do you follow " + answer._answerData.text + "?",
                        options: answerWithOptions.options
                    };
                }
            }
        }
    }
    
    if ( shouldShowOptions && optionsData )
    {
        ShowAnswerOptions( optionsData, answer );
    }
    else
    {
        SaveOnboardingQuizAnswers( );
    }

    if ( answersScrollContainer || quiz )
    {
        requestAnimationFrame( function( )
        {
            answer.scrollIntoView( { behavior: "smooth", block: "center" } );
            requestAnimationFrame( function( )
            {
                if ( answersScrollContainer )
                {
                    answersScrollContainer.scrollTop = savedAnswersScrollTop;
                }
                if ( quiz )
                {
                    quiz.scrollTop = savedQuizScrollTop;
                }
            } );
        } );
    }
}

function GetQuizProgress( currentIdx )
{
    var currentSlide = window._onboardingQuizData.slides[ currentIdx ];
    var slides       = window._onboardingQuizData.slides.filter( function IsMainQuestionSlide( slide )
    {
        return slide.slideType == "Question" && !slide._conditional;
    } );
    var i = 0;

    if ( slides.length > 0 )
    {
        for ( i = 0; i < slides.length; i++ )
        {
            if ( slides[ i ].key == currentSlide.key )
            {
                return {
                    currentQuestion: i + 1,
                    max: slides.length
                };
            }
        }

        if ( currentSlide._conditional )
        {
            for ( i = 0; i < slides.length; i++ )
            {
                if ( slides[ i ].key == currentSlide._parentKey )
                {
                    return {
                        currentQuestion: i + 1,
                        max: slides.length
                    };
                }
            }
        }
    }
    return null;
}

function ResetInterstitialProgressBar( )
{
    var inner = document.querySelector( ".we-onboarding-quiz-interstitial-progress-bar-inner" );
    var progress = document.querySelector( ".we-onboarding-quiz-progress" );
    var progressParent = progress ? progress.parentNode : null;

    if ( inner )
    {
        inner.style.transition = "none";
        inner.style.width      = "0%";
    }
    if ( progress )
    {
        progress.style.display = "";
    }
    if ( progressParent )
    {
        progressParent.style.display = "";
    }
}

function AnimateInterstitialProgressBar( durationMs )
{
    var inner = document.querySelector( ".we-onboarding-quiz-interstitial-progress-bar-inner" );
    var ms    = Number( durationMs || 0 );

    if ( inner )
    {
        if ( Number.isFinite( ms ) && ms > 0 )
        {
            inner.style.transition = "none";
            inner.style.width      = "0%";
            inner.offsetHeight;
            inner.style.transition = "width " + ms + "ms linear";
            inner.style.width      = "100%";
        }
        else
        {
            inner.style.transition = "none";
            inner.style.width      = "0%";
        }
    }
}

function WE_InfoInterstitial_FetchCarousel( carousel, collectionHandle )
{
    const track = carousel.querySelector( ".we-info-interstitial-carousel-track" );
    if ( !track ) { return; }

    track.innerHTML = '<div style="padding: 16px; text-align: center; color: #9ca3af; font-size: 13px;">Loading products...</div>';

    function WE_InfoInterstitial_CarouselResolve( r )
    {
        return r.json();
    }

    function WE_InfoInterstitial_CarouselReject()
    {
        track.innerHTML = "";
        carousel.style.display = "none";
    }

    function WE_InfoInterstitial_CarouselLoaded( data )
    {
        const products = data.products || [];

        if ( products.length > 0 )
        {
            var html = "";
            for ( var p = 0; p < products.length && p < 8; p++ )
            {
                const product = products[ p ];
                const variant = product.variants && product.variants.length > 0 ? product.variants[ 0 ] : null;
                const price = variant ? variant.price : "0";
                const compareAt = variant ? variant.compare_at_price : null;
                const imgSrc = product.images && product.images.length > 0 ? product.images[ 0 ].src : "";
                var discount = 0;
                if ( compareAt && parseFloat( compareAt ) > parseFloat( price ) )
                {
                    discount = Math.round( ( ( parseFloat( compareAt ) - parseFloat( price ) ) / parseFloat( compareAt ) ) * 100 );
                }

                html += '<div class="we-info-interstitial-product-card">';
                html += '<div class="we-info-interstitial-product-image-wrap">';
                if ( imgSrc )
                {
                    html += '<img class="we-info-interstitial-product-image" src="' + imgSrc + '" alt="' + ( product.title || "" ) + '" loading="lazy" width="130" height="130">';
                }
                if ( discount > 0 )
                {
                    html += '<span class="we-info-interstitial-product-badge">-' + discount + '%</span>';
                }
                html += '</div>';
                html += '<div class="we-info-interstitial-product-name">' + ( product.title || "" ) + '</div>';
                html += '<div class="we-info-interstitial-product-price">£' + parseFloat( price ).toFixed( 2 );
                if ( compareAt && parseFloat( compareAt ) > parseFloat( price ) )
                {
                    html += '<span class="we-info-interstitial-product-compare">£' + parseFloat( compareAt ).toFixed( 2 ) + '</span>';
                }
                html += '</div>';
                html += '</div>';
            }

            track.innerHTML = html + html;
        }
        else
        {
            carousel.style.display = "none";
        }
    }

    fetch( "/collections/" + collectionHandle + "/products.json?limit=8" )
        .then( WE_InfoInterstitial_CarouselResolve )
        .then( WE_InfoInterstitial_CarouselLoaded )
        .catch( WE_InfoInterstitial_CarouselReject );
}

function WE_InfoInterstitial_HandleAccordionClick( e )
{
    const trigger = e.currentTarget;
    const item = trigger.closest( ".we-info-interstitial-accordion-item" );
    if ( item )
    {
        const isOpen = item.classList.contains( "is-open" );
        const allItems = item.parentNode.querySelectorAll( ".we-info-interstitial-accordion-item" );
        for ( var a = 0; a < allItems.length; a++ )
        {
            allItems[ a ].classList.remove( "is-open" );
        }
        if ( !isOpen )
        {
            item.classList.add( "is-open" );
        }
    }
}

function UpdateStepIcon( step, state )
{
    var iconContainer = step.querySelector( ".we-onboarding-quiz-results-loading-step-icon" );
    var circleIcon    = null;
    var sparkleIcon   = null;
    var checkIcon     = null;

    if ( iconContainer )
    {
        circleIcon  = iconContainer.querySelector( ".we-onboarding-quiz-results-loading-step-icon-circle" );
        sparkleIcon  = iconContainer.querySelector( ".we-onboarding-quiz-results-loading-step-icon-sparkle" );
        checkIcon    = iconContainer.querySelector( ".we-onboarding-quiz-results-loading-step-icon-check" );

    if ( state == "pending" )
    {
        if ( circleIcon )
        {
            circleIcon.style.display = "block";
        }
        if ( sparkleIcon )
        {
            sparkleIcon.style.display = "none";
        }
        if ( checkIcon )
        {
            checkIcon.style.display = "none";
        }
    }
    else if ( state == "active" )
    {
        if ( circleIcon )
        {
            circleIcon.style.display = "none";
        }
        if ( sparkleIcon )
        {
            sparkleIcon.style.display = "block";
        }
        if ( checkIcon )
        {
            checkIcon.style.display = "none";
        }
    }
    else if ( state == "completed" )
    {
        if ( circleIcon )
        {
            circleIcon.style.display = "none";
        }
        if ( sparkleIcon )
        {
            sparkleIcon.style.display = "none";
        }
        if ( checkIcon )
        {
            checkIcon.style.display = "block";
        }
    }
    }
}

function AnimateResultsLoadingProgress( slideData )
{
    var progressBar = document.querySelector( ".we-onboarding-quiz-results-loading-progress-bar-inner" );
    var progressCart = document.querySelector( ".we-onboarding-quiz-results-loading-progress-cart" );
    var steps = document.querySelectorAll( ".we-onboarding-quiz-results-loading-step" );
    var completionEl = document.querySelector( ".we-onboarding-quiz-results-loading-progress-amount" );

    if ( progressBar && progressCart && steps && steps.length >= 4 )
    {
        function InitializeLoadingStep( step )
        {
            step.classList.remove( "we-onboarding-quiz-results-loading-step--completed", "we-onboarding-quiz-results-loading-step--active", "we-onboarding-quiz-results-loading-step--pending" );
            step.classList.add( "we-onboarding-quiz-results-loading-step--pending" );
            UpdateStepIcon( step, "pending" );
        }

        steps.forEach( InitializeLoadingStep );

        progressBar.style.transition = "none";
        progressBar.style.width = "0%";
        progressCart.style.transition = "none";
        progressCart.style.left = "0%";

        progressBar.offsetHeight;

        var totalDuration = slideData.autoadvanceTime || 8000;
        var stepDuration = totalDuration / 4;

        progressBar.style.transition = "width " + totalDuration + "ms linear";
        progressBar.style.width = "100%";
        progressCart.style.transition = "left " + totalDuration + "ms linear";
        progressCart.style.left = "100%";

        function ActivateStepZero( )
        {
            steps[ 0 ].classList.remove( "we-onboarding-quiz-results-loading-step--pending" );
            steps[ 0 ].classList.add( "we-onboarding-quiz-results-loading-step--active" );
            UpdateStepIcon( steps[ 0 ], "active" );
        }

        function CompleteStepAndActivateNext( completedIdx, activateIdx )
        {
            steps[ completedIdx ].classList.remove( "we-onboarding-quiz-results-loading-step--active" );
            steps[ completedIdx ].classList.add( "we-onboarding-quiz-results-loading-step--completed" );
            UpdateStepIcon( steps[ completedIdx ], "completed" );

            steps[ activateIdx ].classList.remove( "we-onboarding-quiz-results-loading-step--pending" );
            steps[ activateIdx ].classList.add( "we-onboarding-quiz-results-loading-step--active" );
            UpdateStepIcon( steps[ activateIdx ], "active" );
        }

        function CompleteLastStep( )
        {
            steps[ 3 ].classList.remove( "we-onboarding-quiz-results-loading-step--active" );
            steps[ 3 ].classList.add( "we-onboarding-quiz-results-loading-step--completed" );
            UpdateStepIcon( steps[ 3 ], "completed" );
        }

        function WE_OnResultsLoadingTimerAnimationEnd( e )
        {
            var target = e.currentTarget;
            var tickType = target.getAttribute( "data-we-results-loading-tick" ) || "";

            if ( tickType == "t1" )
            {
                CompleteStepAndActivateNext( 0, 1 );
                if ( completionEl )
                {
                    completionEl.innerText = 25;
                }
            }
            else if ( tickType == "t2" )
            {
                CompleteStepAndActivateNext( 1, 2 );
                if ( completionEl )
                {
                    completionEl.innerText = 50;
                }
            }
            else if ( tickType == "t3" )
            {
                CompleteStepAndActivateNext( 2, 3 );
                if ( completionEl )
                {
                    completionEl.innerText = 75;
                }
            }
            else if ( tickType == "t4" )
            {
                CompleteLastStep( );
                if ( completionEl )
                {
                    completionEl.innerText = 100;
                }
            }

            if ( target && target.parentNode )
            {
                target.parentNode.removeChild( target );
            }
        }

        ActivateStepZero( );

        var loadingEl = progressBar.closest( ".we-onboarding-quiz-results-loading" ) || progressBar;
        if ( completionEl )
        {
            completionEl.innerText = 0;
        }

        function CreateLoadingTimerElement( tickType, delayMs )
        {
            var el = document.createElement( "div" );
            el.setAttribute( "class", "we-onboarding-quiz-results-loading-step-timer" );
            el.setAttribute( "data-we-results-loading-tick", tickType );
            el.style.animation = "we-onboarding-quiz-results-loading-tick 1ms linear both";
            el.style.animationDelay = delayMs + "ms";
            el.addEventListener( "animationend", WE_OnResultsLoadingTimerAnimationEnd );
            loadingEl.appendChild( el );
        }

        CreateLoadingTimerElement( "t1", stepDuration );
        CreateLoadingTimerElement( "t2", stepDuration * 2 );
        CreateLoadingTimerElement( "t3", stepDuration * 3 );
        CreateLoadingTimerElement( "t4", totalDuration );
    }
}

function UpdateProgressBarState( activeStepIndex )
{
    const progressBars = document.querySelectorAll( ".we-onboarding-quiz-results-progress-bar" );
    
    function ProcessProgressBar( progressBar )
    {
        const steps = progressBar.querySelectorAll( ".we-onboarding-quiz-results-progress-step" );
        const filledLine = progressBar.querySelector( ".we-onboarding-quiz-results-progress-line-filled" );
        
        if ( steps && steps.length >= 3 )
        {
        function ProcessStep( step, index )
        {
            step.classList.remove( "we-onboarding-quiz-results-progress-step--completed", "we-onboarding-quiz-results-progress-step--active" );
            
            const circle = step.querySelector( ".we-onboarding-quiz-results-progress-step-circle" );
            const box = step.querySelector( ".we-onboarding-quiz-results-progress-step-box" );
            const sparkle = step.querySelector( ".we-onboarding-quiz-results-progress-step-sparkle" );
            const label = step.querySelector( ".we-onboarding-quiz-results-progress-step-label" );
            
            if ( index < activeStepIndex )
            {
                step.classList.add( "we-onboarding-quiz-results-progress-step--completed" );
                if ( circle )
                {
                    circle.classList.remove( "we-onboarding-quiz-results-progress-step-circle--pending" );
                    circle.style.display = "block";
                }
                if ( box )
                {
                    box.style.display = "none";
                }
                if ( sparkle )
                {
                    sparkle.style.display = "none";
                }
                if ( label )
                {
                    label.classList.remove( "we-onboarding-quiz-results-progress-step-label--pending" );
                }
            }
            else if ( index == activeStepIndex )
            {
                step.classList.add( "we-onboarding-quiz-results-progress-step--active" );
                if ( index == 1 )
                {
                    if ( box )
                    {
                        box.style.display = "block";
                    }
                    if ( sparkle )
                    {
                        sparkle.style.display = "block";
                    }
                    if ( circle )
                    {
                        if ( box )
                        {
                            circle.style.display = "none";
                        }
                        else
                        {
                            circle.classList.remove( "we-onboarding-quiz-results-progress-step-circle--pending" );
                            circle.style.display = "block";
                        }
                    }
                }
                else
                {
                    if ( circle )
                    {
                        circle.classList.remove( "we-onboarding-quiz-results-progress-step-circle--pending" );
                        circle.style.display = "block";
                    }
                    if ( box )
                    {
                        box.style.display = "none";
                    }
                    if ( sparkle )
                    {
                        sparkle.style.display = "none";
                    }
                }
                if ( label )
                {
                    label.classList.remove( "we-onboarding-quiz-results-progress-step-label--pending" );
                }
            }
            else
            {
                if ( circle )
                {
                    circle.classList.add( "we-onboarding-quiz-results-progress-step-circle--pending" );
                    circle.style.display = "block";
                }
                if ( box )
                {
                    box.style.display = "none";
                }
                if ( sparkle )
                {
                    sparkle.style.display = "none";
                }
                if ( label )
                {
                    label.classList.add( "we-onboarding-quiz-results-progress-step-label--pending" );
                }
            }
        }
        
        steps.forEach( ProcessStep );
        
        if ( filledLine )
        {
            const widthPercent = ( activeStepIndex / 2 ) * 100;
            filledLine.style.width = widthPercent + "%";
        }
        }
    }
    
    progressBars.forEach( ProcessProgressBar );
}


function EnsureQuizCloseButton( quiz )
{
    if ( !quiz )
    {
        return;
    }

    var closeBtn = quiz.querySelector( ".we-onboarding-quiz-close" );
    if ( closeBtn == null )
    {
        closeBtn = document.createElement( "button" );
        closeBtn.setAttribute( "type", "button" );
        closeBtn.setAttribute( "class", "we-onboarding-quiz-close" );
        closeBtn.setAttribute( "aria-label", "Exit quiz" );
        closeBtn.textContent = "×";
        quiz.appendChild( closeBtn );
    }

    if ( closeBtn._weBound != true )
    {
        closeBtn.addEventListener( "click", function( )
        {
            var redirectTarget = "/pages/lightning-my-aisle";
            var quizData = window._onboardingQuizData || {};
            if ( typeof( quizData.homeLink ) == "string" && quizData.homeLink.length > 0 )
            {
                redirectTarget = quizData.homeLink;
            }
            else if ( typeof( quizData.homelink ) == "string" && quizData.homelink.length > 0 )
            {
                redirectTarget = quizData.homelink;
            }

            try
            {
                WE_QuizTracking_Push( "quiz_exit", { exit_reason: "close_button" } );
            }
            catch ( e )
            {
            }
            window.location.href = redirectTarget;
        } );
        closeBtn._weBound = true;
    }
}

function ResetQuizSlideScroll( quiz )
{
    var answers = quiz.querySelector( ".we-onboarding-quiz-answers" );
    var slide = quiz.querySelector( ".we-onboarding-quiz-slide" );

    if ( answers )
    {
        answers.scrollTop = 0;
    }

    if ( slide )
    {
        slide.scrollTop = 0;
    }

    quiz.scrollTop = 0;
    window.scrollTo( 0, 0 );
}

function WE_QuizResults_SendQuizTakenTag( onComplete )
{
    const auth = window._onboardingQuizData.auth;

    if ( auth )
    {
        const payload =
        {
            "auth"    : auth,
            "addTags" : [ "quiz_taken" ]
        };

        OQ_SendAPIRequest( window._onboardingQuizAPIRoot + "/set-custom-data", "POST", payload, onComplete );
    }
    else
    {
        onComplete( new Error( "Customer authentication is missing" ) );
    }
}

function WE_QuizResults_RevealCart( button, onComplete, onError )
{
    function OnQuizTakenTagSaved( err )
    {
        if ( err )
        {
            onError( err );
        }
        else
        {
            WE_QuizResults_AddActiveToCart( button, true ).then( onComplete ).catch( onError );
        }
    }

    WE_QuizResults_SendQuizTakenTag( OnQuizTakenTagSaved );
}

function ShowSlide( idx, firstLoad )
{
    var skipRegisterRedirect = false;
    try { skipRegisterRedirect = ( sessionStorage.getItem( "cta_quiz_show_results" ) == "1" ); } catch ( e ) {}
    if ( skipRegisterRedirect )
    {
        try { sessionStorage.removeItem( "cta_quiz_show_results" ); } catch ( e ) {}
    }

    var slideData = window._onboardingQuizData.slides[ idx ];
    var quiz      = document.querySelector( ".we-onboarding-quiz" );

    // Remove gift slide class when navigating away
    document.body.classList.remove( "on-gift-slide" );

    var freeGift = quiz.querySelector( ".we-onboarding-quiz-free-gift" );
    if ( freeGift )
    {
        freeGift.classList.add( "hidden" );
    }

    var freeGiftPopup = quiz.querySelector( ".we-onboarding-quiz-free-gift-popup" );
    if ( freeGiftPopup )
    {
        freeGiftPopup.classList.add( "hidden" );
    }

    if ( slideData && window._onboardingQuizData && window._onboardingQuizData.createAccountSlide == slideData.position && slideData.key != "brands" && !skipRegisterRedirect && !sessionStorage.getItem( "quiz_logged_in_skip_register" ) )
    {
        // Store current slide position for back navigation
        try { sessionStorage.setItem( "we_last_quiz_slide_position", slideData.position ); } catch ( e ) {}

        var isInveterate = window._onboardingQuizData.customerTags &&
            window._onboardingQuizData.customerTags.includes( "inveterate-subscriber" );

        if ( isInveterate )
        {
            try { sessionStorage.setItem( "quiz_logged_in_skip_register", "1" ); } catch ( e ) {}
            window.location.href = "/pages/welleasy-quiz?slide=16";
        }
        else
        {
            ShowFreeGiftSlide();
            return;
        }
    }
    var answers            = null;
    var data               = null;
    var quizProgress       = null;
    var quizProgressEl     = null;
    var quizProgressInner  = null;
    var interstitialBodyEl = null;

    if ( slideData && slideData.slideType == "Welcome" )
    {
        WE_QuizTracking_ResetAttemptState( );
        try { sessionStorage.removeItem( "we_quiz_added_to_cart" ); } catch ( e ) {}
    }

    WE_QuizTracking_HandleSlideView( idx, slideData );

    if ( quiz && slideData )
    {
    EnsureQuizCloseButton( quiz );
    answers            = quiz.querySelector( ".we-onboarding-quiz-answers" );
    data               = GetQuizState( );
    quizProgress       = GetQuizProgress( idx );
    quizProgressEl     = quiz.querySelector( ".we-onboarding-quiz-progress" );
    quizProgressInner  = quiz.querySelector( ".we-onboarding-quiz-progressbar-inner" );
    interstitialBodyEl = quiz.querySelector( ".we-onboarding-quiz-interstitial-body" );

    var _allInfoPanels = quiz.querySelectorAll( ".we-onboarding-quiz-info-interstitial" );
    for ( var _ip = 0; _ip < _allInfoPanels.length; _ip++ )
    {
        _allInfoPanels[ _ip ].classList.add( "hidden" );
    }

    if ( answers )
    {
        while ( answers.firstChild )
        {
            answers.firstChild.remove( );
        }
    }

    if ( slideData.slideType == "Question" )
    {
        if ( slideData.answerType == "Multiple" )
        {
            quiz.querySelector( ".we-onboarding-quiz-question-type-prompt" ).classList.remove( "hidden" );
        }
        else
        {
            quiz.querySelector( ".we-onboarding-quiz-question-type-prompt" ).classList.add( "hidden" );
        }
        
        if ( slideData.answers && slideData.answers.length > 0 )
        {
            var stackedPositions = [2, 4];
            var currentPos = parseInt( slideData.position, 10 );
            if ( stackedPositions.indexOf( currentPos ) !== -1 )
            {
                answers.classList.add( "we-onboarding-quiz-stacked-answers" );
                answers.classList.remove( "we-onboarding-quiz-grid-answers" );
            }
            else
            {
                answers.classList.remove( "we-onboarding-quiz-stacked-answers" );
                answers.classList.add( "we-onboarding-quiz-grid-answers" );
            }
        }
        else
        {
            answers.classList.add( "we-onboarding-quiz-stacked-answers" );
            answers.classList.remove( "we-onboarding-quiz-grid-answers" )
        }
    }

    var firstSlidePosition = window._onboardingQuizData.slides.length > 0 ? 
        parseInt( window._onboardingQuizData.slides[ 0 ].position, 10 ) : null;
    var currentSlidePosition = parseInt( slideData.position, 10 );
    
    var prevBtns = quiz.querySelectorAll( ".we-onboarding-quiz-prev" );
    if ( !isNaN( firstSlidePosition ) && !isNaN( currentSlidePosition ) && 
         currentSlidePosition == firstSlidePosition )
    {
        prevBtns.forEach( function addDisabledToPrevBtn( btn )
        {
            btn.classList.add( "disabled" );
        } );
    }
    else
    {
        prevBtns.forEach( function removeDisabledFromPrevBtn( btn )
        {
            btn.classList.remove( "disabled" );
        } );
    }

    quiz.setAttribute( "data-idx", idx );
    
    var interstitialBody = slideData.interstitialBody;
    
    if ( slideData.slideType == "Interstitial" && slideData.interstitialBody != "" )
    {
        interstitialBody = QUIZ_DOMPARSER.parseFromString( interstitialBody, "text/html" );
        var metafieldEl              = interstitialBody.body.querySelector( ".metafield-rich_text_field" );
        if ( metafieldEl )
        {
            interstitialBodyEl.innerHTML = metafieldEl.innerHTML;
        }
    }
    
    Specialise( quiz, slideData );
    
    if ( slideData.slideType == "CustomPicked" && slideData.interstitialBody != "" )
    {
        var customPickedSubtitle = quiz.querySelector( ".we-onboarding-quiz-custom-picked-subtitle" );
        if ( customPickedSubtitle )
        {
            interstitialBody = QUIZ_DOMPARSER.parseFromString( slideData.interstitialBody, "text/html" );
            var metafieldEl              = interstitialBody.body.querySelector( ".metafield-rich_text_field" );
            if ( metafieldEl )
            {
                customPickedSubtitle.innerHTML = metafieldEl.innerHTML;
            }
            else
            {
                customPickedSubtitle.textContent = slideData.interstitialBody.replace( /<[^>]*>/g, "" );
            }
        }
    }

    if ( quizProgress )
    {
        quizProgressEl.innerHTML = quizProgress.currentQuestion + " of " + quizProgress.max;
        quizProgressInner.setAttribute( "style", "width: " + ( quizProgress.currentQuestion / quizProgress.max * 100 ) + "%" )
    }

    if ( slideData.slideType == "Welcome" )
    {
        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.add( "hidden" );
        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function addHiddenToContainer( container )
        {
            container.classList.add( "hidden" );
        } );
        
        const welcomeBodyEl = quiz.querySelector( ".we-onboarding-quiz-welcome-body" );
        if ( welcomeBodyEl )
        {
            welcomeBodyEl.style.display = "block";
        }
        
        const discoverBtn = quiz.querySelector( ".we-onboarding-quiz-welcome-discover" );
        const skipBtn = quiz.querySelector( ".we-onboarding-quiz-welcome-skip" );
        
        if ( discoverBtn )
        {
            discoverBtn.onclick = function onWelcomeDiscoverClick( )
            {
                var state = WE_QuizTracking_GetState( );

                WE_QuizTracking_Push( "quiz_start" );
                state.started = true;
                WE_QuizTracking_SaveState( state );

                window.localStorage.removeItem( SAVE_EXIT_STORAGE_KEY );
                NextOnboardingSlide();
            };
        }
        
        if ( skipBtn )
        {
            skipBtn.onclick = function onWelcomeSkipClick( )
            {
                window.location.href = "/";
            };
        }
    }
    else if ( slideData.slideType == "Question" )
    {
        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.remove( "hidden" );
        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function removeHiddenFromContainer( container )
        {
            container.classList.remove( "hidden" );
        } );
        answers.classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-save-exit" ).classList.remove( "hidden" );

        ResetInterstitialProgressBar( );
    }
    else if ( slideData.slideType == "CustomCreating" )
    {
        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.add( "hidden" );
        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function addHiddenToContainer( container )
        {
            container.classList.add( "hidden" );
        } );

        if ( idx == 20 )
        {
            UpdateProgressBarState( 2 );
            const customCreatingTitle = quiz.querySelector( ".we-onboarding-quiz-custom-creating-title" );
            const customCreatingDots = quiz.querySelector( ".we-onboarding-quiz-custom-creating-dots" );
            const customCreatingSubtitle = quiz.querySelector( ".we-onboarding-quiz-custom-creating-subtitle" );
            
            if ( customCreatingTitle )
            {
                customCreatingTitle.textContent = "We've found 100+ products we think you'll love";
            }
            
            if ( customCreatingDots )
            {
                customCreatingDots.style.display = "none";
            }
            
            if ( !customCreatingSubtitle )
            {
                const subtitle = document.createElement( "p" );
                subtitle.className = "we-onboarding-quiz-custom-creating-subtitle";
                subtitle.textContent = "Feel free to add them into your order too";
                if ( customCreatingTitle && customCreatingTitle.parentNode )
                {
                    customCreatingTitle.parentNode.insertBefore( subtitle, customCreatingTitle.nextSibling );
                }
            }
            else
            {
                customCreatingSubtitle.textContent = "Feel free to add them into your order too";
                customCreatingSubtitle.style.display = "block";
            }
        }
        else
        {
            UpdateProgressBarState( 1 );
            const customCreatingDots = quiz.querySelector( ".we-onboarding-quiz-custom-creating-dots" );
            const customCreatingSubtitle = quiz.querySelector( ".we-onboarding-quiz-custom-creating-subtitle" );
            
            if ( customCreatingDots )
            {
                customCreatingDots.style.display = "flex";
            }
            
            if ( customCreatingSubtitle )
            {
                customCreatingSubtitle.style.display = "none";
            }
        }

        if ( slideData.interstitialBody != "" )
        {
            var bodyEl           = quiz.querySelector( ".we-onboarding-quiz-custom-creating-body" );
            var interstitialBody = slideData.interstitialBody;
            interstitialBody     = QUIZ_DOMPARSER.parseFromString( interstitialBody, "text/html" );
            var metafieldEl      = interstitialBody.body.querySelector( ".metafield-rich_text_field" );
            if ( metafieldEl )
            {
                bodyEl.innerHTML = metafieldEl.innerHTML;
            }
        }
        else
        {
            var bodyEl       = quiz.querySelector( ".we-onboarding-quiz-custom-creating-body" );
            bodyEl.innerHTML = "";
        }

        AnimateInterstitialProgressBar( slideData.autoadvanceTime );
    }
    else if ( slideData.slideType == "CustomPicked" )
    {
        var productsElPicked = null;
        var didRestorePicked = false;

        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.add( "hidden" );
        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function addHiddenToContainer( container )
        {
            container.classList.add( "hidden" );
        } );

        productsElPicked = quiz.querySelector( ".we-onboarding-quiz-results-products" );
        if ( productsElPicked )
        {
            // mw 20260322 : remove DOM cache, it was supposed to be a network cache
            //didRestorePicked = WE_QuizResults_RestoreProductsDomCache( productsElPicked );

            if ( didRestorePicked )
            {
                WE_QuizResults_LoadWidget( productsElPicked );
            }
            else if ( !productsElPicked.querySelector( ".enhanced-commerce-widget" ) )
            {
                WE_QuizResults_ScheduleResultsWidget( productsElPicked, 0 );
            }
        }

        WE_QuizResults_PopulatePlaceholderImages( );

        AnimateInterstitialProgressBar( slideData.autoadvanceTime );
    }
    else if ( slideData.slideType == "ResultsLoading" )
    {
        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.add( "hidden" );
        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function addHiddenToContainer( container )
        {
            container.classList.add( "hidden" );
        } );

        // Start loading products early during ResultsLoading slide
        var productsElEarly = quiz.querySelector( ".we-onboarding-quiz-results-products" );
        if ( productsElEarly && !productsElEarly.querySelector( ".enhanced-commerce-widget" ) )
        {
            WE_QuizResults_ScheduleResultsWidget( productsElEarly, 0 );
        }

        var loadingEl = quiz.querySelector( ".we-onboarding-quiz-results-loading" );
        var revealEl = loadingEl.querySelector( ".we-onboarding-quiz-results-loading-reveal" );
        var revealButton = revealEl.querySelector( ".we-onboarding-quiz-results-loading-reveal-button" );
        var tagsContainer = revealEl.querySelector( ".we-onboarding-quiz-results-loading-reveal-tags" );

        function WE_OnboardingQuizResultsLoading_ShowReveal()
        {
            loadingEl.classList.add( "we-onboarding-quiz-results-loading--reveal" );

            // Keep reveal disabled until the primary quiz recommendations are ready.
            revealButton.disabled = true;
            revealButton.textContent = "Loading products...";

            var productsEl = quiz.querySelector( ".we-onboarding-quiz-results-products" );

            WE_Reveal_BindPrimaryReady( revealButton, productsEl );
            WE_Reveal_UpdateForPrimary( revealButton, productsEl );

            revealButton.addEventListener( "click", function WE_OnboardingQuizResultsLoading_HandleRevealClick()
            {
                if ( revealButton._weQuizAdding ) { return; }
                if ( WE_QuizResults_IsPrimaryReady( productsEl ) == false )
                {
                    WE_Reveal_UpdateForPrimary( revealButton, productsEl );
                    return;
                }
                // Always reconcile the current picks with the live cart. A previous
                // reveal may predate these primary results.
                revealButton._weQuizAdding = true;

                // Flag for cart back button to return to reveal picks
                try { localStorage.setItem( "we_reached_reveal_picks", Date.now().toString() ); } catch ( e ) {}

                // Seal completed quiz: no back path may route into gift or stale flow again.
                try { sessionStorage.removeItem( "we_last_quiz_page" ); } catch ( e ) {}
                try { sessionStorage.removeItem( "we_last_quiz_slide_position" ); } catch ( e ) {}
                try { sessionStorage.removeItem( "we_register_flow" ); } catch ( e ) {}

                // Stamp the cart note so the order carries quiz_taken for Flow.
                // Fire-and-forget: never blocks add-to-cart or redirect.
                fetch( "/cart.js", { headers: { "Accept": "application/json" } } )
                .then( function QuizTakenNote_Read( response ) { return response.json( ); } )
                .then( function QuizTakenNote_Write( cart )
                {
                    var note = ( cart && cart.note ) || "";
                    if ( note.indexOf( "quiz_taken" ) == -1 )
                    {
                        note = ( note != "" ? note + " " : "" ) + "quiz_taken";
                        fetch( "/cart/update.js", {
                            method: "POST",
                            headers: { "Content-Type": "application/json", "Accept": "application/json" },
                            body: JSON.stringify( { note: note } )
                        } ).catch( function QuizTakenNoteWrite_Error( ) { } );
                    }
                } ).catch( function QuizTakenNote_Error( ) { } );

                var addCartLoading = quiz.querySelector( ".we-onboarding-quiz-add-cart-loading" );
                var addCartFill = addCartLoading ? addCartLoading.querySelector( ".we-onboarding-quiz-add-cart-loading-progress-fill" ) : null;
                var addCartCart = addCartLoading ? addCartLoading.querySelector( ".we-onboarding-quiz-add-cart-loading-progress-cart" ) : null;
                var addCartPct = addCartLoading ? addCartLoading.querySelector( ".we-onboarding-quiz-add-cart-loading-percent" ) : null;
                var addCartSteps = addCartLoading ? addCartLoading.querySelectorAll( ".we-onboarding-quiz-add-cart-loading-step" ) : [];

                if ( addCartLoading )
                {
                    addCartLoading.classList.remove( "hidden" );
                    addCartLoading.classList.remove( "we-onboarding-quiz-add-cart-loading--done" );
                }

                var progress = 0;
                var currentStep = -1;
                var finished = false;
                var atcDone = false;
                var lastTime = performance.now();

                if ( addCartSteps[ 0 ] ) addCartSteps[ 0 ].classList.add( "we-onboarding-quiz-add-cart-loading-step--active" );
                currentStep = 0;

                function UpdateProgress( now )
                {
                    if ( finished ) return;

                    var dt = ( now - lastTime ) / 1000;
                    lastTime = now;

                    var speedPerSec = atcDone ? 30 : 18;
                    progress = Math.min( progress + speedPerSec * dt, 95 );

                    if ( addCartFill ) addCartFill.style.width = progress + "%";
                    if ( addCartCart ) addCartCart.style.left = progress + "%";
                    if ( addCartPct ) addCartPct.textContent = Math.round( progress ) + "% complete";

                    if ( currentStep == 0 && progress >= 33 )
                    {
                        addCartSteps[ 0 ].classList.remove( "we-onboarding-quiz-add-cart-loading-step--active" );
                        addCartSteps[ 0 ].classList.add( "we-onboarding-quiz-add-cart-loading-step--done" );
                        currentStep = 1;
                        if ( addCartSteps[ 1 ] ) addCartSteps[ 1 ].classList.add( "we-onboarding-quiz-add-cart-loading-step--active" );
                    }
                    else if ( currentStep == 1 && progress >= 66 )
                    {
                        addCartSteps[ 1 ].classList.remove( "we-onboarding-quiz-add-cart-loading-step--active" );
                        addCartSteps[ 1 ].classList.add( "we-onboarding-quiz-add-cart-loading-step--done" );
                        currentStep = 2;
                        if ( addCartSteps[ 2 ] ) addCartSteps[ 2 ].classList.add( "we-onboarding-quiz-add-cart-loading-step--active" );
                    }

                    if ( progress >= 95 && !finished )
                    {
                        for ( var si = 0; si < addCartSteps.length; si++ )
                        {
                            addCartSteps[ si ].classList.remove( "we-onboarding-quiz-add-cart-loading-step--active" );
                            addCartSteps[ si ].classList.add( "we-onboarding-quiz-add-cart-loading-step--done" );
                        }
                        if ( addCartPct )
                        {
                            addCartPct.textContent = "Finalizing";
                            addCartPct.classList.add( "we-onboarding-quiz-add-cart-loading-percent--typing" );
                        }
                        if ( addCartLoading ) addCartLoading.classList.add( "we-onboarding-quiz-add-cart-loading--done" );
                        return;
                    }

                    requestAnimationFrame( UpdateProgress );
                }

                requestAnimationFrame( UpdateProgress );

                function AddToCart_Done( addedCount )
                {
                    atcDone = true;
                    finished = true;

                    if ( addCartFill )
                    {
                        addCartFill.style.width = "100%";
                    }
                    if ( addCartCart )
                    {
                        addCartCart.style.left = "100%";
                    }

                    if ( addCartLoading )
                    {
                        addCartLoading.classList.add( "we-onboarding-quiz-add-cart-loading--done" );
                    }

                    if ( addCartPct )
                    {
                        addCartPct.textContent = "100% complete";
                        addCartPct.classList.remove( "we-onboarding-quiz-add-cart-loading-percent--typing" );
                    }

                    for ( var si = 0; si < addCartSteps.length; si++ )
                    {
                        addCartSteps[ si ].classList.remove( "we-onboarding-quiz-add-cart-loading-step--active" );
                        addCartSteps[ si ].classList.add( "we-onboarding-quiz-add-cart-loading-step--done" );
                    }

                    if ( addedCount > 0 )
                    {
                        try { window.sessionStorage.setItem( "we_quiz_added_to_cart", "1" ); } catch ( e ) {}
                        revealButton._weQuizAdding = false;
                        const cartRedirectSlide = { slideType: "CartRedirect", position: 100 };
                        window._onboardingQuizData.slides.push( cartRedirectSlide );
                        const slideIndex = window._onboardingQuizData.slides.length - 1;
                        ShowSlide( slideIndex, false );
                    }
                    else
                    {
                        if ( addCartLoading )
                        {
                            addCartLoading.classList.add( "hidden" );
                        }
                        revealButton.disabled = false;
                        revealButton._weQuizAdding = false;
                        revealButton.textContent = "Reveal my picks";
                    }
                }

                function AddToCart_Error( err )
                {
                    console.error( "Quiz reveal failed:", err );
                    finished = true;
                    if ( addCartLoading )
                    {
                        addCartLoading.classList.add( "hidden" );
                        addCartLoading.classList.remove( "we-onboarding-quiz-add-cart-loading--done" );
                    }
                    revealButton.disabled = false;
                    revealButton._weQuizAdding = false;
                    revealButton.textContent = "Reveal my picks";
                }

                WE_QuizResults_RevealCart( revealButton, AddToCart_Done, AddToCart_Error );
            } );
        }

        function WE_QuizResults_AnimateAddCartLoading( container )
        {
            var steps = container.querySelectorAll( ".we-onboarding-quiz-add-cart-loading-step" );
            var fill  = container.querySelector( ".we-onboarding-quiz-add-cart-loading-progress-fill" );
            var cart  = container.querySelector( ".we-onboarding-quiz-add-cart-loading-progress-cart" );
            var pct   = container.querySelector( ".we-onboarding-quiz-add-cart-loading-percent" );
            var progress = 0;
            var target = 90;
            var currentStep = -1;
            var tickCount = 0;

            function UpdateProgress()
            {
                tickCount += 1;
                if ( tickCount % 6 == 0 && progress < target )
                {
                    progress += 1;
                    if ( fill ) fill.style.width = progress + "%";
                    if ( cart ) cart.style.left = progress + "%";
                    if ( pct ) pct.textContent = progress + "% complete";
                }

                var stepThreshold1 = Math.round( target * 0.33 );
                var stepThreshold2 = Math.round( target * 0.66 );

                if ( currentStep < 0 && progress >= 1 )
                {
                    currentStep = 0;
                    if ( steps[ 0 ] ) steps[ 0 ].classList.add( "we-onboarding-quiz-add-cart-loading-step--active" );
                }
                else if ( currentStep == 0 && progress >= stepThreshold1 )
                {
                    steps[ 0 ].classList.remove( "we-onboarding-quiz-add-cart-loading-step--active" );
                    steps[ 0 ].classList.add( "we-onboarding-quiz-add-cart-loading-step--done" );
                    currentStep = 1;
                    if ( steps[ 1 ] ) steps[ 1 ].classList.add( "we-onboarding-quiz-add-cart-loading-step--active" );
                }
                else if ( currentStep == 1 && progress >= stepThreshold2 )
                {
                    steps[ 1 ].classList.remove( "we-onboarding-quiz-add-cart-loading-step--active" );
                    steps[ 1 ].classList.add( "we-onboarding-quiz-add-cart-loading-step--done" );
                    currentStep = 2;
                    if ( steps[ 2 ] ) steps[ 2 ].classList.add( "we-onboarding-quiz-add-cart-loading-step--active" );
                }

                if ( progress < target )
                {
                    requestAnimationFrame( UpdateProgress );
                }
            }

            requestAnimationFrame( UpdateProgress );
        }

        function WE_OnboardingQuizResultsLoading_PopulateTags()
        {
            if ( !tagsContainer )
            {
                return;
            }

            tagsContainer.innerHTML = "";
            var quizState = GetQuizState( );
            var slides = window._onboardingQuizData && window._onboardingQuizData.slides ? window._onboardingQuizData.slides : [];
            var csKeyMap = window._onboardingQuizData && window._onboardingQuizData._csKeyMap ? window._onboardingQuizData._csKeyMap : {};
            var starSvg = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L14.09 8.26L20 9.27L15.55 13.97L16.91 20L12 16.9L7.09 20L8.45 13.97L4 9.27L9.91 8.26L12 2Z" fill="currentColor"/></svg>';
            var maxVisible = 4;
            var tagCount = 0;

            var key;
            for ( key in quizState )
            {
                if ( quizState.hasOwnProperty( key ) && quizState[ key ] && quizState[ key ].length > 0 )
                {
                    var isSubSlide = csKeyMap.hasOwnProperty( key );
                    var isBrandSlide = key == "brands";
                    var isPeopleCountSlide = key == "peopleCount";
                    var isExcludedSlide = key == "goals" || key == "what_brings_you";

                    if ( isSubSlide || isBrandSlide || isPeopleCountSlide || isExcludedSlide )
                    {
                        continue;
                    }

                    var slide = null;
                    var s = 0;
                    for ( s = 0; s < slides.length; s++ )
                    {
                        if ( slides[ s ].key == key )
                        {
                            slide = slides[ s ];
                            break;
                        }
                    }

                    if ( !slide && csKeyMap.hasOwnProperty( key ) )
                    {
                        slide = csKeyMap[ key ];
                    }

                    if ( !slide || !slide.answers )
                    {
                        continue;
                    }

                    var selectedValues = quizState[ key ];
                    var v = 0;
                    for ( v = 0; v < selectedValues.length; v++ )
                    {
                        var selectedVal = selectedValues[ v ];
                        var colonIdx = selectedVal.indexOf( ":" );
                        var rawValue = colonIdx >= 0 ? selectedVal.substring( 0, colonIdx ) : selectedVal;
                        var displayText = rawValue;
                        var a = 0;
                        for ( a = 0; a < slide.answers.length; a++ )
                        {
                            if ( slide.answers[ a ].value == rawValue )
                            {
                                displayText = slide.answers[ a ].text;
                                break;
                            }
                        }

                        var tagEl = document.createElement( "span" );
                        tagEl.className = "we-onboarding-quiz-results-loading-reveal-tag";
                        tagEl.innerHTML = starSvg + displayText;

                        if ( tagCount >= maxVisible )
                        {
                            tagEl.classList.add( "we-onboarding-quiz-results-loading-reveal-tag--hidden" );
                        }

                        tagsContainer.appendChild( tagEl );
                        tagCount++;
                    }
                }
            }

            if ( tagCount > maxVisible )
            {
                var showMoreBtn = document.createElement( "button" );
                showMoreBtn.type = "button";
                showMoreBtn.className = "we-onboarding-quiz-results-loading-reveal-show-more";
                showMoreBtn.textContent = "Show " + ( tagCount - maxVisible ) + " more";
                showMoreBtn.addEventListener( "click", function onShowMoreClick()
                {
                    var hiddenTags = tagsContainer.querySelectorAll( ".we-onboarding-quiz-results-loading-reveal-tag--hidden" );
                    for ( var h = 0; h < hiddenTags.length; h++ )
                    {
                        hiddenTags[ h ].classList.remove( "we-onboarding-quiz-results-loading-reveal-tag--hidden" );
                    }
                    showMoreBtn.classList.add( "hidden" );
                });
                tagsContainer.appendChild( showMoreBtn );
            }
        }

        AnimateResultsLoadingProgress( slideData );

        WE_OnboardingQuizResultsLoading_PopulateTags();
        WE_OnboardingQuizResultsLoading_ShowReveal();
    }
    else if ( slideData.slideType == "Results" )
    {
        var productsEl  = quiz.querySelector( ".we-onboarding-quiz-results-products" );
        var delayMs    = 0;
        var didRestore = false;
        console.log( "[WE Quiz Debug] Entered Results slide", { idx: idx, hasProductsEl: !!productsEl } );

        /* Hide products and clear widget before showing results section to prevent flash of content */
        if ( productsEl )
        {
            productsEl.classList.remove( "we-onboarding-quiz-results-products--visible" );
            
            /* Allow reveal only after delay so widget cannot show before we intend */
            // mw 20260322 : remove DOM cache, it was supposed to be a network cache
            //didRestore = WE_QuizResults_RestoreProductsDomCache( productsEl );
            //if ( didRestore )
            //{
            //    WE_QuizResults_LoadWidget( productsEl );
            //}

            // mw 20260322 : why is this hardcoded to 1.4 seconds ? Simplifying...
            //productsEl._weQuizResultsRevealAt = Date.now( ) + 1400;
            //requestAnimationFrame( WE_QuizResults_RevealProductsContainerTick );

            function WE_OnResultsProductsTransitionEnd( e )
            {
                if ( e && ( e.propertyName == "opacity" ) )
                {
                    WE_QuizResults_WaitForCardsThenEnhance( productsEl, 0 );
                    productsEl.style.transitionDelay = "";
                    productsEl.removeEventListener( "transitionend", WE_OnResultsProductsTransitionEnd );
                }
            }

            productsEl.style.transitionDelay = "1400ms";
            productsEl.addEventListener( "transitionend", WE_OnResultsProductsTransitionEnd );
            productsEl.classList.add( "we-onboarding-quiz-results-products--visible" );
            WE_QuizResults_WaitForCardsThenEnhance( productsEl, 0 );
        }

        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.add( "hidden" );
        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function addHiddenToContainer( container )
        {
            container.classList.add( "hidden" );
        } );
        
        const resultsTitle = quiz.querySelector( ".we-onboarding-quiz-results-title" );
        const resultsSubtitle = quiz.querySelector( ".we-onboarding-quiz-results-subtitle" );
        const resultsInstructions = quiz.querySelector( ".we-onboarding-quiz-results-instructions" );
        
        if ( resultsTitle && ( !resultsTitle.textContent || resultsTitle.textContent.trim() == "" ) )
        {
            resultsTitle.textContent = "Your healthy shop is ready";
        }
        
        if ( resultsSubtitle && ( !resultsSubtitle.textContent || resultsSubtitle.textContent.trim() == "" ) )
        {
            resultsSubtitle.textContent = "Built from your answers on taste, values, dietary needs & everyday habits";
        }
        
        if ( resultsInstructions && ( !resultsInstructions.textContent || resultsInstructions.textContent.trim() == "" ) )
        {
            resultsInstructions.textContent = "You're in control — keep what you love, remove anything you don't. Finalise your order next.";
        }
        
        if ( idx >= 21 )
        {
            UpdateProgressBarState( 2 );
        }
        else
        {
            UpdateProgressBarState( 1 );
        }

        if ( productsEl && !didRestore )
        {
            console.log( "[WE Quiz Debug] Scheduling widget from Results slide", { didRestore: didRestore, delayMs: delayMs } );
            WE_QuizResults_ScheduleResultsWidget( productsEl, delayMs );

            // mw 20260314 : removed all this async timer stuff because it's almost certain to go wrong and/or cause performance issues
            //setTimeout( WE_QuizResults_RunEnhanceOnWidgetLoad, delayMs + 1500 );
        }

        WE_QuizResults_RecalculateFooterUI( );
    }
    else if ( slideData.slideType == "ResultsExplore" )
    {
        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-explore" ).classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.add( "hidden" );
        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function addHiddenToContainer( container )
        {
            container.classList.add( "hidden" );
        } );
        
        UpdateProgressBarState( 2 );
        
        const exploreTitle = quiz.querySelector( ".we-onboarding-quiz-results-explore-title" );
        const exploreSubtitle = quiz.querySelector( ".we-onboarding-quiz-results-explore-subtitle" );
        
        if ( exploreTitle && ( !exploreTitle.textContent || exploreTitle.textContent.trim() == "" ) )
        {
            exploreTitle.textContent = "Round out your first order";
        }
        
        if ( exploreSubtitle && ( !exploreSubtitle.textContent || exploreSubtitle.textContent.trim() == "" ) )
        {
            exploreSubtitle.textContent = "Here are more personalised picks based on your quiz answers. Add them to your cart and hit checkout when ready.";
        }
        
        InitializeCategoryCarousels( );
        
        const viewCartBtn = quiz.querySelector( ".we-onboarding-quiz-results-explore-view-cart-btn" );
        if ( viewCartBtn )
        {
            viewCartBtn.onclick = function( e )
            {
                e.preventDefault( );
                const cartRedirectSlide = {
                    slideType: "CartRedirect",
                    position: 100
                };
                window._onboardingQuizData.slides.push( cartRedirectSlide );
                const slideIndex = window._onboardingQuizData.slides.length - 1;
                ShowSlide( slideIndex, false );
            };
        }
    }
    else if ( slideData.slideType == "CartRedirect" )
    {
        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-explore" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-cart-redirect" ).classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.add( "hidden" );
        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function addHiddenToContainer( container )
        {
            container.classList.add( "hidden" );
        } );
        
        function RedirectToCart( )
        {
            stopQuizOfferTimer();
            try { window.history.replaceState( { slide: 16 }, "", "/pages/welleasy-quiz?slide=16" ); } catch ( e ) {}
            window.location.replace( "/cart" );
        }

        const cartContent = quiz.querySelector( ".we-onboarding-quiz-cart-redirect-content" );
        if ( cartContent )
        {
            cartContent.style.animation = "none";
            void cartContent.offsetWidth;
            cartContent.style.animation = "cart-content-bob 1.5s ease-in-out infinite, cart-content-zoom-out 0.5s ease-in 1.5s forwards";

            function WE_OnboardingQuizCartRedirect_HandleAnimationEnd( e )
            {
                if ( e.animationName == "cart-content-zoom-out" )
                {
                    cartContent.removeEventListener( "animationend", WE_OnboardingQuizCartRedirect_HandleAnimationEnd );
                    RedirectToCart( );
                }
            }

            cartContent.addEventListener( "animationend", WE_OnboardingQuizCartRedirect_HandleAnimationEnd );
        }
        else
        {
            RedirectToCart( );
        }
    }
    else
    {
        var _infoVariantMap = { "labels-interstitial": "labels", "savings-interstitial": "savings", "features-interstitial": "features" };
        var _infoVariant = _infoVariantMap[ slideData.key ] || "";
        var _isInfoInterstitial = slideData.slideType == "Interstitial" && _infoVariant;

        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-explore" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-cart-redirect" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.remove( "hidden" );

        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function addHiddenToContainer( container )
        {
            container.classList.add( "hidden" );
        } );

        if ( _isInfoInterstitial )
        {
            var allInfoPanels = quiz.querySelectorAll( ".we-onboarding-quiz-info-interstitial" );
            for ( var ip = 0; ip < allInfoPanels.length; ip++ )
            {
                allInfoPanels[ ip ].classList.add( "hidden" );
            }

            var activePanel = quiz.querySelector( ".we-onboarding-quiz-info-interstitial[data-variant='" + _infoVariant + "']" );
            if ( activePanel )
            {
                activePanel.classList.remove( "hidden" );
            }

            if ( quizProgressEl ) { quizProgressEl.style.display = "none"; }
            if ( quizProgressInner && quizProgressInner.parentNode ) { quizProgressInner.parentNode.style.display = "none"; }

            var activeCarousel = activePanel ? activePanel.querySelector( ".we-info-interstitial-carousel" ) : null;
            if ( activeCarousel )
            {
                var carouselCollection = activeCarousel.getAttribute( "data-collection" ) || "food";
                WE_InfoInterstitial_FetchCarousel( activeCarousel, carouselCollection );
            }
        }
        else
        {
            quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.remove( "hidden" );
            AnimateInterstitialProgressBar( slideData.autoadvanceTime );
        }
    }

    if ( slideData.slideType == "Question" && slideData.answers && slideData.answers.length > 0 )
    {
        answers.classList.remove( "we-onboarding-quiz-answers--image" );
        answers.classList.remove( "we-onboarding-quiz-answers--card" );
        
        const hardcodedDescriptions = {
            "Save money on groceries": "WellEasy brings you competitive prices on premium brands, plus exclusive bundles and autoship discounts.",
            "Quality I can trust": "Every brand is carefully vetted for clean ingredients and sustainable practices you can feel good about.",
            "Shop a specific diet or lifestyle": "Tell us your dietary needs and we'll curate products perfectly matched to your lifestyle.",
            "Healthy groceries without the shopping trip": "Skip the store entirely - we deliver premium health foods straight to your door on your schedule.",
            "Discover healthier swaps": "Our smart recommendations help you find better alternatives for the products you already love."
        };
        
        const isWhatBringsYouSlide = slideData.text && slideData.text.toLowerCase().includes( "what brings you to welleasy" );
        
        var hasCardStyle = false;
        if ( isWhatBringsYouSlide )
        {
            hasCardStyle = true;
        }
        else
        {
            function HasAnswerDescription( ans )
            {
                return ( ans.description && ans.description != "" && ans.description.trim() != "" ) ||
                       ( hardcodedDescriptions[ ans.text ] );
            }
            hasCardStyle = slideData.answers.some( HasAnswerDescription );
        }
        
        if ( hasCardStyle )
        {
            answers.classList.add( "we-onboarding-quiz-answers--card" );
        }

        // remove the strengths from the copy of answer values for the show answer as selected logic
        // (stored format can be "value" or "value:strength" - strip only when colon present)
        var selectedAnswers = data[ slideData.key ];
        if ( selectedAnswers )
        {
            function StripStrengthFromSelected( selectedAnswer, index )
            {
                var value = selectedAnswer;
                var colonIdx = value.indexOf( ":" );
                if ( colonIdx >= 0 )
                {
                    value = value.slice( 0, colonIdx );
                }
                data[ slideData.key ][ index ] = value;
            }
            selectedAnswers.forEach( StripStrengthFromSelected );
        }
        
        function CreateAnswerElement( answerData, index )
        {
            const answer = document.createElement( "div" );
            answer.setAttribute( "class", "we-onboarding-quiz-answer" );
            answer._answerData = answerData;
            
            if ( hasCardStyle )
            {
                answer.classList.add( "we-onboarding-quiz-answer--card" );
                
                const cardContent = document.createElement( "div" );
                cardContent.setAttribute( "class", "we-onboarding-quiz-answer-card-content" );
                
                const iconMap = {
                    "Save money on groceries": '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pound-sterling"><path d="M18 7c0-5.333-8-5.333-8 0"></path><path d="M10 7v14"></path><path d="M6 21h12"></path><path d="M6 13h10"></path></svg>',
                    "Quality I can trust": '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-check"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path><path d="m9 12 2 2 4-4"></path></svg>',
                    "Shop a specific diet or lifestyle": '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-leaf"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"></path><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path></svg>',
                    "Healthy groceries without the shopping trip": '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-truck"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path><path d="M15 18H9"></path><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path><circle cx="17" cy="18" r="2"></circle><circle cx="7" cy="18" r="2"></circle></svg>',
                    "Discover healthier swaps": '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-refresh-cw"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path><path d="M21 3v5h-5"></path><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path><path d="M8 16H3v5"></path></svg>'
                };
                
                const iconSvg = iconMap[ answerData.text ];
                
                const iconContainer = document.createElement( "div" );
                iconContainer.setAttribute( "class", "we-onboarding-quiz-answer-icon-container" );
                
                if ( iconSvg )
                {
                    iconContainer.innerHTML = iconSvg;
                    
                    const svgElements = iconContainer.querySelectorAll( "svg, svg *" );
                    function StyleSVGElement( el )
                    {
                        el.style.stroke = "rgb(14, 196, 185)";
                        el.style.color = "rgb(14, 196, 185)";
                        if ( el.hasAttribute( "stroke" ) && el.getAttribute( "stroke" ) != "none" && el.getAttribute( "stroke" ) != "currentColor" )
                        {
                            el.setAttribute( "stroke", "rgb(14, 196, 185)" );
                        }
                        if ( el.hasAttribute( "fill" ) && el.getAttribute( "fill" ) != "none" )
                        {
                            el.setAttribute( "fill", "none" );
                        }
                    }
                    svgElements.forEach( StyleSVGElement );
                }
                else
                {
                    iconContainer.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle></svg>';
                }
                
                const headerContainer = document.createElement( "div" );
                headerContainer.setAttribute( "class", "we-onboarding-quiz-answer-card-header" );
                headerContainer.appendChild( iconContainer );
                
                const title = document.createElement( "h3" );
                title.setAttribute( "class", "we-onboarding-quiz-answer-title" );
                title.textContent = answerData.text;
                headerContainer.appendChild( title );
                
                cardContent.appendChild( headerContainer );
                
                var descriptionText = hardcodedDescriptions[ answerData.text ];
                if ( !descriptionText && answerData.description && answerData.description != "" && answerData.description.trim() != "" )
                {
                    descriptionText = answerData.description;
                }
                
                const description = document.createElement( "p" );
                description.setAttribute( "class", "we-onboarding-quiz-answer-description" );
                // description.style.display = "block";
                // description.style.maxHeight = "0";
                // description.style.padding = "0 16px";
                // description.style.transform = "translateX(-15px)";
                // description.style.opacity = "0";
                // description.style.transition = "transform 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), opacity 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), max-height 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), padding 400ms cubic-bezier( 0.4, 0, 0.2, 1 )";
                if ( descriptionText )
                {
                    description.textContent = descriptionText;
                }
                cardContent.appendChild( description );
                
                answer.appendChild( cardContent );
            }
            else if ( answerData.sideImage && answerData.sideImage != "" )
            {
                const image = document.createElement( "img" );
                const imageSrc = answerData.sideImage + "&width=100 100w," + answerData.sideImage + "&width=200 200w";
                const sizes = "(max-width: 400px) 100px, 200px";
                image.setAttribute( "class", "we-onboarding-quiz-answer-image");
                image.setAttribute( "src", answerData.sideImage + "&width=400" );
                image.setAttribute( "srcset", imageSrc );
                image.setAttribute( "sizes", sizes );
                image.setAttribute( "alt", answerData.text );
                image.setAttribute( "width", "400" );
                image.setAttribute( "height", "400" );
                if ( index <= 9 )
                {
                    image.setAttribute( "loading", "eager" );
                    image.setAttribute( "fetchpriority", "high" );
                    image.setAttribute( "decoding", "async" );
                }
                answer.appendChild( image );
                
                const textElement = document.createElement( "p" );
                textElement.textContent = answerData.text;
                answer.appendChild( textElement );
                
                var descriptionText = hardcodedDescriptions[ answerData.text ];
                if ( !descriptionText && answerData.description && answerData.description != "" && answerData.description.trim() != "" )
                {
                    descriptionText = answerData.description;
                }
                
                if ( descriptionText )
                {
                    const description = document.createElement( "p" );
                    description.setAttribute( "class", "we-onboarding-quiz-answer-description" );
                    // description.style.display = "block";
                    // description.style.maxHeight = "0";
                    // description.style.padding = "0 16px";
                    // description.style.transform = "translateX(-15px)";
                    // description.style.opacity = "0";
                    // description.style.transition = "transform 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), opacity 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), max-height 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), padding 400ms cubic-bezier( 0.4, 0, 0.2, 1 )";
                    // description.textContent = descriptionText;
                    answer.appendChild( description );
                }
                
                answer.classList.add( "we-onboarding-quiz-answer--image" );
                answer.classList.add( "we-onboarding-quiz-answer--side-image" );
                answers.classList.add( "we-onboarding-quiz-answers--image" );
            }
            else if ( answerData.image && answerData.image != "" )
            {
                const image = document.createElement( "img" );
                const imageSrc = answerData.image + "&width=100 100w," + answerData.image + "&width=200 200w";
                const sizes = "(max-width: 400px) 100px, 200px";
                image.setAttribute( "class", "we-onboarding-quiz-answer-image");
                image.setAttribute( "src", answerData.image + "&width=400" );
                image.setAttribute( "srcset", imageSrc );
                image.setAttribute( "sizes", sizes );
                image.setAttribute( "alt", answerData.text );
                image.setAttribute( "width", "400" );
                image.setAttribute( "height", "400" );
                if ( index <= 9 )
                {
                    image.setAttribute( "loading", "eager" );
                    image.setAttribute( "fetchpriority", "high" );
                    image.setAttribute( "decoding", "async" );
                }
                answer.appendChild( image );
                
                var descriptionText = hardcodedDescriptions[ answerData.text ];
                if ( !descriptionText && answerData.description && answerData.description != "" && answerData.description.trim() != "" )
                {
                    descriptionText = answerData.description;
                }
                
                if ( descriptionText )
                {
                    const description = document.createElement( "p" );
                    description.setAttribute( "class", "we-onboarding-quiz-answer-description" );
                    // description.style.display = "block";
                    // description.style.maxHeight = "0";
                    // description.style.padding = "0 16px";
                    // description.style.transform = "translateX(-15px)";
                    // description.style.opacity = "0";
                    // description.style.transition = "transform 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), opacity 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), max-height 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), padding 400ms cubic-bezier( 0.4, 0, 0.2, 1 )";
                    description.textContent = descriptionText;
                    answer.appendChild( description );
                }
                
                answer.classList.add( "we-onboarding-quiz-answer--image" );
                answers.classList.add( "we-onboarding-quiz-answers--image" );
            }
            else
            {
                answer.innerHTML = "<p>" + answerData.text + "</p>";
                
                var descriptionText = hardcodedDescriptions[ answerData.text ];
                if ( !descriptionText && answerData.description && answerData.description != "" && answerData.description.trim() != "" )
                {
                    descriptionText = answerData.description;
                }
                
                if ( descriptionText )
                {
                    const description = document.createElement( "p" );
                    description.setAttribute( "class", "we-onboarding-quiz-answer-description" );
                    // description.style.display = "block";
                    // description.style.maxHeight = "0";
                    // description.style.padding = "0 16px";
                    // description.style.transform = "translateX(-15px)";
                    // description.style.opacity = "0";
                    // description.style.transition = "transform 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), opacity 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), max-height 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), padding 400ms cubic-bezier( 0.4, 0, 0.2, 1 )";
                    description.textContent = descriptionText;
                    answer.appendChild( description );
                }
            }

            if ( ( data[ slideData.key ] ) && ( data[ slideData.key ].includes( answerData.value ) ) )
            {
                answer.classList.add( "we-onboarding-quiz-selected-answer" );
                
                // const description = answer.querySelector( ".we-onboarding-quiz-answer-description" );
                // if ( description )
                // {
                //     description.style.maxHeight = "500px";
                //     description.style.padding = "12px 16px";
                //     description.style.transform = "translateX(0)";
                //     description.style.opacity = "1";
                // }
            }

            answer.addEventListener( "click", AnswerClicked );

            answers.appendChild( answer );
        }
        var filteredAnswers = slideData.answers.filter( function IsNotNoneAnswer( a ) { return !a.none; } );
        filteredAnswers.forEach( CreateAnswerElement );

        var slidePosition = parseInt( slideData.position, 10 );
        var showSelectAll = slidePosition != 2 && slidePosition != 3 && slidePosition != 4 && slidePosition != 5 && slidePosition != 6;

        if ( showSelectAll )
        {
        var selectAllBtn = document.createElement( "div" );
        selectAllBtn.setAttribute( "class", "we-onboarding-quiz-answer we-onboarding-quiz-select-all" );
        selectAllBtn.setAttribute( "data-select-all", "true" );
        selectAllBtn.innerHTML = "<p>All of these</p>";

        var firstAnswer = answers.querySelector( ".we-onboarding-quiz-answer:not( .we-onboarding-quiz-select-all )" );
        if ( firstAnswer )
        {
            if ( firstAnswer.classList.contains( "we-onboarding-quiz-answer--card" ) )
            {
                selectAllBtn.classList.add( "we-onboarding-quiz-answer--card" );
            }
            else if ( firstAnswer.classList.contains( "we-onboarding-quiz-answer--side-image" ) )
            {
                selectAllBtn.classList.add( "we-onboarding-quiz-answer--side-image" );
            }
            else if ( firstAnswer.classList.contains( "we-onboarding-quiz-answer--image" ) )
            {
                selectAllBtn.classList.add( "we-onboarding-quiz-answer--image" );
            }
        }

        selectAllBtn.addEventListener( "click", function onSelectAllClick( )
        {
            var allAnswers  = answers.querySelectorAll( ".we-onboarding-quiz-answer:not( .we-onboarding-quiz-select-all ):not( .we-onboarding-quiz-none-of-these )" );
            var noneOfTheseBtn = answers.querySelector( ".we-onboarding-quiz-none-of-these" );
            var allSelected = true;

            function CheckIfAllSelected( ans )
            {
                if ( !ans.classList.contains( "we-onboarding-quiz-selected-answer" ) )
                {
                    allSelected = false;
                }
            }
            allAnswers.forEach( CheckIfAllSelected );

            function ToggleAll( ans )
            {
                if ( allSelected )
                {
                    ans.classList.remove( "we-onboarding-quiz-selected-answer" );
                }
                else
                {
                    ans.classList.add( "we-onboarding-quiz-selected-answer" );
                }
            }
            allAnswers.forEach( ToggleAll );

            if ( allSelected )
            {
                selectAllBtn.classList.remove( "we-onboarding-quiz-selected-answer" );
            }
            else
            {
                selectAllBtn.classList.add( "we-onboarding-quiz-selected-answer" );
                if ( noneOfTheseBtn )
                {
                    noneOfTheseBtn.classList.remove( "we-onboarding-quiz-selected-answer" );
                }
            }

            SaveOnboardingQuizAnswers();
        } );
        answers.appendChild( selectAllBtn );
        }

        if ( slideData.slideType == "Question" && slideData.position != 2 && slideData.position != 4 )
        {
            var noneOfTheseBtn = document.createElement( "div" );
            noneOfTheseBtn.setAttribute( "class", "we-onboarding-quiz-answer we-onboarding-quiz-none-of-these" );
            noneOfTheseBtn._isNoneOfThese = true;
            noneOfTheseBtn.innerHTML = "<p>None of these</p>";
            noneOfTheseBtn.addEventListener( "click", AnswerClicked );
            answers.appendChild( noneOfTheseBtn );
        }
    }

    if ( !firstLoad && slideData.position > 0 && slideData.position < 9999 )
    {
        var qp = ParseQP( );
        qp.slide = slideData.position;
        window.history.pushState( { slide: slideData.position }, "", window.location.pathname + MakeQPStr( qp ) );
    }
    SaveOnboardingQuizState( );

    WE_QuizProgress_WriteForSlide( slideData );

    initQuizResumeBanner( );
    var closeBtn = quiz.querySelector('.we-onboarding-quiz-close');
    var saveExitBtn = quiz.querySelector('.we-onboarding-quiz-save-exit');

    if (closeBtn) {
        closeBtn.style.display = '';          // remove any inline display:none
        closeBtn.classList.remove('hidden');  // remove any hidden utility class
    }

    if ( saveExitBtn && slideData.position < 16 )
    {
        saveExitBtn.style.display = '';
        saveExitBtn.classList.remove( 'hidden' );
    }
    else if ( saveExitBtn )
    {
        saveExitBtn.classList.add( "hidden" );
    }

    if ( slideData.autoadvanceTime && !firstLoad && slideData.slideType != "ResultsLoading" && slideData.slideType != "Results" && slideData.slideType != "ResultsExplore" && !( slideData.slideType == "Interstitial" && ( slideData.key == "labels-interstitial" || slideData.key == "savings-interstitial" || slideData.key == "features-interstitial" ) ) )
    {
        var nextIdx = idx + 1;

        function WE_OnboardingQuizSlideAdvanceAnimationEnd( e )
        {
            var el = e.currentTarget;
            var activeEl = ( quizEl ? quizEl._weOnboardingQuizSlideAdvanceEl : null );

            if ( el && activeEl && el == activeEl )
            {
                if ( quizEl )
                {
                    quizEl._weOnboardingQuizSlideAdvanceEl = null;
                }
                if ( el.parentNode )
                {
                    el.parentNode.removeChild( el );
                }
                ShowSlide( nextIdx );
            }
        }

        if ( quiz )
        {
            var quizEl = quiz;

            if ( quizEl._weOnboardingQuizSlideAdvanceEl )
            {
                if ( quizEl._weOnboardingQuizSlideAdvanceEl.parentNode )
                {
                    quizEl._weOnboardingQuizSlideAdvanceEl.parentNode.removeChild( quizEl._weOnboardingQuizSlideAdvanceEl );
                }
                quizEl._weOnboardingQuizSlideAdvanceEl = null;
            }

            var timerEl = document.createElement( "div" );
            timerEl.setAttribute( "class", "we-onboarding-quiz-slide-advance-timer" );
            timerEl.style.animation = "we-onboarding-quiz-slide-advance 1ms linear both";
            timerEl.style.animationDelay = slideData.autoadvanceTime + "ms";
            timerEl.addEventListener( "animationend", WE_OnboardingQuizSlideAdvanceAnimationEnd );
            quizEl.appendChild( timerEl );
            quizEl._weOnboardingQuizSlideAdvanceEl = timerEl;
        }
        else
        {
            ShowSlide( nextIdx );
        }
    }

    ResetQuizSlideScroll( quiz );
    }
}

function InitializeCategoryCarousels( )
{
    const categories = document.querySelectorAll( ".we-onboarding-quiz-results-explore-category" );
    
    function InitializeCategory( category )
    {
        const productsContainer = category.querySelector( ".we-onboarding-quiz-results-explore-category-products" );
        const prevBtn = category.querySelector( ".we-onboarding-quiz-results-explore-category-nav-btn--prev" );
        const nextBtn = category.querySelector( ".we-onboarding-quiz-results-explore-category-nav-btn--next" );
        
        if ( productsContainer && prevBtn && nextBtn )
        {
        function UpdateNavButtons( )
        {
            const scrollLeft = productsContainer.scrollLeft;
            const scrollWidth = productsContainer.scrollWidth;
            const clientWidth = productsContainer.clientWidth;
            
            if ( scrollLeft <= 0 )
            {
                prevBtn.classList.add( "hidden" );
            }
            else
            {
                prevBtn.classList.remove( "hidden" );
            }
            
            if ( scrollLeft + clientWidth >= scrollWidth - 10 )
            {
                nextBtn.classList.add( "hidden" );
            }
            else
            {
                nextBtn.classList.remove( "hidden" );
            }
        }
        
        function HandlePrevClick( )
        {
            productsContainer.scrollBy( { left: -300, behavior: "smooth" } );
        }
        
        function HandleNextClick( )
        {
            productsContainer.scrollBy( { left: 300, behavior: "smooth" } );
        }
        
        prevBtn.addEventListener( "click", HandlePrevClick );
        nextBtn.addEventListener( "click", HandleNextClick );
        productsContainer.addEventListener( "scroll", UpdateNavButtons );
        UpdateNavButtons( );
        }
    }
    
    categories.forEach( InitializeCategory );
}

function ShowAnswerOptions( answerData, answerParent )
{
    var overlay          = document.querySelector( ".we-onboarding-quiz-options-overlay" );
    var popup            = document.querySelector( ".we-onboarding-quiz-options" );
    var header           = document.querySelector( ".we-onboarding-quiz-options-question" );
    var answersContainer = document.querySelector( ".we-onboarding-quiz-options-values" );

    overlay.classList.add( "we-onboarding-quiz-options-overlay--visible" );
    popup.classList.add( "we-onboarding-quiz-options--visible" );

    header.innerText = answerData.optionsQuestion;

    while ( answersContainer.firstChild )
    {
        answersContainer.firstChild.remove( );
    }

    function CreateOptionElement( answer )
    {
        const answerEl = document.createElement( "div" );
        answerEl.setAttribute( "class", "we-onboarding-quiz-answer" );
        answerEl._answerData = answer;
        answerEl.innerHTML = "<p>" + answer.text + "</p>";
        answerEl.addEventListener( "click", function onAnswerOptionClick( e )
        {
            OptionClicked( e, answerParent );
        });
        answersContainer.appendChild( answerEl );
    }
    answerData.options.forEach( CreateOptionElement );
}

function OptionClicked( e, answerParent )
{
    // remove the selected answer styling as SaveOnboardingQuizAnswers will save it separately to it's parent if present,
    // there is logic to join the answers in that function
    var options = document.querySelectorAll( ".we-onboarding-quiz-options-values .we-onboarding-quiz-answer" );
    options.forEach( function clearSelectedOptionStyle( option )
    {
        option.classList.remove( "we-onboarding-quiz-selected-answer" );
    } );
    var selectedOption = e.currentTarget._answerData.value;
    answerParent._answerData.selectedOption = selectedOption;
    CloseOptionsPopup( );
    SaveOnboardingQuizAnswers( );
}

function CloseOptionsPopup( )
{
    var overlay = document.querySelector( ".we-onboarding-quiz-options-overlay" );
    var popup   = document.querySelector( ".we-onboarding-quiz-options" );

    if ( overlay )
    {
        overlay.classList.remove( "we-onboarding-quiz-options-overlay--visible" );
    }
    if ( popup )
    {
        popup.classList.remove( "we-onboarding-quiz-options--visible" );
    }
}

function NavigateToRegisterFromQuiz( )
{
    ShowFreeGiftSlide();
}

function ShowFreeGiftSlide( skipPush )
{
    if ( window.startQuizOfferTimer )
    {
        window.startQuizOfferTimer( );
    }

    var quiz = document.querySelector( ".we-onboarding-quiz" );
    if ( !quiz ) return;

    var memberTags = ( window._onboardingQuizData && window._onboardingQuizData.customerTags ) || [ ];
    var isMember   = document.body.classList.contains( "has-inveterate-subscriber" );
    var t          = 0;
    var norm       = "";
    if ( !isMember )
    {
        for ( t = 0; t < memberTags.length; t++ )
        {
            norm = String( memberTags[ t ] ).toLowerCase( ).replace( /[^a-z0-9]/g, "" );
            if ( norm == "inveteratesubscriber" )
            {
                isMember = true;
                break;
            }
        }
    }
    if ( isMember )
    {
        window.location.href = "/pages/welleasy-quiz?slide=16";
        return;
    }

    // Store gift indicator for back navigation
    try { sessionStorage.setItem( "we_last_quiz_slide_position", "gift" ); } catch ( e ) {}

    if ( !skipPush )
    {
        window.history.pushState({ slide: "gift" }, "", "/pages/welleasy-quiz?slide=gift" );
    }

    var allSlides = quiz.querySelectorAll( ".we-onboarding-quiz-slide, .we-onboarding-quiz-welcome, .we-onboarding-quiz-results-loading, .we-onboarding-quiz-results, .we-onboarding-quiz-results-explore, .we-onboarding-quiz-custom-creating, .we-onboarding-quiz-custom-picked, .we-onboarding-quiz-add-cart-loading" );
    for ( var i = 0; i < allSlides.length; i++ )
    {
        allSlides[ i ].classList.add( "hidden" );
    }

    var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
    for ( var b = 0; b < buttonContainers.length; b++ )
    {
        buttonContainers[ b ].classList.add( "hidden" );
    }

    var freeGiftSlide = quiz.querySelector( ".we-onboarding-quiz-free-gift" );
    var giftContinue = document.querySelector( ".we-free-gift-continue" );
    var storedGift = null;

    if ( freeGiftSlide )
    {
        freeGiftSlide.classList.remove( "hidden" );
        document.body.classList.add( "on-gift-slide" );
        var freeGiftPopup = quiz.querySelector( ".we-onboarding-quiz-free-gift-popup" );
        if ( freeGiftPopup )
        {
            freeGiftPopup.classList.add( "hidden" );
        }

        try { storedGift = localStorage.getItem( "we_quiz_free_gift_variant" ); } catch ( e ) {}

        if ( storedGift )
        {
            var storedCard = quiz.querySelector( '.we-free-gift-card[data-variant-id="' + storedGift + '"]' );

            if ( storedCard )
            {
                storedCard.classList.add( "we-free-gift-card--selected" );

                if ( giftContinue )
                {
                    giftContinue.disabled = false;
                    giftContinue.setAttribute( "data-variant-id", storedGift );
                    WE_QuizGiftMeta_StoreFromCard( storedCard );
                }
            }
            else if ( giftContinue )
            {
                giftContinue.disabled = true;
            }
        }
        else if ( giftContinue )
        {
            giftContinue.disabled = true;
        }

        if ( giftContinue && giftContinue.disabled )
        {
            if ( giftContinue.getAttribute( "data-variant-id" ) )
            {
                giftContinue.disabled = false;
            }
        }

        InitFreeGiftSelection();
    }
}

function WE_QuizGift_RefreshNodes( )
{
    var sels = [ ".we-free-gift-card", ".we-free-gift-continue", ".we-free-gift-no-thanks", ".we-free-gift-card-info-btn", ".we-free-gift-popup-close", ".we-free-gift-popup-backdrop", ".we-free-gift-popup-choose" ];
    var live = null;
    var i    = 0;
    var j    = 0;
    for ( i = 0; i < sels.length; i++ )
    {
        live = document.querySelectorAll( sels[ i ] );
        for ( j = 0; j < live.length; j++ )
        {
            live[ j ].replaceWith( live[ j ].cloneNode( true ) );
        }
    }
}

function WE_QuizGift_ReplaceCartGift( oldVariantId, newVariantId, done, continueBtn )
{
    var addPayload = null;
    fetch( "/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded", "Accept": "application/json" },
        body: "id=" + oldVariantId + "&quantity=0"
    } )
    .then( function QuizGiftReplace_Removed( response ) { return response.json( ); } )
    .then( function QuizGiftReplace_Add( )
    {
        addPayload = { items: [ { id: Number( newVariantId ), quantity: 1, properties: { "_product_gift_type": "free_gift", "_quiz_gift": "true" } } ] };
        return fetch( "/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify( addPayload )
        } );
    } )
    .then( function QuizGiftReplace_Added( response ) { return response.json( ); } )
    .then( function QuizGiftReplace_Done( )
    {
        done( );
    } )
    .catch( function QuizGiftReplace_Error( )
    {
        continueBtn.disabled = false;
        if ( continueBtn.getAttribute( "data-busy-text" ) )
        {
            continueBtn.textContent = continueBtn.getAttribute( "data-busy-text" );
        }
    } );
}

function WE_QuizGiftMeta_StoreFromCard( card )
{
    var titleEl = null;
    var title   = "";
    var imgEl   = null;
    var image   = "";
    var variant = "";
    if ( card )
    {
        variant = card.getAttribute( "data-variant-id" ) || "";
        titleEl = card.querySelector( ".we-free-gift-card-title" );
        if ( titleEl && titleEl.textContent )
        {
            title = titleEl.textContent.trim( );
        }
        imgEl = card.querySelector( ".we-free-gift-card-image-wrap img" );
        if ( imgEl )
        {
            image = imgEl.getAttribute( "src" ) || "";
        }
        if ( variant != "" && title != "" )
        {
            try
            {
                window.localStorage.setItem( "we_quiz_free_gift_meta", JSON.stringify( {
                    title: title,
                    image: image,
                    variantId: variant
                } ) );
            }
            catch ( e ) { }
        }
    }
}

function InitFreeGiftSelection()
{
    var FREE_GIFT_STORAGE_KEY = "we_quiz_free_gift_variant";
    var cards = null;
    var continueBtn = null;
    var noThanksBtn = null;
    var popup = null;
    var selectedCard = null;
    WE_QuizGift_RefreshNodes( );
    cards = document.querySelectorAll( ".we-free-gift-card" );
    continueBtn = document.querySelector( ".we-free-gift-continue" );
    noThanksBtn = document.querySelector( ".we-free-gift-no-thanks" );
    popup = document.querySelector( ".we-onboarding-quiz-free-gift-popup" );
    if ( continueBtn && continueBtn.hasAttribute( "data-busy-text" ) )
    {
        continueBtn.textContent = continueBtn.getAttribute( "data-busy-text" );
        continueBtn.removeAttribute( "data-busy-text" );
        continueBtn.disabled = !continueBtn.getAttribute( "data-variant-id" );
    }

function HandleGiftCardClick( e )
{
    var card = e.currentTarget;
    var giftVariantId = card.getAttribute( "data-variant-id" );

    if ( !giftVariantId )
    {
        return;
    }

    for ( var i = 0; i < cards.length; i++ )
    {
        cards[ i ].classList.remove( "we-free-gift-card--selected" );
    }
    card.classList.add( "we-free-gift-card--selected" );
    continueBtn.disabled = false;
    continueBtn.setAttribute( "data-variant-id", giftVariantId );
    localStorage.setItem( FREE_GIFT_STORAGE_KEY, giftVariantId );
    // Store persistent variant ID for the cart
    localStorage.setItem( 'we_gift_variant_id', giftVariantId );
    WE_QuizGiftMeta_StoreFromCard( card );
}

    for ( var i = 0; i < cards.length; i++ )
    {
        cards[ i ].addEventListener( "click", HandleGiftCardClick );
    }

    if ( continueBtn )
    {
        continueBtn.addEventListener( "click", function HandleContinueClick()
        {
            var variantId = localStorage.getItem( FREE_GIFT_STORAGE_KEY );

            if ( !variantId )
            {
                variantId = continueBtn.getAttribute( "data-variant-id" );
            }

            if ( !variantId || continueBtn.disabled )
            {
                return;
            }

            continueBtn.disabled = true;
            continueBtn.setAttribute( "data-busy-text", continueBtn.textContent );
            continueBtn.textContent = "Adding...";

            function OnCartLoaded( cart )
            {
                var alreadyInCart   = false;
                var cartGiftVariant = "";
                for ( var i = 0; i < cart.items.length; i++ )
                {
                    if ( cart.items[ i ].properties && cart.items[ i ].properties._product_gift_type == "free_gift" )
                    {
                        alreadyInCart = true;
                        cartGiftVariant = String( cart.items[ i ].variant_id || "" );
                        break;
                    }
                }

                function RedirectToRegister()
                {
                    var quizEl = document.querySelector( ".we-onboarding-quiz" );
                    var isLoggedIn = quizEl && quizEl.getAttribute( "data-customer-logged-in" ) == "true";

                    if ( isLoggedIn )
                    {
                        window.location.href = "/pages/welleasy-quiz?slide=16";
                    }
                    else
                    {
                        localStorage.setItem( "quiz_account_creation", true );
                        try { sessionStorage.setItem( "we_register_flow", "quiz" ); } catch ( err ) {}
                        try { sessionStorage.setItem( "we_last_quiz_slide_position", "gift" ); } catch ( err ) {}
                        window.location.href = "/account/register?flow=quiz";
                    }
                }

                if ( alreadyInCart && cartGiftVariant == String( variantId ) )
                {
                    RedirectToRegister();
                    return;
                }

                if ( alreadyInCart )
                {
                    WE_QuizGift_ReplaceCartGift( cartGiftVariant, variantId, RedirectToRegister, continueBtn );
                    return;
                }

                var payload = { items: [ { id: Number( variantId ), quantity: 1, properties: { "_product_gift_type": "free_gift", "_quiz_gift": "true" } } ] };
                fetch( "/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify( payload )
                } )
                .then( function HandleAddResponse( response ) { return response.json(); } )
                .then( function HandleAddComplete()
                {
                    RedirectToRegister();
                } )
                .catch( function HandleAddError()
                {
                    continueBtn.disabled = false;
                    if ( continueBtn.getAttribute( "data-busy-text" ) )
                    {
                        continueBtn.textContent = continueBtn.getAttribute( "data-busy-text" );
                    }
                } );
            }

            fetch( "/cart.js" )
                .then( function HandleCartResponse( response ) { return response.json(); } )
                .then( OnCartLoaded )
                .catch( function OnCartError() { OnCartLoaded( { items: [] } ); } );
        } );
    }

    if ( noThanksBtn )
    {
        noThanksBtn.addEventListener( "click", function HandleNoThanks()
        {
            localStorage.setItem( "quiz_account_creation", true );
            try { sessionStorage.setItem( "we_register_flow", "quiz" ); } catch ( e ) {}
            try { sessionStorage.setItem( "we_last_quiz_slide_position", "gift" ); } catch ( e ) {}

            var quizEl = document.querySelector( ".we-onboarding-quiz" );
            var isLoggedIn = quizEl && quizEl.getAttribute( "data-customer-logged-in" ) == "true";

            if ( isLoggedIn )
            {
                window.location.href = "/pages/welleasy-quiz?slide=16";
            }
            else
            {
                window.location.href = "/account/register?flow=quiz";
            }
        } );
    }

    var infoBtns = document.querySelectorAll( ".we-free-gift-card-info-btn" );
    for ( var i = 0; i < infoBtns.length; i++ )
    {
        infoBtns[ i ].addEventListener( "click", function HandleInfoClick( e )
        {
            e.stopPropagation();
            selectedCard = e.currentTarget.closest( ".we-free-gift-card" );
            if ( !selectedCard || !popup ) return;

            var popupImg = popup.querySelector( ".we-free-gift-popup-img" );
            var popupTitle = popup.querySelector( ".we-free-gift-popup-title" );
            var popupPriceValue = popup.querySelector( ".we-free-gift-popup-price-value" );
            var popupDescription = popup.querySelector( ".we-free-gift-popup-description" );
            var cardImg = selectedCard.querySelector( "img" );
            var cardTitle = selectedCard.querySelector( ".we-free-gift-card-title" );
            var cardDescription = selectedCard.dataset.description;

            if ( popupImg && cardImg ) popupImg.src = cardImg.src;
            if ( popupTitle && cardTitle ) popupTitle.textContent = cardTitle.textContent;
            if ( popupPriceValue ) popupPriceValue.textContent = selectedCard.querySelector( ".we-free-gift-card-compare" ).textContent.replace( "FREE", "" ).trim();
            if ( popupDescription ) popupDescription.textContent = cardDescription || "";

            popup.classList.remove( "hidden" );
        } );
    }

    if ( popup )
    {
        var closeBtn = popup.querySelector( ".we-free-gift-popup-close" );
        var backdrop = popup.querySelector( ".we-free-gift-popup-backdrop" );
        var chooseBtn = popup.querySelector( ".we-free-gift-popup-choose" );

        if ( closeBtn )
        {
            closeBtn.addEventListener( "click", function HandlePopupClose()
            {
                popup.classList.add( "hidden" );
            } );
        }
        if ( backdrop )
        {
            backdrop.addEventListener( "click", function HandleBackdropClick()
            {
                popup.classList.add( "hidden" );
            } );
        }
        if ( chooseBtn )
        {
            chooseBtn.addEventListener( "click", function HandleChooseGift()
            {
                popup.classList.add( "hidden" );
                if ( selectedCard )
                {
                    for ( var i = 0; i < cards.length; i++ )
                    {
                        cards[ i ].classList.remove( "we-free-gift-card--selected" );
                    }
                    selectedCard.classList.add( "we-free-gift-card--selected" );
                    continueBtn.disabled = false;
                    localStorage.setItem( FREE_GIFT_STORAGE_KEY, selectedCard.getAttribute( "data-variant-id" ) );
                    WE_QuizGiftMeta_StoreFromCard( selectedCard );
                }
            } );
        }
    }
}

function RemoveConditionalSlides( currentIdx )
{
    var slideData = window._onboardingQuizData.slides[ currentIdx ];
    var i         = 0;

    if ( !slideData )
    {
        return;
    }

    for ( i = window._onboardingQuizData.slides.length - 1; i >= 0; i-- )
    {
        if ( window._onboardingQuizData.slides[ i ]._conditional && window._onboardingQuizData.slides[ i ]._parentKey == slideData.key )
        {
            window._onboardingQuizData.slides.splice( i, 1 );
        }
    }
}

function InsertConditionalSlides( currentIdx )
{
    var slideData    = window._onboardingQuizData.slides[ currentIdx ];
    var answers      = null;
    var selected     = [];
    var insertAfter  = currentIdx;
    var i            = 0;
    var j            = 0;
    var answerEl     = null;
    var answerData   = null;
    var cslide       = null;
    var existingKeys = [];

    if ( !slideData || slideData.slideType != "Question" )
    {
        return;
    }

    RemoveConditionalSlides( currentIdx );

    answers = document.querySelectorAll( ".we-onboarding-quiz-answers .we-onboarding-quiz-answer:not( [data-select-all] ):not( .we-onboarding-quiz-none-of-these )" );

    for ( i = 0; i < answers.length; i++ )
    {
        answerEl = answers[ i ];
        if ( answerEl.classList.contains( "we-onboarding-quiz-selected-answer" ) && answerEl._answerData )
        {
            selected.push( answerEl._answerData );
        }
    }

    for ( i = 0; i < window._onboardingQuizData.slides.length; i++ )
    {
        existingKeys.push( window._onboardingQuizData.slides[ i ].key );
    }

    for ( i = 0; i < selected.length; i++ )
    {
        answerData = selected[ i ];
        cslide     = answerData.conditionalSlide ? window._onboardingQuizData._csKeyMap[ answerData.conditionalSlide ] : null;

        console.log( "[Quiz Debug] InsertConditionalSlides:", answerData.text, "-> sub_slide_key:", answerData.conditionalSlide, "-> csKeyMap lookup:", cslide ? "FOUND (" + cslide.key + ")" : "MISSING" );

        if ( cslide && existingKeys.indexOf( cslide.key ) == -1 )
        {
            var newSlide = WE_QuizConditional_BuildSlide( slideData, cslide );

            insertAfter++;
            window._onboardingQuizData.slides.splice( insertAfter, 0, newSlide );
            existingKeys.push( cslide.key );
        }
    }
}

function NextOnboardingSlide( e )
{
    var quiz                   = null;
    var currentIdx             = 0;
    var slideData              = null;
    var idx                    = 0;
    var errorPrompt            = null;
    var shouldScheduleRegister = false;

    quiz = document.querySelector( ".we-onboarding-quiz" );

    if ( quiz )
    {
        currentIdx = Number( quiz.getAttribute( "data-idx" ) );
        slideData  = window._onboardingQuizData.slides[ currentIdx ];

        // First, insert conditional slides for current slide
        InsertConditionalSlides( currentIdx );

        // Check if current slide is the create account slide — go to free gift for brands, otherwise advance
        if ( slideData && window._onboardingQuizData.createAccountSlide && Number( slideData.position ) == Number( window._onboardingQuizData.createAccountSlide ) )
        {
            WE_QuizTracking_HandleStepComplete( currentIdx, slideData );
            errorPrompt = document.querySelector( ".we-onboarding-quiz .we-onboarding-quiz-error-prompt" );
            if ( errorPrompt )
            {
                errorPrompt.classList.add( "hidden" );
            }

            var isInveterate = window._onboardingQuizData.customerTags &&
                window._onboardingQuizData.customerTags.includes( "inveterate-subscriber" );

            if ( isInveterate )
            {
                try { sessionStorage.setItem( "quiz_logged_in_skip_register", "1" ); } catch ( e ) {}
                window.location.href = "/pages/welleasy-quiz?slide=16";
            }
            else if ( slideData.key == "brands" )
            {
                NavigateToRegisterFromQuiz();
            }
            else
            {
                idx = currentIdx + 1;
                if ( idx < window._onboardingQuizData.slides.length )
                {
                    ShowSlide( idx );
                }
                else
                {
                    shouldScheduleRegister = true;
                }
            }
        }
        // Then check if we should go to register after position 15
        else if ( slideData && Number( slideData.position ) == 15 )
        {
            idx = currentIdx + 1;
            if ( idx < window._onboardingQuizData.slides.length )
            {
                // There are conditional slides for position 15, go to first one
                WE_QuizTracking_HandleStepComplete( currentIdx, slideData );
                errorPrompt = document.querySelector( ".we-onboarding-quiz .we-onboarding-quiz-error-prompt" );
                if ( errorPrompt )
                {
                    errorPrompt.classList.add( "hidden" );
                }
                ShowSlide( idx );
            }
            else
            {
                shouldScheduleRegister = true;
            }
        }
        else
        {
            idx = currentIdx + 1;
            if ( idx < window._onboardingQuizData.slides.length )
            {
                WE_QuizTracking_HandleStepComplete( currentIdx, slideData );
                errorPrompt = document.querySelector( ".we-onboarding-quiz .we-onboarding-quiz-error-prompt" );
                if ( errorPrompt )
                {
                    errorPrompt.classList.add( "hidden" );
                }
                ShowSlide( idx );
            }
        }
    }
    if ( shouldScheduleRegister )
    {
        NavigateToRegisterFromQuiz( );
    }
}

function PreviousOnboardingSlide( e )
{
    var quiz = document.querySelector( ".we-onboarding-quiz" );
    var idx  = Number( quiz.getAttribute( "data-idx" ) );

    if ( idx > 0 )
    {
        ShowSlide( idx - 1 );
    }

    var errorPrompt = quiz.querySelector( ".we-onboarding-quiz-error-prompt" );
    if ( errorPrompt )
    {
        errorPrompt.classList.add( "hidden" );
    }
}


function StartOnboardingQuiz( )
{
    if ( window._onboardingQuizData && !window._onboardingQuizData.auth )
    {
        try { sessionStorage.removeItem( "quiz_logged_in_skip_register" ); } catch ( e ) {}
    }

    var prevBtns       = null;
    var nextBtns       = null;
    var optionsOverlay = null;
    var optionsClose   = null;
    var qp             = null;
    var slideIdx       = 0;
    var targetPosition = 0;
    var i              = 0;
    var slidePosition  = 0;

    if ( window._onboardingQuizData && window._onboardingQuizData.slides )
    {
        console.log( "[Quiz Debug] Slides loaded:", window._onboardingQuizData.slides.length );
        window._onboardingQuizData.slides.forEach( function logSlide( s, i )
        {
            console.log( "[Quiz Debug] Slide " + i + ": key=" + s.key + " position=" + s.position + " answers=" + ( s.answers ? s.answers.length : 0 ) + " slideType=" + s.slideType );
        });
        window._onboardingQuizData.slides.sort( function SortSlidesByPosition( a, b ){
            return ( a.position - b.position );
        });

        window._onboardingQuizData._csKeyMap = {};
        for ( i = window._onboardingQuizData.slides.length - 1; i >= 0; i-- )
    {
        if ( window._onboardingQuizData.slides[ i ]._conditional )
        {
            var _cs = window._onboardingQuizData.slides[ i ];
            if ( _cs.key )
            {
                window._onboardingQuizData._csKeyMap[ _cs.key ] = _cs;
            }
            window._onboardingQuizData.slides.splice( i, 1 );
        }
    }

        console.log( "[Quiz Debug] _csKeyMap keys:", Object.keys( window._onboardingQuizData._csKeyMap ) );

    prevBtns = document.querySelectorAll( ".we-onboarding-quiz-prev" );
    nextBtns = document.querySelectorAll( ".we-onboarding-quiz-next" );
    
    prevBtns.forEach( function bindPrevBtnClick( prevBtn )
    {
        prevBtn.addEventListener( "click", PreviousOnboardingSlide );
    });
    
    nextBtns.forEach( function bindNextBtnClick( nextBtn )
    {
        nextBtn.addEventListener( "click", NextOnboardingSlide );
    });

    optionsOverlay = document.querySelector( ".we-onboarding-quiz-options-overlay" );
    optionsClose = document.querySelector( ".we-onboarding-quiz-options-close" );
    
    if ( optionsOverlay )
    {
        optionsOverlay.addEventListener( "click", CloseOptionsPopup );
    }
    
    if ( optionsClose )
    {
        optionsClose.addEventListener( "click", CloseOptionsPopup );
    }

    InitSaveAndExitButton( );

    var infoContinueBtns = document.querySelectorAll( ".we-onboarding-quiz-info-interstitial .we-info-interstitial-continue" );
    for ( var icb = 0; icb < infoContinueBtns.length; icb++ )
    {
        infoContinueBtns[ icb ].addEventListener( "click", function InfoInterstitial_Continue( e )
        {
            e.preventDefault();
            e.stopPropagation();

            var quiz = document.querySelector( ".we-onboarding-quiz" );
            if ( !quiz ) return;

            var currentIdx = Number( quiz.getAttribute( "data-idx" ) );
            var slideData = window._onboardingQuizData && window._onboardingQuizData.slides ? window._onboardingQuizData.slides[ currentIdx ] : null;
            var nextIdx = currentIdx + 1;

            if ( slideData )
            {
                WE_QuizTracking_HandleStepComplete( currentIdx, slideData );
            }

            var errorPrompt = quiz.querySelector( ".we-onboarding-quiz-error-prompt" );
            if ( errorPrompt )
            {
                errorPrompt.classList.add( "hidden" );
            }

            if ( nextIdx < window._onboardingQuizData.slides.length )
            {
                ShowSlide( nextIdx );
            }
        } );
    }

    var accordionTriggers = document.querySelectorAll( ".we-info-interstitial-accordion-trigger" );
    for ( var atri = 0; atri < accordionTriggers.length; atri++ )
    {
        accordionTriggers[ atri ].addEventListener( "click", WE_InfoInterstitial_HandleAccordionClick );
    }

    qp = ParseQP( );

    if ( !WE_OnboardingQuiz_IsBackForwardNav() && ( qp.slide == undefined || qp.slide == "" ) )
    {
        WE_QuizClearStaleResumeFlags( );
    }

    if ( qp.slide == "gift" )
    {
        ShowFreeGiftSlide( true );
        return;
    }

    if ( qp.slide != undefined && qp.slide != "" )
    {
        targetPosition = parseInt( qp.slide, 10 );
        if ( !isNaN( targetPosition ) )
        {
            for ( i = 0; i < window._onboardingQuizData.slides.length; i++ )
            {
                slidePosition = parseInt( window._onboardingQuizData.slides[ i ].position, 10 );
                if ( !isNaN( slidePosition ) && slidePosition == targetPosition )
                {
                    slideIdx = i;
                    break;
                }
            }

            if ( slideIdx == 0 && targetPosition != parseInt( window._onboardingQuizData.slides[ 0 ].position, 10 ) )
            {
                var resolved = WE_QuizProgress_ResolveIdx( );
                if ( resolved == -2 )
                {
                    ShowFreeGiftSlide( true );
                    return;
                }
                else if ( resolved >= 0 )
                {
                    ShowSlide( resolved, true );
                    return;
                }
                var progressPosition = WE_OnboardingQuiz_ReadProgressPosition( );
                var progressIdx = -1;
                if ( progressPosition > 0 )
                {
                    progressIdx = WE_OnboardingQuiz_FindSlideIdxByPosition( progressPosition );
                }
                if ( progressIdx >= 0 )
                {
                    ShowSlide( progressIdx, true );
                    return;
                }
                if ( window._onboardingQuizData.auth )
                {
                    window.location.href = "/pages/welleasy-quiz?slide=16";
                    return;
                }
                else
                {
                    ShowFreeGiftSlide();
                    return;
                }
            }
        }
    }

    ShowSlide( slideIdx, true );
    }
    else
    {
        console.error( "Quiz data not found" );
    }
} 

StartOnboardingQuiz( );

function RedirectSlide10ToRegister()
{
}

RedirectSlide10ToRegister();

function WE_OnboardingQuizResults_SetQuizCardRemovedState( card, isRemoved )
{
    var addBack = null;

    addBack = card.querySelector( ".we-quiz-card__add-back" );

    if ( isRemoved )
    {
        card.classList.add( "we-quiz-card--removed" );
    }
    else
    {
        card.classList.remove( "we-quiz-card--removed" );
    }

    if ( addBack )
    {
        addBack.hidden = !isRemoved;
    }
}

function WE_OnboardingQuizResults_GetDrawer( )
{
    var drawer = null;

    drawer = document.querySelector( ".we-quiz-drawer" );

    return drawer;
}

function WE_QuizResults_DrawerProductFetchResolve( product, drawerIngredients, drawerNutrition )
{
    var desc = ( product && product.description ) ? product.description : "";

    if ( drawerIngredients ) { drawerIngredients.innerHTML = desc; }
    if ( drawerNutrition )   { drawerNutrition.innerHTML = desc; }
}

function WE_QuizResults_DrawerProductFetchReject( )
{
}

function WE_QuizResults_DrawerProductFetchParse( r )
{
    return r.json( );
}

function WE_OnboardingQuizResults_PopulateDrawerFromCard( drawer, card )
{
    var imgEl             = null;
    var vendorEl          = null;
    var titleEl           = null;
    var drawerImg         = null;
    var drawerVendor      = null;
    var drawerTitle       = null;
    var drawerIngredients = null;
    var drawerNutrition   = null;
    var whyShownEl        = null;
    var whyShownReasons   = null;
    var whyShownProduct   = null;
    var ecPopup           = null;
    var reasonsData       = null;
    var reasons           = [];
    var i                 = 0;
    var imgSrc            = "";
    var vendor            = "";
    var title             = "";
    var productUrl        = "";
    var handleMatch       = null;
    var handle            = "";

    imgEl = card.querySelector( ".we-quiz-card__image-img" ) || card.querySelector( ".ec-product-image-container img, .product-card__image img, [id=\"product-card-image-container\"] img" );
    if ( imgEl )
    {
        imgSrc = imgEl.getAttribute( "src" ) || "";
    }

    vendorEl = card.querySelector( ".we-quiz-card__vendor" ) || card.querySelector( ".ec-product-vendor, .product-card__brand" );
    if ( vendorEl )
    {
        vendor = ( vendorEl.textContent || "" ).trim( );
    }

    titleEl = card.querySelector( ".we-quiz-card__title" ) || card.querySelector( ".ec-product-title, .product-card__title" );
    if ( titleEl )
    {
        title = ( titleEl.textContent || "" ).trim( );
    }

    drawerImg = drawer.querySelector( ".we-quiz-drawer__img" );
    if ( drawerImg )
    {
        drawerImg.setAttribute( "src", imgSrc );
        drawerImg.setAttribute( "alt", title );
    }

    drawerVendor = drawer.querySelector( ".we-quiz-drawer__vendor" );
    if ( drawerVendor )
    {
        drawerVendor.textContent = vendor;
    }

    drawerTitle = drawer.querySelector( ".we-quiz-drawer__title" );
    if ( drawerTitle )
    {
        drawerTitle.textContent = title;
    }

    drawerIngredients = drawer.querySelector( ".we-quiz-drawer__ingredients" );
    drawerNutrition   = drawer.querySelector( ".we-quiz-drawer__nutrition" );
    if ( drawerIngredients ) { drawerIngredients.innerHTML = ""; }
    if ( drawerNutrition )   { drawerNutrition.innerHTML = ""; }

    whyShownEl = drawer.querySelector( ".we-quiz-drawer__why-shown" );
    whyShownReasons = drawer.querySelector( ".we-quiz-drawer__why-shown-reasons" );
    whyShownProduct = drawer.querySelector( ".we-quiz-drawer__why-shown-product" );
    reasons = [];
    if ( whyShownEl && whyShownReasons )
    {
        reasonsData = card.getAttribute( "data-ec-reasons" ) || card.getAttribute( "data-ec-dev-reasons" );
        if ( reasonsData )
        {
            try { reasons = JSON.parse( reasonsData ); } catch ( err ) { reasons = []; }
            if ( !Array.isArray( reasons ) ) { reasons = []; }
        }
        if ( reasons.length == 0 )
        {
            ecPopup = card.querySelector( ".ec-dev-popup" );
            if ( !ecPopup )
            {
                ecPopup = document.querySelector( ".ec-dev-popup" );
                if ( ecPopup && title )
                {
                    var popupH4 = ecPopup.querySelector( "h4" );
                    if ( !popupH4 || ( popupH4.textContent || "" ).trim() != title )
                    { ecPopup = null; }
                }
            }
            if ( ecPopup )
            {
                var popupParas = ecPopup.querySelectorAll( "p" );
                for ( i = 0; i < popupParas.length; i++ )
                {
                    reasons.push( ( popupParas[ i ].textContent || "" ).trim() );
                }
                reasons = reasons.filter( function( r ) { return r.length > 0; } );
            }
        }
        if ( reasons.length > 0 )
        {
            if ( whyShownProduct ) { whyShownProduct.textContent = title || ""; }
            whyShownReasons.innerHTML = "";
            for ( i = 0; i < reasons.length; i++ )
            {
                var p = document.createElement( "p" );
                p.textContent = reasons[ i ];
                whyShownReasons.appendChild( p );
            }
            whyShownEl.removeAttribute( "hidden" );
        }
        else
        {
            whyShownEl.setAttribute( "hidden", "hidden" );
        }
    }

    productUrl = "";
    try
    {
        var dataStr = card.getAttribute( "data-product-data" ) || "";
        var dataObj = dataStr ? JSON.parse( dataStr ) : null;
        if ( dataObj && dataObj.url ) { productUrl = dataObj.url; }
    }
    catch ( err ) { }
    if ( !productUrl )
    {
        var linkEl = card.querySelector( "a[href*=\"/products/\"]" );
        if ( linkEl ) { productUrl = linkEl.getAttribute( "href" ) || ""; }
    }

    handleMatch = productUrl ? productUrl.match( /\/products\/([^/?]+)/ ) : null;
    handle      = handleMatch ? handleMatch[ 1 ] : "";

    if ( handle )
    {
        function HandleDrawerProductFetched( product )
        {
            WE_QuizResults_DrawerProductFetchResolve( product, drawerIngredients, drawerNutrition );
            if ( typeof loadDrawerReviews === 'function' )
            {
                loadDrawerReviews( handle );
            }
        }
        fetch( "/products/" + handle + ".js" )
            .then( WE_QuizResults_DrawerProductFetchParse )
            .then( HandleDrawerProductFetched )
            .catch( WE_QuizResults_DrawerProductFetchReject );
    }
}

function WE_OnboardingQuizResults_OpenDrawer( button, card )
{
    var drawer = null;

    if ( card && typeof window.dispatchEvent == "function" )
    {
        try
        {
            window.dispatchEvent( new CustomEvent( "we-quiz-drawer-will-open", { detail: { card: card }, bubbles: true } ) );
        }
        catch ( err ) { }
    }

    drawer = WE_OnboardingQuizResults_GetDrawer( );

    if ( drawer )
    {
        WE_OnboardingQuizResults_PopulateDrawerFromCard( drawer, card );

        var drawerTags = drawer.querySelector( ".we-quiz-drawer__tags" );
        if ( drawerTags )
        {
            drawerTags.innerHTML = "";

            var dqProductUrl = "";
            try
            {
                var dqDataStr = card.getAttribute( "data-product-data" ) || "";
                var dqDataObj = dqDataStr ? JSON.parse( dqDataStr ) : null;
                if ( dqDataObj && dqDataObj.url ) { dqProductUrl = dqDataObj.url; }
            }
            catch ( err ) { }
            if ( !dqProductUrl )
            {
                var dqLink = card.querySelector( "a[href*=\"/products/\"]" );
                if ( dqLink ) { dqProductUrl = dqLink.getAttribute( "href" ) || ""; }
            }
            var dqHandleMatch = dqProductUrl ? dqProductUrl.match( /\/products\/([^/?]+)/ ) : null;
            var dqHandle = dqHandleMatch ? dqHandleMatch[ 1 ] : "";

            var dqCardTagsStr = card.getAttribute( "data-product-tags" ) || "";
            var dqCardTags = dqCardTagsStr ? dqCardTagsStr.split( "," ) : [];

            function DqPopulateTags( dqProductTags )
            {
                var dqState = GetQuizState( );
                var dqSlides = window._onboardingQuizData && window._onboardingQuizData.slides ? window._onboardingQuizData.slides : [];
                var dqCsKeyMap = window._onboardingQuizData && window._onboardingQuizData._csKeyMap ? window._onboardingQuizData._csKeyMap : {};
                var dqStarSvg = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L14.09 8.26L20 9.27L15.55 13.97L16.91 20L12 16.9L7.09 20L8.45 13.97L4 9.27L9.91 8.26L12 2Z" fill="currentColor"/></svg>';
                var dqProductTagsLower = [];
                for ( var dpi = 0; dpi < dqProductTags.length; dpi++ ) { dqProductTagsLower.push( dqProductTags[ dpi ].toLowerCase().trim() ); }
                for ( var dk in dqState )
                {
                    if ( !dqState.hasOwnProperty( dk ) || !dqState[ dk ] || dqState[ dk ].length == 0 ) continue;
                    var dIsDiet = dk == "diets";
                    var dIsSubSlide = dqCsKeyMap.hasOwnProperty( dk );
                    var dIsBrand = dk == "brands";
                    var dIsPeopleCount = dk == "peopleCount";
                    var dIsExcluded = dk == "goals" || dk == "what_brings_you";
                    if ( dIsSubSlide || dIsBrand || dIsPeopleCount || dIsExcluded ) continue;
                    var dSlide = null;
                    for ( var ds = 0; ds < dqSlides.length; ds++ ) { if ( dqSlides[ ds ].key == dk ) { dSlide = dqSlides[ ds ]; break; } }
                    if ( !dSlide && dqCsKeyMap.hasOwnProperty( dk ) ) dSlide = dqCsKeyMap[ dk ];
                    if ( !dSlide || !dSlide.answers ) continue;
                    var dVals = dqState[ dk ];
                    for ( var dv = 0; dv < dVals.length; dv++ )
                    {
                        var dSel = dVals[ dv ];
                        var dColon = dSel.indexOf( ":" );
                        var dRaw = dColon >= 0 ? dSel.substring( 0, dColon ) : dSel;
                        var dText = dRaw;
                        var dProdTag = "";
                        for ( var da = 0; da < dSlide.answers.length; da++ ) { if ( dSlide.answers[ da ].value == dRaw ) { dText = dSlide.answers[ da ].text; dProdTag = ( dSlide.answers[ da ].productTag || "" ).toLowerCase().trim(); break; } }
                        if ( dProdTag && dqProductTagsLower.indexOf( dProdTag ) !== -1 )
                        {
                            var dTag = document.createElement( "span" );
                            dTag.className = "we-quiz-drawer__tag";
                            dTag.innerHTML = dqStarSvg + dText;
                            drawerTags.appendChild( dTag );
                        }
                    }
                }
            }

            if ( dqCardTags.length > 0 )
            {
                DqPopulateTags( dqCardTags );
            }
            else if ( dqHandle )
            {
                fetch( "/products/" + dqHandle + ".js" )
                    .then( function( r ) { return r.json(); } )
                    .then( function( product ) { DqPopulateTags( product.tags || [] ); } )
                    .catch( function() { DqPopulateTags( [] ); } );
            }
        }

        drawer.classList.add( "we-quiz-drawer--open" );
        drawer.setAttribute( "aria-hidden", "false" );
        document.body.classList.add( "we-quiz-drawer-open" );
    }

    if ( button )
    {
        button.setAttribute( "aria-expanded", "true" );
    }
}

function WE_OnboardingQuizResults_CloseDrawer( )
{
    var drawer          = null;
    var expandedButtons = null;
    var i               = 0;

    drawer = WE_OnboardingQuizResults_GetDrawer( );

    if ( drawer )
    {
        drawer.classList.remove( "we-quiz-drawer--open" );
        drawer.setAttribute( "aria-hidden", "true" );
    }

    document.body.classList.remove( "we-quiz-drawer-open" );

    expandedButtons = document.querySelectorAll( ".we-quiz-card__reason[aria-expanded='true']" );

    for ( i = 0; i < expandedButtons.length; i++ )
    {
        expandedButtons[ i ].setAttribute( "aria-expanded", "false" );
    }
}

function WE_ParseMoneyValue( value )
{
    var result = 0;

    if ( value )
    {
        result = parseFloat( value.replace( /[^0-9.]/g, "" ) ) || 0;
    }

    return result;
}

function WE_QuizResults_RevealProductsContainer( )
{
    var productsEl = document.querySelector( ".we-onboarding-quiz-results-products" );
    if ( productsEl )
    {
        productsEl.classList.add( "we-onboarding-quiz-results-products--visible" );
    }
}

// mw 20260322 : removing async stuff implemented using requestAnimationFrame
//function WE_QuizResults_RevealProductsContainerTick( )
//{
//    var productsEl     = document.querySelector( ".we-onboarding-quiz-results-products" );
//    var shouldReveal   = false;
//    var revealAt       = 0;
//
//    if ( productsEl )
//    {
//        revealAt = productsEl._weQuizResultsRevealAt || 0;
//
//        if ( revealAt && Date.now( ) >= revealAt )
//        {
//            shouldReveal = true;
//        }
//    }
//
//    if ( shouldReveal )
//    {
//        productsEl.classList.add( "we-onboarding-quiz-results-products--visible" );
//    }
//    else
//    {
//        requestAnimationFrame( WE_QuizResults_RevealProductsContainerTick );
//    }
//}

function WE_QuizResults_GetResultsCacheSignature( )
{
    var quizStateStr = "";
    var authSig      = "";
    var auth          = null;
    var authId       = "";
    var authEmail    = "";
    var result       = "";

    quizStateStr = localStorage.getItem( LOCALSTORAGE_KEY_NAME ) || "";
    auth = window._onboardingQuizData.auth;

    if ( auth )
    {
        if ( auth.id != undefined && auth.id != null )
        {
            authId = String( auth.id );
        }

        if ( auth.email != undefined && auth.email != null )
        {
            authEmail = String( auth.email );
        }
    }

    if ( authId != "" || authEmail != "" )
    {
        authSig = authId + ":" + authEmail;
    }

    result = authSig + "|" + quizStateStr;
    return result;
}

function WE_QuizResults_HasImagesSrcResolved( productsEl )
{
    var cards      = null;
    var imgEl      = null;
    var url        = "";
    var src        = "";
    var resolved   = false;
    var mainImgSel = ".we-quiz-card__image-img, .ec-product-image-container img, .product-card__image img, .product-card__image__img, [id=\"product-card-image-container\"] img";
    var i          = 0;
    var totalCards = 0;
    var okCount    = 0;
    var allOk      = true;

    if ( productsEl )
    {
        cards = productsEl.querySelectorAll( ".ec-product-card, .product-grid__product-card, .we-quiz-card" );
        totalCards = cards.length;

        for ( i = 0; i < totalCards; i++ )
        {
            if ( !allOk )
            {
                break;
            }

            imgEl = cards[ i ].querySelector( mainImgSel );
            if ( imgEl )
            {
                url = WE_QuizResults_GetMainImageUrl( imgEl );
                if ( url )
                {
                    src = imgEl.getAttribute( "src" ) || "";
                    if ( src == url )
                    {
                        okCount ++;
                    }
                    else
                    {
                        allOk = false;
                    }
                }
                else
                {
                    allOk = false;
                }
            }
            else
            {
                allOk = false;
            }
        }
    }

    if ( totalCards > 0 && allOk && okCount == totalCards )
    {
        resolved = true;
    }

    return resolved;
}


function WE_QuizResults_GetProductsDomCacheKeyName( )
{
    return LOCALSTORAGE_KEY_NAME + "_results_products_dom_cache_v3";
}

// mw 20260322 : removing the DOM cache, it was supposed to be a network cache
//function WE_QuizResults_SaveProductsDomCache( productsEl )
//{
//    if ( productsEl && !productsEl._weQuizResultsProductsDomCacheSaved && !productsEl._weQuizResultsProductsDomCacheSaving )
//    {
//        productsEl._weQuizResultsProductsDomCacheSaving = true;
//
//        WE_QuizResults_PollSaveProductsDomCache( productsEl, 0 );
//    }
//}
//
//function WE_QuizResults_PollSaveProductsDomCache( productsEl, frameCount )
//{
//    const maxFrames = 240;
//    var canPoll = false;
//
//    if ( productsEl && !productsEl._weQuizResultsProductsDomCacheSaved )
//    {
//      canPoll = true;
//    }
//
//    if ( canPoll )
//    {
//        var cacheKey = WE_QuizResults_GetProductsDomCacheKeyName( );
//        var signature = WE_QuizResults_GetResultsCacheSignature( );
//
//        WE_QuizResults_ForceLoadWidgetImages( productsEl );
//        WE_QuizResults_PopulatePlaceholderImages( );
//
//        if ( WE_QuizResults_HasImagesSrcResolved( productsEl ) )
//        {
//            var cacheData = null;
//
//            cacheData = {
//                "signature" : signature,
//                "productsHtml" : productsEl.innerHTML
//            };
//
//            localStorage.setItem( cacheKey, JSON.stringify( cacheData ) );
//            productsEl._weQuizResultsProductsDomCacheSaved = true;
//            productsEl._weQuizResultsProductsDomCacheSaving = false;
//            console.log( "[WE Quiz Cache] save success", cacheKey, signature );
//        }
//        else if ( frameCount < maxFrames )
//        {
//            requestAnimationFrame( function WE_QuizResults_PollSaveProductsDomCacheTick( )
//            {
//                WE_QuizResults_PollSaveProductsDomCache( productsEl, frameCount + 1 );
//            } );
//        }
//        else
//        {
//            productsEl._weQuizResultsProductsDomCacheSaving = false;
//            console.log( "[WE Quiz Cache] save fail", cacheKey, signature );
//        }
//    }
//}

function WE_QuizResults_RestoreProductsDomCache( productsEl )
{
    var restored = false;
    var cacheKey = "";
    var cachedStr = "";
    var cached = null;
    var signature = "";

    if ( productsEl )
    {
        cacheKey = WE_QuizResults_GetProductsDomCacheKeyName( );
        signature = WE_QuizResults_GetResultsCacheSignature( );
        cachedStr = localStorage.getItem( cacheKey );

        if ( cachedStr )
        {
            try
            {
                cached = JSON.parse( cachedStr );
            }
            catch ( e )
            {
                cached = null;
            }

            if ( cached && cached.signature == signature && cached.productsHtml )
            {
                productsEl.innerHTML = cached.productsHtml;
                productsEl._weQuizResultsProductsDomCacheRestored = true;
                restored = true;
            }
        }
    }

    if ( restored )
    {
        console.log( "[WE Quiz Cache] restore hit", cacheKey, signature );
    }
    else
    {
        var cachedStrLen = 0;
        if ( cachedStr )
        {
            cachedStrLen = cachedStr.length;
        }
        console.log( "[WE Quiz Cache] restore miss", cacheKey, signature, "cachedStrLen", cachedStrLen );
    }

    return restored;
}

function WE_QuizResults_RunEnhanceOnWidgetLoad( )
{
    WE_QuizResults_EnhanceECCards( );
    WE_QuizResults_RecalculateFooterUI( );
}


function WE_QuizResults_LoadWidget( productsEl )
{
    //var widget      = null;
    //const hasWidget = productsEl.querySelector( ".enhanced-commerce-widget" );
    //
    //if ( hasWidget )
    //{
    //    //productsEl._weQuizResultsWidgetLoaded = true;
    //    WE_QuizResults_ApplyCachedVariantIds( productsEl );
    //    WE_QuizResults_ApplyCachedProductImages( productsEl );
    //    WE_QuizResults_ForceLoadWidgetImages( productsEl );
    //    WE_QuizResults_RunEnhanceOnWidgetLoad( );
    //    WE_QuizResults_PopulatePlaceholderImages( );
    //}
    //else
    {
        productsEl._weQuizResultsEnhanceComplete = false;
        SaveOnboardingQuizState( );

        // mw 20260322 : this is how app-specific clientside network caching should work
        function OnWidgetLoadResponse( widgetLoadResponse )
        {
            productsEl._weQuizResultsEcApiResponse = true;
            console.log( "[WE AOV Fallback] EC API response received", { at: new Date( ).toISOString( ) } );
            productsEl._cachedNetworkResponse = widgetLoadResponse;
            WE_QuizResults_WaitForCardsThenEnhance( productsEl, 0 );
        }
        
        var makeNetworkRequest = true;
        var oldWidget          = productsEl.querySelector( ".enhanced-commerce-widget" );
        if ( ( productsEl._cachedNetworkResponse ) && ( oldWidget ) )
        {
            console.log( "could use cached data here", productsEl._cachedNetworkResponse );
            //makeNetworkRequest = false;
        }

        if ( makeNetworkRequest )
        {
            console.log( "[WE Quiz Debug] Loading EC widget for quiz results", { hasOldWidget: !!oldWidget, ecWidgetName: window._onboardingQuizData.ecWidgetName, ecWidgetTitle: window._onboardingQuizData.ecWidgetTitle } );

            // remove old widget if there is one
            if ( oldWidget )
            {
                console.log( "[WE Quiz Debug] Removing old EC widget" );
                oldWidget.remove( );
            }

            // add a new one
            var param =
            {
                "type"               : "custom",
                "name"               : window._onboardingQuizData.ecWidgetName,
                "title"              : window._onboardingQuizData.ecWidgetTitle
            };

            console.log( "[WE Quiz Debug] EC_CreateWidget params:", JSON.stringify( param ) );
            productsEl._ecWidgetParam = param;
            productsEl._ecWidgetCallback = OnWidgetLoadResponse;
            var widget = EC_CreateWidget( param, OnWidgetLoadResponse );
            
            productsEl.appendChild( widget );
            console.log( "[WE Quiz Debug] EC widget appended", { hasWidgetNow: !!productsEl.querySelector( ".enhanced-commerce-widget" ), widgetTag: widget ? widget.tagName : "null", widgetChildren: widget ? widget.children.length : 0 } );

            /* JUSTIFIED: EC renders cards asynchronously after API response — observer detects exact moment cards appear */
            var ecObserver = new MutationObserver( function OnEcWidgetMutation( mutations )
            {
                var cards = productsEl.querySelectorAll( ".ec-product-card, .product-grid__product-card, .product-card" );
                console.log( "[WE Quiz Debug] MutationObserver fired", { cardsFound: cards.length, mutations: mutations.length, addedNodes: mutations[ 0 ] ? mutations[ 0 ].addedNodes.length : 0 } );
                if ( cards.length > 0 )
                {
                    console.log( "[WE Quiz Debug] Observer found cards — processing" );
                    ecObserver.disconnect();
                    clearTimeout( ecSafetyTimeout );
                    WE_QuizResults_WaitForCardsThenEnhance( productsEl, 0 );
                }
            } );

            ecObserver.observe( productsEl, { childList: true, subtree: true } );
            console.log( "[WE Quiz Debug] MutationObserver started on productsEl" );

            var ecSafetyTimeout = setTimeout( function EcObserverSafetyFallback()
            {
                console.log( "[WE Quiz Debug] Safety timeout fired (10s) — observer did not detect cards" );
                ecObserver.disconnect();
                WE_QuizResults_WaitForCardsThenEnhance( productsEl, 0 );
            }, 10000 );
        }
        WE_QuizResults_ApplyCachedProductImages( productsEl );
        //productsEl._weQuizResultsWidgetLoaded = true;
        console.log( "[WE Quiz Debug] Initial WaitForCardsThenEnhance call" );
        WE_QuizResults_WaitForCardsThenEnhance( productsEl, 0 );
    }
}

function WE_QuizResults_WaitForCardsThenEnhance( productsEl, frameCount )
{
    const cards      = productsEl.querySelectorAll( ".product-grid__product-card, .ec-product-card, .product-card" );
    const totalCards   = cards.length;
    var enhancedCards = 0;

    WE_QuizResults_ForceLoadWidgetImages( productsEl );
    WE_QuizResults_PopulatePlaceholderImages( );

    WE_QuizResults_ApplyCachedVariantIds( productsEl );

    enhancedCards = productsEl.querySelectorAll( ".we-quiz-card" ).length;
    var retryCount = productsEl._weQuizRetryCount || 0;
    console.log( "[WE Quiz Debug] WaitForCardsThenEnhance", {
        totalCards: totalCards,
        enhancedCards: enhancedCards,
        enhanceComplete: !!productsEl._weQuizResultsEnhanceComplete,
        retryCount: retryCount
    } );

    if ( enhancedCards > 0 && enhancedCards == totalCards && !productsEl._weQuizResultsEnhanceComplete )
    {
        console.log( "[WE Quiz Debug] Enhancement complete — " + totalCards + " cards processed" );
        productsEl._weQuizResultsEnhanceComplete = true;
        WE_QuizResults_RunEnhanceOnWidgetLoad( );
        WE_QuizResults_SaveCachedProductImages( productsEl );
        WE_QuizResults_ScheduleFollowUpEnhance( productsEl, 20, 0, 0 );
        WE_QuizResults_MarkPrimaryReady( productsEl, totalCards );
    }
    else if ( totalCards > 0 && !productsEl._weQuizResultsEnhanceComplete )
    {
        console.log( "[WE Quiz Debug] Cards found but not all enhanced — running enhance pass" );
        WE_QuizResults_RunEnhanceOnWidgetLoad( );
    }
    else if ( totalCards == 0 && retryCount < 8 && !productsEl._weQuizResultsEnhanceComplete )
    {
        console.log( "[WE Quiz Debug] No cards yet — retry " + ( retryCount + 1 ) + "/8: reloading widget in 2s" );
        productsEl._weQuizRetryCount = retryCount + 1;
        setTimeout( function RetryReloadWidget()
        {
            if ( productsEl._weQuizResultsEnhanceComplete ) { return; }
            var retryOldWidget = productsEl.querySelector( ".enhanced-commerce-widget" );
            if ( retryOldWidget ) { retryOldWidget.remove( ); }
            var retryWidget = EC_CreateWidget( productsEl._ecWidgetParam, productsEl._ecWidgetCallback );
            productsEl.appendChild( retryWidget );
            console.log( "[WE Quiz Debug] Retry widget appended" );
        }, 2000 );
    }
    else if ( totalCards > 0 && enhancedCards < totalCards )
    {
        console.log( "[WE Quiz Debug] Found " + enhancedCards + "/" + totalCards + " cards — waiting for more" );
        setTimeout( function WaitForMoreCards()
        {
            WE_QuizResults_WaitForCardsThenEnhance( productsEl, frameCount );
        }, 1000 );
    }
    else if ( totalCards == 0 )
    {
        console.log( "[WE Quiz Debug] No cards after 8 retries — observer still watching" );
        WE_QuizResults_MarkPrimaryReady( productsEl, 0 );
    }

    if ( totalCards > 0 )
    {
        WE_QuizKlaviyo_TrackResults( productsEl );
    }
}

function WE_QuizResults_ScheduleFollowUpEnhance( productsEl, framesLeft, previousCount, passCount )
{
    const maxPasses = 20;

    if ( framesLeft > 0 )
    {
        requestAnimationFrame( function WE_QuizResults_FollowUpEnhanceNextFrame( )
        {
            WE_QuizResults_ScheduleFollowUpEnhance( productsEl, framesLeft - 1, previousCount, passCount );
        } );
    }
        else
        {
            WE_QuizResults_RunEnhanceOnWidgetLoad( );
            WE_QuizResults_RecalculateFooterUI( );
        }
}

function WE_QuizResults_IsPrimaryReady( productsEl )
{
    return productsEl && productsEl._wePrimaryComplete == true;
}

function WE_Reveal_UpdateForPrimary( revealButton, productsEl )
{
    if ( WE_QuizResults_IsPrimaryReady( productsEl ) == true )
    {
        var cards = productsEl ? productsEl.querySelectorAll( ".ec-product-card, .product-grid__product-card, .product-card" ).length : 0;
        if ( cards === 0 )
        {
            revealButton.disabled    = false;
            revealButton.textContent = "Browse my aisle \u2192";
            revealButton.onclick = function() { window.location.href = "/pages/lightning-my-aisle"; };
            revealButton.setAttribute( "data-we-aisle-fallback", "1" );
        }
        else
        {
            revealButton.disabled    = false;
            revealButton.textContent = "Reveal my picks";
            revealButton.removeAttribute( "data-we-aisle-fallback" );
        }
    }
    else
    {
        revealButton.disabled    = true;
        revealButton.textContent = "Loading products...";
    }
}

function WE_Reveal_OnPrimaryReady( event )
{
    var productsEl   = event.target;
    var quiz         = productsEl.closest( ".we-onboarding-quiz" );
    var revealButton = null;
    if ( quiz != null )
    {
        revealButton = quiz.querySelector( ".we-onboarding-quiz-results-loading-reveal-button" );
        WE_Reveal_UpdateForPrimary( revealButton, productsEl );
    }
}

function WE_Reveal_BindPrimaryReady( revealButton, productsEl )
{
    productsEl.addEventListener( "we-quiz-primary-ready", WE_Reveal_OnPrimaryReady );
    WE_Reveal_UpdateForPrimary( revealButton, productsEl );
}

function WE_QuizResults_MarkPrimaryReady( productsEl, count )
{
    var event = null;
    if ( productsEl._wePrimaryComplete == true )
    {
        return;
    }
    productsEl._wePrimaryComplete = true;
    console.log( "[WE Quiz Primary] Products ready",
    {
        count: count
    } );
    event = document.createEvent( "Event" );
    event.initEvent( "we-quiz-primary-ready", true, false );
    productsEl.dispatchEvent( event );
}

function WE_QuizResults_OnProductsMutate( )
{
    WE_QuizResults_RunEnhanceOnWidgetLoad( );
}

function WE_QuizResults_DisconnectObserver( observer )
{
    observer.disconnect( );
}

function WE_QuizResults_EnhancePollTick( )
{
    WE_QuizResults_RunEnhanceOnWidgetLoad( );
}

function WE_QuizResults_EnhancePollSwitchToSlow( fastPollId )
{
    clearInterval( fastPollId );
    WE_QuizResults_EnhancePollTick( );
}

function WE_QuizResults_ClearEnhancePoll( pollId )
{
    clearInterval( pollId );
}

// mw 20260314 : removed all this async timer stuff because it's almost certain to go wrong and/or cause performance issues
//function WE_QuizResults_WaitForApiTick( productsEl, intervalRef, attemptsRef )
//{
//    attemptsRef[ 0 ]++;
//    if ( window.SendAPIRequest )
//    {
//        clearInterval( intervalRef[ 0 ] );
//        SaveOnboardingQuizState( );
//        setTimeout( WE_QuizResults_LoadWidget, 300, productsEl );
//    }
//    else if ( attemptsRef[ 0 ] >= 150 )
//    {
//        clearInterval( intervalRef[ 0 ] );
//        setTimeout( WE_QuizResults_LoadWidget, 300, productsEl );
//    }
//}

//function Really_WE_QuizResults_ScheduleResultsWidget( productsEl )
//{
//    if ( window.EC_CreateWidget )
//    {
//        WE_QuizResults_LoadWidget( productsEl );
//    }
//    else
//    {
//        productsEl._weQuizResultsWidgetRetrying = true;
//        productsEl._weQuizResultsWidgetRetryFrameCount = 0;
//        requestAnimationFrame( WE_QuizResults_AttemptLoadWidgetTick );
//    }
//}
//
//function WE_QuizResults_RetryScheduleResultsWidget( productsEl )
//{
//    Really_WE_QuizResults_ScheduleResultsWidget( productsEl );
//}


// mw 20260322 : ignore delay parameter, it's always zero and isn't used anyway
// to do : remove it !
function WE_QuizResults_ScheduleResultsWidget( productsEl, delayMs )
{
    if ( productsEl )
    {
        console.log( "[WE Quiz Debug] ScheduleResultsWidget", { delayMs: delayMs, hasECCreateWidget: !!window.EC_CreateWidget } );
        // mw 20260322 : remove check for "hasWidget" here because it's made in WE_QuizResults_LoadWidget
        //var hasWidget = productsEl.querySelector( ".enhanced-commerce-widget" );

        //if ( hasWidget )
        //{
        //    WE_QuizResults_RunEnhanceOnWidgetLoad( );
        //    WE_QuizResults_PopulatePlaceholderImages( );
        //}
        //else
        if ( window.EC_CreateWidget )
        {
            WE_QuizResults_LoadWidget( productsEl );
        }
        else
        {
            // mw 20260322 : removing all polling
            //productsEl._weQuizResultsWidgetRetrying = true;
            //productsEl._weQuizResultsWidgetRetryFrameCount = 0;
            //requestAnimationFrame( WE_QuizResults_AttemptLoadWidgetTick );

            function WE_QuizResults_LoadWidgetOnEcReady( )
            {
                console.log( "[WE Quiz Debug] enhancedcommerce:ready received - loading widget" );
                WE_QuizResults_LoadWidget( productsEl );
                window.removeEventListener( "enhancedcommerce:ready", WE_QuizResults_LoadWidgetOnEcReady );
            }

            window.addEventListener( "enhancedcommerce:ready", WE_QuizResults_LoadWidgetOnEcReady );
            console.log( "[WE Quiz Debug] Waiting for enhancedcommerce:ready event" );

            // Safari can miss enhancedcommerce:ready if it already fired before this listener attached.
            if ( window.EC_CreateWidget )
            {
                console.log( "[WE Quiz Debug] EC_CreateWidget already available, loading immediately" );
                WE_QuizResults_LoadWidgetOnEcReady( );
            }
        }
    }
}

function WE_QuizResults_AttemptLoadWidgetTick( )
{
    const maxFrames = 60;
    var productsEl = null;
    var frameCount = 0;
    var hasWidget = false;
    var shouldContinue = false;

    productsEl = document.querySelector( ".we-onboarding-quiz-results-products" );

    if ( productsEl )
    {
        frameCount = productsEl._weQuizResultsWidgetRetryFrameCount || 0;
        hasWidget = productsEl.querySelector( ".enhanced-commerce-widget" );

        if ( productsEl._weQuizResultsProductsDomCacheRestored )
        {
            hasWidget = true;
            shouldContinue = false;
            productsEl._weQuizResultsWidgetRetrying = false;
        }
        if ( hasWidget )
        {
            productsEl._weQuizResultsWidgetRetrying = false;
        }
        else if ( window.EC_CreateWidget )
        {
            productsEl._weQuizResultsWidgetRetrying = false;
            WE_QuizResults_LoadWidget( productsEl );
        }
        else if ( frameCount < maxFrames )
        {
            productsEl._weQuizResultsWidgetRetryFrameCount = frameCount + 1;
            shouldContinue = true;
        }
        else
        {
            productsEl._weQuizResultsWidgetRetrying = false;
        }
    }

    if ( shouldContinue )
    {
        // No scheduled retries: requestAnimationFrame is disabled.
    }
}

// mw 20260314 : removed this because it was calling the back-end 4 times to show one results slide
//function original_WE_QuizResults_ScheduleResultsWidget( productsEl, delayMs )
//{
//    var attempts    = [ 0 ];
//    var intervalRef = [ null ];
//    var doLoadNow   = false;
//
//    if ( !window._onboardingQuizData.auth )
//    {
//        doLoadNow = true;
//    }
//    else if ( window.SendAPIRequest )
//    {
//        SaveOnboardingQuizState( );
//        doLoadNow = true;
//    }
//
//    if ( doLoadNow )
//    {
//        setTimeout( WE_QuizResults_LoadWidget, delayMs, productsEl );
//    }
//    else
//    {
//        function WE_QuizResults_WaitForApiInterval( )
//        {
//            WE_QuizResults_WaitForApiTick( productsEl, intervalRef, attempts );
//        }
//        intervalRef[ 0 ] = setInterval( WE_QuizResults_WaitForApiInterval, 100 );
//    }
//}

function WE_QuizResults_EnhanceECCards( )
{
    var productsEl = null;
    var cards      = null;
    var i          = 0;
    var card       = null;
    var removeBtn  = null;
    var addBackBtn = null;
    var saveEl     = null;
    var reasonBtn  = null;
    var price      = 0;
    var oldPrice   = 0;
    var pct        = 0;
    var mainPriceEl = null;
    var ecPriceEl   = null;
    var dataString     = "";
    var data           = null;
    var priceEl        = null;
    var oldPriceEl     = null;
    var infoContainer  = null;
    var enhancedCount  = 0;
    var sparkleSvg     = "<svg class=\"we-onboarding-quiz-results-sparkle\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z\"></path><path d=\"M20 3v4\"></path><path d=\"M22 5h-4\"></path><path d=\"M4 17v2\"></path><path d=\"M5 18H3\"></path></svg>";

    productsEl = document.querySelector( ".we-onboarding-quiz-results-products" );
    if ( productsEl )
    {
        cards = productsEl.querySelectorAll( ".product-grid__product-card, .ec-product-card, .product-card" );
        for ( i = 0; i < cards.length; i++ )
        {
            card = cards[ i ];
            if ( !card.getAttribute( "data-variant-id" ) && !card.querySelector( "[data-variant-id]" ) )
            {
                dataString = card.getAttribute( "data-product-data" ) || "";
                data = null;
                try
                {
                    if ( dataString )
                    {
                        data = JSON.parse( dataString );
                    }
                    else
                    {
                        data = null;
                    }
                }
                catch ( err )
                {
                    data = null;
                }
                var resolvedVariantId = WE_QuizResults_GetVariantIdFromProductData( data );
                if ( resolvedVariantId )
                {
                    card.setAttribute( "data-variant-id", resolvedVariantId );
                }
                else
                {
                    resolvedVariantId = WE_QuizResults_GetVariantIdFromCardDom( card );
                    if ( resolvedVariantId )
                    {
                        card.setAttribute( "data-variant-id", resolvedVariantId );
                    }
                    else
                    {
                        WE_QuizResults_AttemptResolveVariantIdForCard( card );
                    }
                }
            }
            if ( !card.classList.contains( "we-quiz-card" ) )
            {
                card.classList.add( "we-quiz-card" );
                enhancedCount++;
            }

            if ( !card.querySelector( ".we-quiz-card__remove" ) )
            {
                removeBtn = document.createElement( "button" );
                removeBtn.setAttribute( "type", "button" );
                removeBtn.setAttribute( "class", "we-quiz-card__remove" );
                removeBtn.setAttribute( "aria-label", "Remove product" );
                removeBtn.textContent = "×";
                card.appendChild( removeBtn );
            }

            if ( !card.querySelector( ".we-quiz-card__add-back" ) )
            {
                addBackBtn = document.createElement( "button" );
                addBackBtn.setAttribute( "type", "button" );
                addBackBtn.setAttribute( "class", "we-quiz-card__add-back" );
                addBackBtn.setAttribute( "aria-label", "Add product back" );
                addBackBtn.setAttribute( "hidden", "hidden" );
                addBackBtn.innerHTML = "<span class=\"we-quiz-card__add-back-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-rotate-ccw\"><path d=\"M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8\"></path><path d=\"M3 3v5h5\"></path></svg></span><span>Add back</span>";
                card.appendChild( addBackBtn );
            }

            var productDataString = card.getAttribute( "data-product-data" ) || "";

            saveEl = card.querySelector( ".we-quiz-card__save" ) || null;
            price = 0;
            oldPrice = 0;
            dataString = productDataString;
            data = null;
            try
            {
                if ( dataString )
                {
                    data = JSON.parse( dataString );
                }
                else
                {
                    data = null;
                }
            }
            catch ( err )
            {
                data = null;
            }
            if ( data && data.attributes )
            {
                price = WE_ParseMoneyValue( data.attributes.price );
                oldPrice = WE_ParseMoneyValue( data.attributes.price_old );
            }
            if ( price <= 0 )
            {
                priceEl = card.querySelector( ".product-card__price__discounted, .ec-product-regular-price" );
                oldPriceEl = card.querySelector( ".product-card__price__full, .ec-product-compare-price, [data-compare-at-price]" );
                if ( priceEl )
                {
                    price = WE_ParseMoneyValue( priceEl.textContent || priceEl.getAttribute( "data-product-price" ) || "" );
                }
                if ( oldPriceEl )
                {
                    oldPrice = WE_ParseMoneyValue( oldPriceEl.textContent || oldPriceEl.getAttribute( "data-compare-at-price" ) || "" );
                }
            }
            if ( oldPrice <= 0 )
            {
                oldPrice = price;
            }
            pct = ( oldPrice > price && oldPrice > 0 ) ? Math.round( ( ( oldPrice - price ) / oldPrice ) * 100 ) : 0;
            if ( !saveEl )
            {
                saveEl = document.createElement( "span" );
                saveEl.className = "we-quiz-card__save";
                saveEl.textContent = "Save " + pct + "%";
                mainPriceEl = card.querySelector( ".product-card__main-price" );
                if ( mainPriceEl )
                {
                    mainPriceEl.appendChild( saveEl );
                }
                else
                {
                    infoContainer = card.querySelector( ".product-card__info-container, a[href].product-card__info-container, .ec-product-info" );
                    if ( infoContainer )
                    {
                        infoContainer.appendChild( saveEl );
                    }
                    else
                    {
                        card.appendChild( saveEl );
                    }
                }
            }
            else
            {
                saveEl.textContent = "Save " + pct + "%";
            }

            mainPriceEl = card.querySelector( ".product-card__main-price" );
            if ( mainPriceEl && saveEl.parentNode != mainPriceEl )
            {
                mainPriceEl.appendChild( saveEl );
            }
            else if ( !mainPriceEl )
            {
                ecPriceEl = card.querySelector( ".ec-product-price" );
                if ( ecPriceEl && saveEl.parentNode != ecPriceEl )
                {
                    ecPriceEl.appendChild( saveEl );
                }
            }

            if ( pct <= 0 )
            {
                saveEl.style.display = "none";
            }
            else
            {
                saveEl.style.display = "";
            }

            if ( !card.querySelector( ".we-quiz-card__reason" ) )
            {
                reasonBtn = document.createElement( "button" );
                reasonBtn.setAttribute( "type", "button" );
                reasonBtn.setAttribute( "class", "we-quiz-card__reason" );
                reasonBtn.setAttribute( "aria-expanded", "false" );
                reasonBtn.innerHTML = sparkleSvg + "<span>Picked for you - see why \u2192</span>";
                infoContainer = card.querySelector( ".product-card__info-container, a[href].product-card__info-container, .ec-product-info" );
                if ( infoContainer )
                {
                    infoContainer.appendChild( reasonBtn );
                }
                else
                {
                    card.insertBefore( reasonBtn, card.querySelector( ".we-quiz-card__remove" ) || null );
                    if ( !reasonBtn.parentNode )
                    {
                        card.appendChild( reasonBtn );
                    }
                }
            }
        }
        if ( productsEl && enhancedCount > 0 )
        {
            if ( !productsEl._weQuizResultsRevealAt || Date.now( ) >= productsEl._weQuizResultsRevealAt )
            {
                productsEl.classList.add( "we-onboarding-quiz-results-products--visible" );
            }
        }
        WE_QuizResults_ForceLoadWidgetImages( productsEl );
    }
    WE_QuizResults_PopulatePlaceholderImages( );
}

function WE_QuizResults_PlaceholderPollTick( )
{
    WE_QuizResults_PopulatePlaceholderImages( );
}

function WE_QuizResults_PlaceholderPollStop( pollId )
{
    clearInterval( pollId );
}

function WE_QuizResults_GetFirstUrlFromSrcset( srcsetValue )
{
    var out = "";
    var first = "";

    if ( srcsetValue )
    {
        first = srcsetValue.split( "," )[ 0 ];
        first = first.trim( );
        if ( first.indexOf( " " ) > -1 )
        {
            first = first.split( " " )[ 0 ];
        }
        out = first;
    }

    return out;
}

function WE_QuizResults_GetMainImageUrl( imgEl )
{
    var url = "";
    var out = "";
    if ( imgEl )
    {
        var dataSrc = "";
        var dataLazySrc = "";
        var srcset = "";

        dataSrc = imgEl.getAttribute( "data-src" ) || "";
        dataLazySrc = imgEl.getAttribute( "data-lazy-src" ) || "";
        srcset = imgEl.getAttribute( "data-srcset" ) || imgEl.getAttribute( "srcset" ) || "";

        if ( dataSrc )
        {
            url = dataSrc;
        }
        else if ( dataLazySrc )
        {
            url = dataLazySrc;
        }
        else if ( srcset )
        {
            url = WE_QuizResults_GetFirstUrlFromSrcset( srcset );
        }
        else
        {
            url = imgEl.getAttribute( "src" ) || ( imgEl.currentSrc || "" ) || "";
        }
    }
    if ( url && url.indexOf( "data:" ) != 0 )
    {
        out = url;
    }
    return out;
}

function WE_QuizResults_PopulatePlaceholderImages( )
{
    const mainImgSel = ".we-quiz-card__image-img, .ec-product-image-container img, .product-card__image img, .product-card__image__img, [id=\"product-card-image-container\"] img";
    var productsEl   = document.querySelector( ".we-onboarding-quiz-results-products" );
    var placeholders = document.querySelectorAll( ".we-onboarding-quiz-custom-picked-product-placeholder" );
    var rawCards     = null;
    var card         = null;
    var imgEl        = null;
    var url          = "";
    var i            = 0;
    var ph           = null;
    var img          = null;
    var dataString   = "";
    var dataObj      = null;
    var dataImg      = "";
    var featureImageNode = null;

    if ( productsEl && placeholders.length != 0 )
    {
        rawCards = productsEl.querySelectorAll( ".ec-product-card, .product-grid__product-card, .we-quiz-card" );
        for ( i = 0; i < placeholders.length; i++ )
        {
            ph = placeholders[ i ];
            if ( i >= rawCards.length )
            {
                ph.innerHTML = "";
                continue;
            }
            card = rawCards[ i ];
            imgEl = card.querySelector( mainImgSel );
            url = WE_QuizResults_GetMainImageUrl( imgEl );
            if ( !url )
            {
                dataString = card.getAttribute( "data-product-data" ) || "";
                dataObj = null;
                dataImg = "";
                try
                {
                    dataObj = dataString ? JSON.parse( dataString ) : null;
                }
                catch ( err )
                {
                    dataObj = null;
                }
                if ( dataObj && dataObj.attributes )
                {
                    dataImg = dataObj.attributes.image_link || dataObj.attributes.image || "";
                }
                if ( !dataImg && dataObj )
                {
                    dataImg = dataObj.image_link || dataObj.image || "";
                }
                url = dataImg || "";
            }
            if ( !url )
            {
                featureImageNode = card.querySelector( "[data-key=\"feature_image\"]" );
                if ( featureImageNode )
                {
                    url = featureImageNode.getAttribute( "data-value" ) || featureImageNode.getAttribute( "src" ) || featureImageNode.getAttribute( "data-src" ) || featureImageNode.getAttribute( "data-lazy-src" ) || "";
                }
            }
            if ( !url )
            {
                continue;
            }
            img = ph.querySelector( "img" );
            if ( img && ( img.getAttribute( "src" ) || "" ) == url )
            {
                continue;
            }
            ph.innerHTML = "";
            img = document.createElement( "img" );
            img.setAttribute( "src", url );
            img.setAttribute( "alt", "" );
            img.setAttribute( "loading", "lazy" );
            ph.appendChild( img );
        }
    }
}

function WE_QuizResults_ForceLoadWidgetImages( productsEl )
{
    var cards      = [];
    var imgEl      = null;
    var dataSrc    = "";
    var src        = "";
    var i          = 0;
    var mainImgSel = ".we-quiz-card__image-img, .ec-product-image-container img, .product-card__image img, .product-card__image__img, [id=\"product-card-image-container\"] img";

    if ( productsEl )
    {
        cards = productsEl.querySelectorAll( ".ec-product-card, .product-grid__product-card, .we-quiz-card" );
        for ( i = 0; i < cards.length; i++ )
        {
            imgEl = cards[ i ].querySelector( mainImgSel );
            if ( !imgEl )
            {
                continue;
            }
            var dataLazySrc = "";
            var srcset = "";

            dataSrc = imgEl.getAttribute( "data-src" ) || "";
            dataLazySrc = imgEl.getAttribute( "data-lazy-src" ) || "";
            srcset = imgEl.getAttribute( "data-srcset" ) || imgEl.getAttribute( "srcset" ) || "";

            if ( !dataSrc && dataLazySrc )
            {
                dataSrc = dataLazySrc;
            }

            if ( !dataSrc && srcset )
            {
                dataSrc = WE_QuizResults_GetFirstUrlFromSrcset( srcset );
            }
            src = imgEl.getAttribute( "src" ) || "";

            if ( dataSrc && src != dataSrc )
            {
                imgEl.setAttribute( "loading", "eager" );
                imgEl.setAttribute( "src", dataSrc );
            }
            else if ( src && src.indexOf( "http" ) == 0 && imgEl.naturalWidth == 0 )
            {
                imgEl.setAttribute( "loading", "eager" );
                imgEl.removeAttribute( "src" );
                imgEl.setAttribute( "src", src );
            }
        }
    }
}

function WE_QuizResults_GetCardVariantId(card) {
    var variantId = "";

    if (card) {
        // 1. Check for direct attribute
        variantId = card.getAttribute("data-variant-id") || "";
        if (variantId) return variantId;

        // 2. Look for data-key elements
        var dataEls = card.querySelectorAll("[data-key]");
        for (var i = 0; i < dataEls.length; i++) {
            var el = dataEls[i];
            var key = el.getAttribute("data-key") || "";
            var value = el.getAttribute("data-value") || el.textContent || "";
            if (key.match(/variants\s*\[\s*0\s*\]\s*\.\s*id|variant_id|variantId/)) {
                variantId = String(value).trim();
                if (variantId) return variantId;
            }
        }

        // fallback
        var atc = card.querySelector( ".ec-add-to-cart" );
        if ( atc && atc.dataset.variantId )
        {
            return atc.dataset.variantId;
        }

        // 3. Parse data-product-data JSON
        var dataStr = card.getAttribute("data-product-data");
        if (dataStr) {
            try {
                var data = JSON.parse(dataStr);
                // Try multiple paths
                variantId = data.variantId || data.variant_id ||
                            (data.variants && data.variants[0] && data.variants[0].id) ||
                            (data.attributes && data.attributes.variant_id) ||
                            (data.attributes && data.attributes.variants && data.attributes.variants[0] && data.attributes.variants[0].id);
                if (variantId) return String(variantId);
            } catch(e) {}
        }
    }
    return variantId;
}

function WE_QuizResults_GetVariantIdFromProductData( data )
{
    var variantId = "";

    if ( data )
    {
        variantId = data.variantId || data.variant_id || "";

        if ( !variantId && data.attributes )
        {
            variantId = data.attributes.variantId || data.attributes.variant_id || "";
        }

        if ( !variantId && data.variant )
        {
            variantId = data.variant.id || data.variant.variantId || data.variant.variant_id || "";
        }

        if ( !variantId && data.variants )
        {
            if ( data.variants.length > 0 )
            {
                variantId = data.variants[ 0 ].id || data.variants[ 0 ].variantId || data.variants[ 0 ].variant_id || "";
            }
        }

        if ( !variantId && data.attributes && data.attributes.variants )
        {
            if ( data.attributes.variants.length > 0 )
            {
                variantId = data.attributes.variants[ 0 ].id || data.attributes.variants[ 0 ].variantId || data.attributes.variants[ 0 ].variant_id || "";
            }
        }

        if ( !variantId && data.attributes && data.attributes.variant )
        {
            variantId = data.attributes.variant.id || data.attributes.variant.variantId || data.attributes.variant.variant_id || "";
        }
    }

    return variantId;
}

function WE_QuizResults_GetVariantIdFromCardDom( card )
{
    var variantId = "";

    if ( card )
    {
        var dataEls = null;
        var i = 0;
        var el = null;
        var key = "";
        var value = "";

        dataEls = card.querySelectorAll( "[data-key]" );

        for ( i = 0; i < dataEls.length; i++ )
        {
            el = dataEls[ i ];
            key = el.getAttribute( "data-key" ) || "";

            if ( key == "variants.[0].id" )
            {
                value = el.getAttribute( "data-value" ) || el.textContent || "";
                variantId = String( value ).trim( );
                break;
            }
            else if ( key == "variants[0].id" )
            {
                value = el.getAttribute( "data-value" ) || el.textContent || "";
                variantId = String( value ).trim( );
                break;
            }
            else if ( key == "variants.[0].variantId" )
            {
                value = el.getAttribute( "data-value" ) || el.textContent || "";
                variantId = String( value ).trim( );
                break;
            }
            else if ( key == "variants[0].variantId" )
            {
                value = el.getAttribute( "data-value" ) || el.textContent || "";
                variantId = String( value ).trim( );
                break;
            }
            else if ( key == "variantId" )
            {
                value = el.getAttribute( "data-value" ) || el.textContent || "";
                variantId = String( value ).trim( );
                break;
            }
            else if ( key == "variant_id" )
            {
                value = el.getAttribute( "data-value" ) || el.textContent || "";
                variantId = String( value ).trim( );
                break;
            }
            else if ( key.indexOf( "variants" ) >= 0 && ( key.indexOf( ".id" ) >= 0 || key.indexOf( "variant_id" ) >= 0 || key.indexOf( "variantId" ) >= 0 ) )
            {
                value = el.getAttribute( "data-value" ) || el.textContent || "";
                variantId = String( value ).trim( );
                break;
            }
        }
    }

    return variantId;
}

function WE_QuizResults_GetProductHandleFromCard( card )
{
    var handle = "";
    var linkEl = null;
    var href   = "";
    var match  = null;
    var handleEl = null;
    var keyValue = "";

    if ( card )
    {
        linkEl = card.querySelector( "a[href*=\"/products/\"]" );
        if ( linkEl )
        {
            href = linkEl.getAttribute( "href" ) || "";
            match = href.match( /\/products\/([^/?]+)/ );
            if ( match && match[ 1 ] )
            {
                handle = match[ 1 ];
            }
        }

        if ( !handle )
        {
            handleEl = card.querySelector( '[data-key="handle"], [data-key="product.handle"], [data-key="productHandle"]' );
            if ( handleEl )
            {
                keyValue = handleEl.getAttribute( "data-value" ) || handleEl.textContent || "";
                handle = keyValue.trim( );
            }
        }
    }

    return handle;
}

function WE_QuizResults_GetCardRegularPriceValue( card )
{
    var priceVal = "";
    var priceEl  = null;

    if ( card )
    {
        priceEl = card.querySelector( "[data-key=\"variants.[0].price\"], .ec-product-regular-price, #product-card-regular-price" );
        if ( priceEl )
        {
            priceVal = priceEl.getAttribute( "data-value" ) || priceEl.textContent || "";
        }
        else
        {
            priceEl = card.querySelector( ".product-card__price__discounted, .ec-product-price" );
            if ( priceEl )
            {
                priceVal = priceEl.textContent || "";
            }
        }
    }

    return WE_ParseMoneyValue( priceVal );
}

function WE_QuizResults_QueueEnhanceAfterVariantResolution( )
{
    var productsEl = document.querySelector( ".we-onboarding-quiz-results-products" );
    if ( productsEl && productsEl._weQuizResultsVariantResolveEnhanceQueued != true )
    {
        productsEl._weQuizResultsVariantResolveEnhanceQueued = true;
        WE_QuizResults_RunVariantResolveEnhanceTick( );
    }
}

function WE_QuizResults_RunVariantResolveEnhanceTick( )
{
    var productsEl = document.querySelector( ".we-onboarding-quiz-results-products" );
    if ( productsEl )
    {
        productsEl._weQuizResultsVariantResolveEnhanceQueued = false;
    }

    WE_QuizResults_EnhanceECCards( );
    WE_QuizResults_RecalculateFooterUI( );
}

async function WE_QuizResults_AttemptResolveVariantIdForCard( card )
{
    var handle = "";
    var regularPrice = 0;
    var productsJson = null;
    var variants = null;
    var variant = null;
    var variantId = "";
    var i = 0;

    if ( !card )
    {
        return false;
    }

    if ( card._weQuizResultsVariantResolveStarted == true )
    {
        return false;
    }

    if ( card.getAttribute( "data-variant-id" ) )
    {
        return false;
    }

    card._weQuizResultsVariantResolveStarted = true;

    handle = WE_QuizResults_GetProductHandleFromCard( card );
    if ( !handle )
    {
        return false;
    }

    regularPrice = WE_QuizResults_GetCardRegularPriceValue( card );

    try
    {
        var response = await fetch( "/products/" + handle + ".js" );
        productsJson = await response.json( );
    }
    catch ( err )
    {
        productsJson = null;
    }

    if ( !productsJson || !productsJson.variants )
    {
        return false;
    }

    variants = productsJson.variants;

    if ( !variants || !variants.length )
    {
        return false;
    }

    for ( i = 0; i < variants.length; i++ )
    {
        if ( variants[ i ] && variants[ i ].id )
        {
            if ( regularPrice > 0 )
            {
                if ( WE_ParseMoneyValue( variants[ i ].price ) == regularPrice )
                {
                    variant = variants[ i ];
                    break;
                }
            }
        }
    }

    if ( !variant && variants.length > 0 )
    {
        variant = variants[ 0 ];
    }

    if ( variant && variant.id )
    {
        variantId = String( variant.id );
        card.setAttribute( "data-variant-id", variantId );
        WE_QuizResults_QueueEnhanceAfterVariantResolution( );
        return true;
    }

    return false;
}

function WE_QuizResults_GetImagesCacheKeyName( )
{
    return LOCALSTORAGE_KEY_NAME + "_results_images_cache_v1";
}

function WE_QuizResults_SaveCachedProductImages( productsEl )
{
    var cacheKey  = "";
    var cached     = null;
    var images     = {};
    var resolvedCount = 0;
    var cards      = null;
    var card       = null;
    var imgEl      = null;
    var variantId  = "";
    var url        = "";
    var mainImgSel = ".we-quiz-card__image-img, .ec-product-image-container img, .product-card__image img, .product-card__image__img, [id=\"product-card-image-container\"] img";
    var i          = 0;

    if ( productsEl && !productsEl._weQuizResultsImagesCacheSaved )
    {
        cards = productsEl.querySelectorAll( ".ec-product-card, .product-grid__product-card, .we-quiz-card" );
        for ( i = 0; i < cards.length; i++ )
        {
            card = cards[ i ];
            variantId = WE_QuizResults_GetCardVariantId( card );
            if ( !variantId )
            {
                continue;
            }

            imgEl = card.querySelector( mainImgSel );
            if ( !imgEl )
            {
                continue;
            }

            url = WE_QuizResults_GetMainImageUrl( imgEl );
            if ( url && url.indexOf( "data:" ) != 0 && url != "" )
            {
                images[ variantId ] = url;
                resolvedCount++;
            }
        }

        if ( resolvedCount > 0 )
        {
            cacheKey = WE_QuizResults_GetImagesCacheKeyName( );
            cached = {
                "imagesByVariant" : images
            };
            window.localStorage.setItem( cacheKey, JSON.stringify( cached ) );
            productsEl._weQuizResultsImagesCacheSaved = true;
        }
    }
}

function WE_QuizResults_ApplyCachedProductImages( productsEl )
{
    var cacheKey = "";
    var cachedStr = "";
    var cached = null;
    var imagesByVariant = null;
    var imagesByProductKey = null;
    var imagesByIndex = null;
    var cards      = null;
    var card       = null;
    var imgEl      = null;
    var variantId  = "";
    var productKey = "";
    var url        = "";
    var src        = "";
    var mainImgSel = ".we-quiz-card__image-img, .ec-product-image-container img, .product-card__image img, .product-card__image__img, [id=\"product-card-image-container\"] img";
    var i          = 0;
    var appliedAny = false;

    if ( productsEl )
    {
        WE_QuizResults_BuildImagesCacheFromWidgetHtmlIfNeeded( );

        cacheKey = WE_QuizResults_GetImagesCacheKeyName( );
        cachedStr = window.localStorage.getItem( cacheKey );
        if ( cachedStr )
        {
            try
            {
                cached = JSON.parse( cachedStr );
            }
            catch ( e )
            {
                cached = null;
            }
        }

        if ( cached && cached.imagesByVariant )
        {
            imagesByVariant = cached.imagesByVariant;
        }

        if ( cached && cached.imagesByProductKey )
        {
            imagesByProductKey = cached.imagesByProductKey;
        }

        if ( cached && cached.imagesByIndex )
        {
            imagesByIndex = cached.imagesByIndex;
        }

        if ( cached )
        {
            cards = productsEl.querySelectorAll( ".ec-product-card, .product-grid__product-card, .we-quiz-card" );
            for ( i = 0; i < cards.length; i++ )
            {
                card = cards[ i ];
                variantId = WE_QuizResults_GetCardVariantId( card );
                productKey = WE_QuizResults_GetProductKeyForCard( card );

                url = "";

                if ( imagesByProductKey && productKey )
                {
                    url = imagesByProductKey[ productKey ];
                }

                if ( !url && imagesByVariant && variantId )
                {
                    url = imagesByVariant[ variantId ];
                }

                if ( !url && imagesByIndex && ( i < imagesByIndex.length ) )
                {
                    url = imagesByIndex[ i ];
                }

                if ( !url )
                {
                    continue;
                }

                imgEl = card.querySelector( mainImgSel );
                if ( !imgEl )
                {
                    continue;
                }

                src = imgEl.getAttribute( "src" ) || "";
                if ( !src || ( src.indexOf( "data:" ) == 0 ) || src != url )
                {
                    imgEl.setAttribute( "loading", "eager" );
                    imgEl.setAttribute( "src", url );
                    appliedAny = true;
                }
            }
        }
    }

    if ( productsEl && appliedAny )
    {
        productsEl._weQuizResultsImagesAppliedCached = true;
    }
}

function WE_QuizResults_GetVariantCacheKeyName( )
{
    return LOCALSTORAGE_KEY_NAME + "_results_variant_cache_v1";
}

function WE_QuizResults_SaveVariantIdCacheFromWidgetHtmlIfNeeded( )
{
    var variantCacheKey = "";
    var variantCacheStr = "";
    var variantCache = null;
    var shouldBuild = true;

    variantCacheKey = WE_QuizResults_GetVariantCacheKeyName( );
    variantCacheStr = window.localStorage.getItem( variantCacheKey );
    if ( variantCacheStr )
    {
        try
        {
            variantCache = JSON.parse( variantCacheStr );
        }
        catch ( e )
        {
            variantCache = null;
        }

        if ( variantCache && variantCache.variantByProductKey && Object.keys( variantCache.variantByProductKey ).length > 0 )
        {
            shouldBuild = false;
        }
    }

    var widgetCacheKey = LOCALSTORAGE_KEY_NAME + "_results_cache_v1";
    var widgetCacheStr = window.localStorage.getItem( widgetCacheKey );
    var hasWidgetCache = false;
    if ( widgetCacheStr )
    {
        hasWidgetCache = true;
    }

    if ( shouldBuild && hasWidgetCache )
    {
        var widgetCache = null;
        try
        {
            widgetCache = JSON.parse( widgetCacheStr );
        }
        catch ( e )
        {
            widgetCache = null;
        }

        if ( widgetCache && widgetCache.widgetHtml )
        {
            var parser = new DOMParser( );
            var doc = parser.parseFromString( widgetCache.widgetHtml, "text/html" );
            var productCards = doc.querySelectorAll( ".ec-product-card, .product-grid__product-card .ec-product-card, .product-grid__product-card, .we-quiz-card" );

            var variantByProductKey = {};
            var i = 0;

            for ( i = 0; i < productCards.length; i++ )
            {
                var card = productCards[ i ];
                var productKey = WE_QuizResults_GetProductKeyForCard( card );
                var variantId = "";
                var idEl = null;

                if ( productKey )
                {
                    idEl = card.querySelector( '[data-key="variants.[0].id"], [data-key="variants[0].id"], [data-key="variant_id"], [data-key="variantId"], [data-key="variants[0].variantId"], [data-key="variants.[0].variantId"]' );
                    if ( idEl )
                    {
                        variantId = ( idEl.getAttribute( "data-value" ) || idEl.textContent || "" ).trim( );
                    }

                    if ( variantId )
                    {
                        variantByProductKey[ productKey ] = variantId;
                    }
                }
            }

            var payload = {
                "variantByProductKey" : variantByProductKey
            };
            window.localStorage.setItem( variantCacheKey, JSON.stringify( payload ) );
        }
    }
}

function WE_QuizResults_ApplyCachedVariantIds( productsEl )
{
    var variantCacheKey = "";
    var variantCacheStr = "";
    var variantCache = null;
    var variantByProductKey = null;
    var cards = null;
    var i = 0;
    var card = null;
    var productKey = "";
    var variantId = "";

    var canApply = false;

    if ( productsEl && !productsEl._weQuizResultsVariantIdsApplied )
    {
        canApply = true;
    }

    if ( canApply )
    {
        WE_QuizResults_SaveVariantIdCacheFromWidgetHtmlIfNeeded( );

        variantCacheKey = WE_QuizResults_GetVariantCacheKeyName( );
        variantCacheStr = window.localStorage.getItem( variantCacheKey );
        if ( variantCacheStr )
        {
            try
            {
                variantCache = JSON.parse( variantCacheStr );
            }
            catch ( e )
            {
                variantCache = null;
            }
        }

        if ( variantCache && variantCache.variantByProductKey )
        {
            variantByProductKey = variantCache.variantByProductKey;
            cards = productsEl.querySelectorAll( ".ec-product-card, .product-grid__product-card, .we-quiz-card" );

            for ( i = 0; i < cards.length; i++ )
            {
                card = cards[ i ];
                if ( card.getAttribute( "data-variant-id" ) || card.querySelector( "[data-variant-id]" ) )
                {
                    continue;
                }

                productKey = WE_QuizResults_GetProductKeyForCard( card );
                if ( !productKey )
                {
                    continue;
                }

                variantId = variantByProductKey[ productKey ];
                if ( variantId )
                {
                    card.setAttribute( "data-variant-id", variantId );
                }
            }
        }

        productsEl._weQuizResultsVariantIdsApplied = true;
    }
}

function WE_QuizResults_GetProductKeyForCard( card )
{
    var vendorEl = null;
    var titleEl = null;
    var vendor = "";
    var title = "";
    var key = "";

    if ( card )
    {
        vendorEl = card.querySelector( ".ec-product-vendor, .product-card__brand, .we-quiz-card__vendor, [data-key=\"vendor\"]" );
        if ( vendorEl )
        {
            vendor = ( vendorEl.textContent || "" ).trim( );
        }

        titleEl = card.querySelector( ".ec-product-title, .product-card__title, .we-quiz-card__title, [data-key=\"title\"]" );
        if ( titleEl )
        {
            title = ( titleEl.textContent || "" ).trim( );
        }

        if ( vendor && title )
        {
            key = vendor + "::" + title;
        }
    }

    return key;
}

function WE_QuizResults_BuildImagesCacheFromWidgetHtmlIfNeeded( )
{
    var imagesCacheKey = "";
    var imagesCacheStr = "";
    var imagesCache = null;
    var cachedOk = false;
    var shouldBuild = false;

    imagesCacheKey = WE_QuizResults_GetImagesCacheKeyName( );
    imagesCacheStr = window.localStorage.getItem( imagesCacheKey );
    if ( imagesCacheStr )
    {
        try
        {
            imagesCache = JSON.parse( imagesCacheStr );
        }
        catch ( e )
        {
            imagesCache = null;
        }

        if ( imagesCache && imagesCache.imagesByProductKey && imagesCache.imagesByIndex && imagesCache.imagesByIndex.length > 0 )
        {
            cachedOk = true;
        }
    }

    if ( cachedOk )
    {
        shouldBuild = false;
    }
    else
    {
        shouldBuild = true;
    }

    if ( shouldBuild )
    {
        var widgetCacheKey = LOCALSTORAGE_KEY_NAME + "_results_cache_v1";
        var widgetCacheStr = window.localStorage.getItem( widgetCacheKey );
        if ( widgetCacheStr )
        {
            var widgetCache = null;
            try
            {
                widgetCache = JSON.parse( widgetCacheStr );
            }
            catch ( e )
            {
                widgetCache = null;
            }

            if ( widgetCache && widgetCache.widgetHtml )
            {
                var parser = new DOMParser( );
                var doc = parser.parseFromString( widgetCache.widgetHtml, "text/html" );
                var productEls = doc.querySelectorAll( ".ec-product-card, .product-grid__product-card, .we-quiz-card" );

                var imagesByProductKey = {};
                var imagesByIndex = [];
                var i = 0;

                for ( i = 0; i < productEls.length; i++ )
                {
                    var card = productEls[ i ];
                    var imgEl = card.querySelector( ".ec-product-image-container img, img" );
                    var url = "";
                    var key = "";

                    if ( imgEl )
                    {
                        url = imgEl.getAttribute( "src" ) || "";
                        url = url.trim( );
                    }

                    key = WE_QuizResults_GetProductKeyForCard( card );

                    if ( url )
                    {
                        imagesByIndex.push( url );
                        if ( key )
                        {
                            imagesByProductKey[ key ] = url;
                        }
                    }
                }

                var payload = {
                    "imagesByVariant" : { },
                    "imagesByProductKey" : imagesByProductKey,
                    "imagesByIndex" : imagesByIndex
                };

                window.localStorage.setItem( imagesCacheKey, JSON.stringify( payload ) );
            }
        }
    }
}

function WE_QuizResults_GetActiveCards( )
{
    var cards      = null;
    var ecCards    = null;
    var active     = [];
    var i          = 0;
    var card       = null;
    var productsEl = null;

    cards = document.querySelectorAll( ".we-quiz-card" );
    for ( i = 0; i < cards.length; i++ )
    {
        if ( cards[ i ].classList.contains( "we-quiz-card--removed" ) == false && active.indexOf( cards[ i ] ) == -1 )
        {
            active.push( cards[ i ] );
        }
    }

    productsEl = document.querySelector( ".we-onboarding-quiz-results-products" );
    if ( productsEl )
    {
        ecCards = productsEl.querySelectorAll( ".product-grid__product-card, .ec-product-card, .product-card" );
        for ( i = 0; i < ecCards.length; i++ )
        {
            card = ecCards[ i ];
            if ( !card.classList.contains( "we-quiz-card" ) && !card.classList.contains( "we-quiz-card--removed" ) && active.indexOf( card ) == -1 )
            {
                active.push( card );
            }
        }
    }

    return active;
}

function WE_QuizResults_UpdateItemCountUI( activeCount )
{
    var countEl = null;

    countEl = document.querySelector( ".we-onboarding-quiz-results-item-count" );

    if ( countEl )
    {
        countEl.textContent = String( activeCount );
    }
}

function WE_QuizResults_UpdateTotalsUI( total, save )
{
    var totalEl = null;
    var saveEl  = null;

    totalEl = document.querySelector( ".we-onboarding-quiz-results-total-amount" );
    saveEl  = document.querySelector( ".we-onboarding-quiz-results-save-amount" );

    if ( totalEl )
    {
        totalEl.textContent = "£" + total.toFixed( 2 );
    }

    if ( saveEl )
    {
        saveEl.textContent = "£" + save.toFixed( 2 );
    }
}

function WE_QuizResults_ParseCardPriceAndLabels( card )
{
    var dataString = "";
    var data       = null;
    var price      = 0;
    var oldPrice   = 0;
    var priceEl    = null;
    var oldPriceEl = null;
    var titleEl    = null;
    var vendorEl   = null;
    var item_name  = "";
    var item_brand = "";

    if ( card )
    {
        titleEl  = card.querySelector( ".ec-product-title, .product-card__title, .we-quiz-card__title, [data-key=\"title\"]" );
        vendorEl = card.querySelector( ".ec-product-vendor, .product-card__brand, .we-quiz-card__vendor, [data-key=\"vendor\"]" );

        if ( titleEl )
        {
            item_name = ( titleEl.textContent || "" ).trim( );
        }
        if ( vendorEl )
        {
            item_brand = ( vendorEl.textContent || "" ).trim( );
        }

        dataString = card.getAttribute( "data-product-data" ) || "";

        if ( dataString )
        {
            try
            {
                data = JSON.parse( dataString );
            }
            catch ( err )
            {
                data = null;
            }

            if ( data && data.attributes )
            {
                price    = WE_ParseMoneyValue( data.attributes.price );
                oldPrice = WE_ParseMoneyValue( data.attributes.price_old );
            }
        }

        if ( price <= 0 )
        {
            priceEl    = card.querySelector( ".product-card__price__discounted, .ec-product-price" );
            oldPriceEl = card.querySelector( ".product-card__price__full" );
            if ( priceEl )
            {
                price = WE_ParseMoneyValue( priceEl.textContent || "" );
            }
            if ( price <= 0 )
            {
                priceEl = card.querySelector( "[data-product-price]" );
                if ( priceEl )
                {
                    price = WE_ParseMoneyValue( priceEl.getAttribute( "data-product-price" ) || "" );
                }
            }
            if ( oldPriceEl )
            {
                oldPrice = WE_ParseMoneyValue( oldPriceEl.textContent || "" );
            }
            if ( oldPrice <= 0 )
            {
                oldPriceEl = card.querySelector( "[data-compare-at-price]" );
                if ( oldPriceEl )
                {
                    oldPrice = WE_ParseMoneyValue( oldPriceEl.getAttribute( "data-compare-at-price" ) || "" );
                }
            }
            if ( oldPrice <= 0 )
            {
                oldPrice = price;
            }
        }
    }

    return { price: price, oldPrice: oldPrice, item_name: item_name, item_brand: item_brand };
}

function WE_QuizResults_RecalculateFooterUI( )
{
    var activeCards = [];
    var total       = 0;
    var save        = 0;
    var i           = 0;
    var card        = null;
    var parsed      = null;
    var price       = 0;
    var oldPrice    = 0;

    activeCards = WE_QuizResults_GetActiveCards( );

    for ( i = 0; i < activeCards.length; i++ )
    {
        card   = activeCards[ i ];
        parsed = WE_QuizResults_ParseCardPriceAndLabels( card );
        price  = parsed.price;
        oldPrice = parsed.oldPrice;

        if ( price > 0 )
        {
            total += price;
            if ( oldPrice > price )
            {
                save += ( oldPrice - price );
            }
        }
    }

    WE_QuizResults_UpdateItemCountUI( activeCards.length );
    WE_QuizResults_UpdateTotalsUI( total, save );
}

function WE_QuizResults_SetAddToCartLoading( button, isLoading )
{
    if ( isLoading )
    {
        button.setAttribute( "aria-busy", "true" );
        button.setAttribute( "disabled", "disabled" );
        button.classList.add( "is-loading" );
    }
    else
    {
        button.removeAttribute( "aria-busy" );
        button.removeAttribute( "disabled" );
        button.classList.remove( "is-loading" );
    }
}

function WE_QuizResults_SetAddToCartMessage( button, message )
{
    var original = "";

    original = button.getAttribute( "data-original-text" ) || "";

    if ( original == "" )
    {
        button.setAttribute( "data-original-text", button.textContent || "" );
    }

    button.textContent = message;
}

function WE_QuizResults_ResetAddToCartMessage( button )
{
    var original = "";

    original = button.getAttribute( "data-original-text" ) || "";

    if ( original )
    {
        button.textContent = original;
    }
}

function WE_QuizResults_BuildActiveVariantItems( )
{
    var activeCards = [];
    var items       = [];
    var i           = 0;
    var card        = null;
    var variantId   = "";
    var sellingPlan = null;
    var spEl        = null;

    activeCards = WE_QuizResults_GetActiveCards( );

    for ( i = 0; i < activeCards.length; i++ )
    {
        card      = activeCards[ i ];
        variantId = WE_QuizResults_GetCardVariantId( card );

        if ( variantId )
        {
            var item = { "id": variantId, "quantity": 1, "_card": card };
            items.push( item );
        }
    }

    return items;
}

function WE_QuizResults_FindVariantById( variants, variantId )
{
    var i   = 0;
    var out = null;

    for ( i = 0; i < variants.length; i++ )
    {
        if ( String( variants[ i ].id ) == String( variantId ) )
        {
            out = variants[ i ];
            break;
        }
    }
    return out;
}

async function WE_QuizResults_FetchSellingPlanForVariant( card, variantId )
{
    var link    = null;
    var match   = null;
    var handle  = null;
    var product = null;
    var v       = null;
    var spid    = null;
    var result  = null;

    if ( card )
    {
        link = card.querySelector( "a[href*='/products/']" );
        if ( link && link.href )
        {
            match = link.getAttribute( "href" ).match( /\/products\/([^\/\?]+)/ );
            if ( match && match[ 1 ] )
            {
                handle = match[ 1 ];
                try
                {
                    product = await fetch( "/products/" + handle + ".js" ).then( function WE_QuizResults_FetchProductJson( r ) { return r.json( ); } );
                }
                catch ( err )
                {
                }
                if ( product && product.variants )
                {
                    v = WE_QuizResults_FindVariantById( product.variants, variantId );
                    if ( v && v.selling_plan_allocations && v.selling_plan_allocations.length > 0 )
                    {
                        spid = v.selling_plan_allocations[ 0 ].selling_plan_id;
                    }
                }
                result = spid || null;
            }
        }
    }
    return result;
}

function WE_QuizResults_GetEcSid( )
{
    var sid = null;

    try
    {
        sid = window.localStorage.getItem( "EC_SID" );
    }
    catch ( e )
    {
    }

    return sid;
}

function WE_QuizResults_MapItemToCartItem( it )
{
    var out        = { "id": it.id, "quantity": it.quantity };
    var sid        = WE_QuizResults_GetEcSid( );
    var widgetName = WE_QuizResults_EcWidgetName( );

    if ( it.selling_plan )
    {
        out.selling_plan = it.selling_plan;
    }

    // Never emit a blank property — cart.liquid treats blank as non-quiz cart
    out.properties = { "_enhancedcommerce": sid || "quiz", "_ec_widget": widgetName };
    return out;
}

function WE_QuizResults_FetchWithTimeout( url, opts, ms )
{
    var controller = new AbortController();
    var timer = setTimeout( function FetchTimeout_Abort() { controller.abort(); }, ms );
    opts.signal = controller.signal;
    return fetch( url, opts ).then( function FetchTimeout_Clear( r ) { clearTimeout( timer ); return r; } );
}

function WE_QuizResults_GetAddToCartLoadingOverlay( )
{
    var el = document.querySelector( ".we-onboarding-quiz-add-to-cart-loading" );
    if ( !el )
    {
        el = document.createElement( "div" );
        el.className = "we-onboarding-quiz-add-to-cart-loading hidden";
        el.setAttribute( "aria-hidden", "true" );
        el.innerHTML = "<div class=\"we-onboarding-quiz-add-to-cart-loading__text-wrap\"><span class=\"we-onboarding-quiz-add-to-cart-loading__text\">Filling up your basket... good things take a moment</span></div><div class=\"we-onboarding-quiz-add-to-cart-loading__circle\"></div>";
        document.body.appendChild( el );
    }
    return el;
}

function WE_QuizResults_ShowAddToCartLoadingOverlay( )
{
    var el = WE_QuizResults_GetAddToCartLoadingOverlay( );
    el.classList.remove( "hidden" );
    el.setAttribute( "aria-hidden", "false" );
}

function WE_QuizResults_HideAddToCartLoadingOverlay( )
{
    var el = document.querySelector( ".we-onboarding-quiz-add-to-cart-loading" );
    if ( el )
    {
        el.classList.add( "hidden" );
        el.setAttribute( "aria-hidden", "true" );
    }
}

async function WE_QuizResults_FetchSellingPlanForVariant( card, variantId )
{
    var link    = null;
    var match   = null;
    var handle  = null;
    var product = null;
    var v       = null;
    var spid    = null;
    var result  = null;

    if ( card )
    {
        link = card.querySelector( "a[href*='/products/']" );
        if ( link && link.href )
        {
            match = link.getAttribute( "href" ).match( /\/products\/([^\/\?]+)/ );
            if ( match && match[ 1 ] )
            {
                handle = match[ 1 ];
                try
                {
                    product = await fetch( "/products/" + handle + ".js" ).then( function WE_QuizResults_FetchProductJson( r ) { return r.json( ); } );
                }
                catch ( err )
                {
                }
                if ( product && product.variants )
                {
                    v = WE_QuizResults_FindVariantById( product.variants, variantId );
                    if ( v && v.selling_plan_allocations && v.selling_plan_allocations.length > 0 )
                    {
                        spid = v.selling_plan_allocations[ 0 ].selling_plan_id;
                    }
                }
                result = spid || null;
            }
        }
    }
    return result;
}

async function WE_QuizResults_RemoveInCartItems( items )
{
    var cart = null;
    var inCartKeys = {};
    var filtered = [];
    var i = 0;
    var line = null;
    var result = items;

    if ( items && items.length > 0 )
    {
        try
        {
            cart = await fetch( "/cart.js", { headers: { "Accept": "application/json" } } ).then( function WE_QuizResults_ReadCartJson( r ) { return r.json( ); } );
        }
        catch ( err )
        {
            cart = null;
        }

        if ( cart && cart.items )
        {
            for ( i = 0; i < cart.items.length; i++ )
            {
                line = cart.items[ i ];
                inCartKeys[ String( line.variant_id ) ] = true;
            }

            for ( i = 0; i < items.length; i++ )
            {
                if ( !inCartKeys[ String( items[ i ].id ) ] )
                {
                    filtered.push( items[ i ] );
                }
            }

            result = filtered;
        }
    }

    return result;
}

async function WE_QuizResults_FetchVariantAvailable( handle, variantId )
{
    var isAvailable = true;
    var productsJson = null;
    var variants = null;
    var i = 0;

    if ( !handle || !variantId )
    {
        return isAvailable;
    }

    try
    {
        productsJson = await fetch( "/products/" + handle + ".js" ).then( function WE_QuizResults_ReadProductJson( r ) { return r.json( ); } );
    }
    catch ( err )
    {
        productsJson = null;
    }

    if ( productsJson && productsJson.variants )
    {
        variants = productsJson.variants;

        for ( i = 0; i < variants.length; i++ )
        {
            if ( String( variants[ i ].id ) == String( variantId ) )
            {
                isAvailable = variants[ i ].available != false;
            }
        }
    }

    return isAvailable;
}

function WE_QuizResults_EcWidgetName( )
{
    var name = "";

    if ( window._onboardingQuizData && window._onboardingQuizData.ecWidgetName )
    {
        name = String( window._onboardingQuizData.ecWidgetName );
    }

    return name;
}

function WE_QuizResults_PushEcAtcClicks( addedLineItems )
{
    var widgetName = WE_QuizResults_EcWidgetName( );
    var event      = null;
    var i          = 0;

    if ( widgetName != "" && window._enhancedCommerceQ )
    {
        for ( i = 0; i < addedLineItems.length; i++ )
        {
            event = { "eventType" : "add_to_cart", "variantID" : String( addedLineItems[ i ].id ), "widgetName" : widgetName };
            window._enhancedCommerceQ.push( { "command" : "track", "event" : event } );
        }
    }
}

async function WE_QuizResults_AddActiveToCart( button, skipInCart )
{
    var items         = [];
    var i             = 0;
    var cartItems     = [];
    var response      = null;
    var added         = 0;
    var failed        = 0;
    var builtCount    = 0;
    var availableItems = [];
    var oosCount      = 0;
    var cardHandle    = "";
    var addedLineItems = [];

    try
    {
        items = WE_QuizResults_BuildActiveVariantItems( );

        WE_QuizResults_SetAddToCartLoading( button, true );

        builtCount = items.length;

        if ( skipInCart )
        {
            // Skip variants already in cart so repeat Reveal never double-adds.
            // Returning builtCount when all are present still routes to cart.
            items = await WE_QuizResults_RemoveInCartItems( items );
        }

        // Drop sold-out variants up front: Shopify rejects the whole bulk
        // add when any line is out of stock.
        availableItems = [];
        oosCount = 0;

        var checkPromises = items.map( function( item )
        {
            var handle = "";

            if ( item._card )
            {
                handle = WE_QuizResults_GetProductHandleFromCard( item._card );
            }

            return WE_QuizResults_FetchVariantAvailable( handle, item.id ).then( function( ok ) { return { item: item, ok: ok }; } );
        } );

        var checkResults = await Promise.all( checkPromises );

        for ( i = 0; i < checkResults.length; i++ )
        {
            if ( checkResults[ i ].ok )
            {
                availableItems.push( checkResults[ i ].item );
            }
            else
            {
                oosCount++;
            }
        }

        items = availableItems;

        if ( oosCount > 0 )
        {
            console.log( "[WE Quiz ATC] Items skipped as sold out", oosCount );
        }

        if ( items.length < 1 )
        {
            WE_QuizResults_SetAddToCartLoading( button, false );

            if ( builtCount > 0 && oosCount == 0 )
            {
                return builtCount;
            }

            if ( oosCount > 0 )
            {
                WE_QuizResults_SetAddToCartMessage( button, "Some items are out of stock" );
            }
            else
            {
                WE_QuizResults_SetAddToCartMessage( button, "No items to add" );
            }

            return 0;
        }
        else
        {
            WE_QuizResults_SetAddToCartMessage( button, "Adding..." );

            cartItems = items.map( WE_QuizResults_MapItemToCartItem );
            response = await WE_QuizResults_FetchWithTimeout(
                "/cart/add.js?sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template,welleasy-new-old-cart",
                {
                    "method": "POST",
                    "headers":
                    {
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    },
                    "body": JSON.stringify( { "items": cartItems } )
                },
                15000
            );
            if ( response.ok )
            {
                added            = items.length;
                failed           = 0;
                addedLineItems   = items.slice( );
            }
            else
            {
                added          = 0;
                failed         = 0;
                addedLineItems = [ ];
                for ( i = 0; i < cartItems.length; i++ )
                {
                    response = await WE_QuizResults_FetchWithTimeout(
                        "/cart/add.js?sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template,welleasy-new-old-cart",
                        {
                            "method": "POST",
                            "headers":
                            {
                                "Content-Type": "application/json",
                                "Accept": "application/json"
                            },
                            "body": JSON.stringify( { "items": [ cartItems[ i ] ] } )
                        },
                        15000
                    );
                    if ( response.ok )
                    {
                        added++;
                        addedLineItems.push( items[ i ] );
                    }
                    else
                    {
                        failed++;
                    }
                }
            }

            if ( failed > 0 )
            {
                console.log( "[WE Quiz ATC] Items failed to add", { failed: failed } );
            }

            if ( added > 0 )
            {
                WE_QuizResults_PushEcAtcClicks( addedLineItems );
                WE_QuizTracking_PushResultsPageAddToCart( addedLineItems );
            }

            if ( added > 0 )
            {
                document.dispatchEvent(
                    new CustomEvent(
                        "cart:updated",
                        {
                            "detail":
                            {
                                "source": "we-onboarding-quiz-results"
                            }
                        }
                    )
                );
            }

            WE_QuizResults_SetAddToCartLoading( button, false );
            return added;
        }
    }
    catch ( err )
    {
        console.error("Add to cart error:", err);
        WE_QuizResults_SetAddToCartLoading( button, false );
        throw err;
    }
}

function WE_OnboardingQuizResults_OnClick( e )
{
    var target      = null;
    var removeBtn   = null;
    var addBackBtn  = null;
    var reasonBtn   = null;
    var closeBtn    = null;
    var atcBtn      = null;
    var card        = null;
    var handled     = false;
    var drawer      = null;
    var panel       = null;
    var productLink = null;
    var resultsArea = null;
    var unenhanced  = null;

    target = e.target;

    if ( target && target.closest )
    {
        resultsArea = target.closest( ".we-onboarding-quiz-results-products" );
        if ( resultsArea )
        {
            unenhanced = target.closest( ".product-grid__product-card, .ec-product-card, .product-card" );
            if ( unenhanced && !unenhanced.querySelector( ".we-quiz-card__remove" ) )
            {
                WE_QuizResults_RunEnhanceOnWidgetLoad( );
            }
        }

        removeBtn  = target.closest( ".we-quiz-card__remove" );
        addBackBtn = target.closest( ".we-quiz-card__add-back" );
        reasonBtn  = target.closest( ".we-quiz-card__reason" );
        closeBtn   = target.closest( "[data-we-quiz-drawer-close]" );
        atcBtn     = target.closest( ".we-onboarding-quiz-results-add-to-cart" );

        if ( removeBtn )
        {
            card = removeBtn.closest( ".we-quiz-card" );

            if ( card )
            {
                WE_OnboardingQuizResults_SetQuizCardRemovedState( card, true );
                handled = true;
            }
        }
        else if ( addBackBtn )
        {
            card = addBackBtn.closest( ".we-quiz-card" );

            if ( card )
            {
                WE_OnboardingQuizResults_SetQuizCardRemovedState( card, false );
                handled = true;
            }
        }
        else if ( reasonBtn )
        {
            card = reasonBtn.closest( ".we-quiz-card" );

            if ( card )
            {
                WE_OnboardingQuizResults_OpenDrawer( reasonBtn, card );
                handled = true;
            }
        }
        else if ( closeBtn )
        {
            WE_OnboardingQuizResults_CloseDrawer( );
            handled = true;
        }
        else if ( atcBtn )
        {
            WE_QuizResults_AddActiveToCart( atcBtn );
            handled = true;
        }
        else
        {
            productLink = target.closest( "a[href*='/products/']" );
            if ( productLink )
            {
                card = productLink.closest( ".we-quiz-card" );
                if ( card && card.closest( ".we-onboarding-quiz-results-products" ) )
                {
                    reasonBtn = card.querySelector( ".we-quiz-card__reason" );
                    WE_OnboardingQuizResults_OpenDrawer( reasonBtn || null, card );
                    handled = true;
                }
            }
        }

        if ( !handled )
        {
            drawer = WE_OnboardingQuizResults_GetDrawer( );
            panel  = drawer ? drawer.querySelector( ".we-quiz-drawer__panel" ) : null;

            if ( drawer && panel && drawer.classList.contains( "we-quiz-drawer--open" ) && !panel.contains( target ) )
            {
                WE_OnboardingQuizResults_CloseDrawer( );
                handled = true;
            }
        }
    }

    if ( handled )
    {
        e.preventDefault( );
        e.stopPropagation( );
        WE_QuizResults_RecalculateFooterUI( );
    }
}

function WE_OnboardingQuizResults_OnKeyDown( e )
{
    if ( e.key == "Escape" )
    {
        WE_OnboardingQuizResults_CloseDrawer( );
    }
}

function WE_OnboardingQuiz_HideMobileButtonsOnSlide20( )
{
    var buttons = null;
    var i       = 0;
    var path    = window.location.pathname || "";
    var search  = window.location.search || "";

    if ( path.replace( /\/$/, "" ) == "/pages/welleasy-quiz" && search.indexOf( "slide=20" ) != -1 )
    {
        buttons = document.querySelectorAll( ".we-onboarding-quiz-buttons-mobile" );
        for ( i = 0; i < buttons.length; i++ )
        {
            buttons[ i ].style.display = "none !important";
        }
    }
}

function WE_SetQuizCardRemovedState( card, isRemoved )
{
    var addBack = null;

    addBack = card.querySelector( '.we-quiz-card__add-back' );

    if ( isRemoved )
    {
        card.classList.add( 'we-quiz-card--removed' );
        if ( addBack )
        {
            addBack.hidden = false;
        }
    }
    else
    {
        card.classList.remove( 'we-quiz-card--removed' );
        if ( addBack )
        {
            addBack.hidden = true;
        }
    }
}

function WE_OnQuizCardInteraction( e )
{
    var removeBtn = null;
    var addBackBtn = null;
    var card = null;

    removeBtn  = e.target.closest( '.we-quiz-card__remove' );
    addBackBtn = e.target.closest( '.we-quiz-card__add-back' );

    if ( removeBtn )
    {
        card = removeBtn.closest( '.we-quiz-card' );
        if ( card )
        {
            e.preventDefault( );
            e.stopPropagation( );
            WE_SetQuizCardRemovedState( card, true );
            WE_QuizResults_RecalculateFooterUI( );
        }
    }
    else if ( addBackBtn )
    {
        card = addBackBtn.closest( '.we-quiz-card' );
        if ( card )
        {
            e.preventDefault( );
            e.stopPropagation( );
            WE_SetQuizCardRemovedState( card, false );
            WE_QuizResults_RecalculateFooterUI( );
        }
    }
}

function WE_InitQuizCardRemoveUX( )
{
    document.addEventListener( 'click', WE_OnQuizCardInteraction );
}

function EC_Ruk_StripReviewsWord( )
{
    var snippets = null;

    snippets = document.querySelectorAll( ".ruk_rating_snippet" );

    for ( var i = 0; i < snippets.length; i++ )
    {
        var snippet = null;
        var countEl = null;
        var text    = "";

        snippet = snippets[ i ];
        countEl = snippet.querySelector( ".ruk-rating-snippet-count" );

        if ( countEl )
        {
            text = countEl.textContent || "";

            if ( text.indexOf( " Reviews" ) >= 0 )
            {
                text = text.replace( " Reviews", "" );
            }
            else if ( text.indexOf( " Review" ) >= 0 )
            {
                text = text.replace( " Review", "" );
            }

            countEl.textContent = text;
        }
    }

}


function WE_QuizResults_OnWidgetCardsLoaded( e )
{
    //console.log( "card loaded : ", e.detail );
    var card        = ( e && e.detail && e.detail.card ) || null;
    var productsEl  = document.querySelector( ".we-onboarding-quiz-results-products" );

    if ( productsEl && ( !card || productsEl.contains( card ) ) )
    {
        WE_QuizResults_EnhanceECCards( );
        WE_QuizResults_RecalculateFooterUI( );
        WE_QuizTracking_RecordResultsProductsOfferedMax( );
    }
}

function WE_QuizResults_OnWidgetCardPricesReady( e )
{
    var card       = ( e && e.detail && e.detail.card ) || null;
    var productsEl = document.querySelector( ".we-onboarding-quiz-results-products" );

    if ( productsEl && ( !card || productsEl.contains( card ) ) )
    {
        WE_QuizResults_RecalculateFooterUI( );
    }
}

function WE_OnboardingQuiz_OnDOMReady( )
{
    document.addEventListener( "click", WE_OnboardingQuizResults_OnClick );
    document.addEventListener( "keydown", WE_OnboardingQuizResults_OnKeyDown );

    window.addEventListener( "enhancedcommerce:card_rendered", WE_QuizResults_OnWidgetCardsLoaded );
    document.addEventListener( "enhancedcommerce:card_prices_ready", WE_QuizResults_OnWidgetCardPricesReady );

    WE_QuizResults_RecalculateFooterUI( );
    WE_QuizTracking_RecordResultsProductsOfferedMax( );
    WE_OnboardingQuiz_HideMobileButtonsOnSlide20( );
    WE_InitQuizCardRemoveUX( );
    EC_Ruk_StripReviewsWord( );
    WE_QuizLoader_StartSubtitleRotation( );
    window.addEventListener( "beforeunload", WE_QuizTracking_HandlePageExit );
}

function WE_QuizLoader_CollectSubtitles( subtitleEl )
{
    var subtitles = [];
    var i = 0;
    var value = "";

    for ( i = 1; i <= 4; i++ )
    {
        value = subtitleEl.getAttribute( "data-subtitle-" + i ) || "";

        if ( value != "" )
        {
            subtitles.push( value );
        }
    }

    return subtitles;
}

function WE_QuizLoader_StartSubtitleRotation( )
{
    var subtitleEl = document.querySelector( ".we-onboarding-quiz-results-loading .js-quiz-loader-subtitle" );
    var subtitles = [];
    var index = 0;
    var ticks = 0;
    var timerId = null;

    if ( !subtitleEl )
    {
        return;
    }

    subtitles = WE_QuizLoader_CollectSubtitles( subtitleEl );

    if ( subtitles.length < 2 )
    {
        return;
    }

    /* JUSTIFIED: rotating loader copy while results settle; bounded ticks and visible-only advance guarantee teardown. */
    timerId = setInterval( function WE_QuizLoader_RotateTick( )
    {
        ticks++;

        if ( ticks > 120 )
        {
            clearInterval( timerId );
            return;
        }

        if ( subtitleEl.offsetParent == null )
        {
            return;
        }

        index = ( index + 1 ) % subtitles.length;
        subtitleEl.textContent = subtitles[ index ];
    }, 2500 );
}

function WE_OnboardingQuiz_InitOnce( )
{
    var shouldRun = WE_OnboardingQuiz_InitOnce._ran != true;

    if ( shouldRun )
    {
        WE_OnboardingQuiz_InitOnce._ran = true;
        WE_OnboardingQuiz_OnDOMReady( );
    }
}

if ( document.readyState == "loading" )
{
    window.addEventListener( "DOMContentLoaded", WE_OnboardingQuiz_InitOnce );
}
else
{
    WE_OnboardingQuiz_InitOnce( );
}

function WE_OnboardingQuiz_IsQuizFlow( )
{
    var flow = "";

    try
    {
        flow = sessionStorage.getItem( "we_register_flow" ) || "";
    }
    catch ( e )
    {
        flow = "";
    }

    if ( flow == "quiz" )
    {
        return true;
    }

    return false;
}

function WE_QuizClearStaleResumeFlags( )
{
    try { localStorage.removeItem( "we_reached_reveal_picks" ); } catch ( e ) {}
    try { localStorage.removeItem( "quiz_reached_cart" ); } catch ( e ) {}
    try { localStorage.removeItem( "we_quiz_free_gift_variant" ); } catch ( e ) {}
    try { localStorage.removeItem( "we_quiz_free_gift_meta" ); } catch ( e ) {}
    try { localStorage.removeItem( "we_gift_variant_id" ); } catch ( e ) {}
    try { sessionStorage.removeItem( "we_quiz_added_to_cart" ); } catch ( e ) {}
}

function WE_OnboardingQuiz_IsBackForwardNav( )
{
    var navEntry = null;
    var isBackNav = false;

    if ( performance && performance.getEntriesByType )
    {
        navEntry = performance.getEntriesByType( "navigation" )[ 0 ];

        if ( navEntry && navEntry.type == "back_forward" )
        {
            isBackNav = true;
        }
    }

    return isBackNav;
}

function WE_OnboardingQuiz_OnPageShowBfCache( event )
{
    var quiz                  = null;
    var qp                    = null;
    var targetPosition        = 0;
    var slideIdx              = 0;
    var i                     = 0;
    var slidePosition         = 0;
    var navEntry              = null;
    var isBackNav             = false;
    var fromCartFlag          = null;
    var canHandleBackNav      = false;
    var hasSlideQuery         = false;
    var shouldRedirectToCart  = false;
    var hasValidTarget        = false;

    navEntry = performance.getEntriesByType( "navigation" )[ 0 ];
    isBackNav = ( event.persisted == true ) || ( navEntry && navEntry.type == "back_forward" );

    quiz = document.querySelector( ".we-onboarding-quiz" );
    qp = ParseQP( );
    hasSlideQuery = qp.slide != undefined && qp.slide != "";

    canHandleBackNav =
    (
        quiz &&
        window._onboardingQuizData &&
        window._onboardingQuizData.slides &&
        isBackNav &&
        hasSlideQuery
    );

    if ( canHandleBackNav )
    {
        try
        {
            fromCartFlag = sessionStorage.getItem( "we_checkout_started_from_cart" );
        }
        catch ( e )
        {
            fromCartFlag = null;
        }

        shouldRedirectToCart = fromCartFlag == "1";

        if ( qp.slide == "gift" )
        {
            try { sessionStorage.removeItem( "we_last_quiz_page" ); } catch ( e ) {}
            try { sessionStorage.removeItem( "we_last_quiz_slide_position" ); } catch ( e ) {}
            try { localStorage.removeItem( "quiz_account_creation" ); } catch ( e ) {}
            try { sessionStorage.removeItem( "quiz_logged_in_skip_register" ); } catch ( e ) {}
            ShowFreeGiftSlide( true );
        }
        else if ( shouldRedirectToCart )
        {
            try
            {
                sessionStorage.removeItem( "we_checkout_started_from_cart" );
            }
            catch ( e )
            {
            }

            window.location.replace( "/cart" );
        }
        else
        {
            if ( WE_OnboardingQuiz_IsQuizFlow() )
            {
                if ( qp.slide == "gift" )
                {
                    ShowFreeGiftSlide( true );
                    return;
                }

                targetPosition = parseInt( qp.slide, 10 );
                hasValidTarget = !isNaN( targetPosition );

                if ( hasValidTarget )
                {
                    slideIdx = 0;
                    for ( i = 0; i < window._onboardingQuizData.slides.length; i++ )
                    {
                        slidePosition = parseInt( window._onboardingQuizData.slides[ i ].position, 10 );
                        if ( !isNaN( slidePosition ) && slidePosition == targetPosition )
                        {
                            slideIdx = i;
                            break;
                        }
                    }

                    if ( slideIdx == 0 && targetPosition != parseInt( window._onboardingQuizData.slides[ 0 ].position, 10 ) )
                    {
                        var backResolved = WE_QuizProgress_ResolveIdx( );
                        if ( backResolved == -2 )
                        {
                            ShowFreeGiftSlide( true );
                            return;
                        }
                        else if ( backResolved >= 0 )
                        {
                            ShowSlide( backResolved, true );
                            return;
                        }
                        var backProgress = WE_OnboardingQuiz_ReadProgressPosition( );
                        if ( backProgress > 0 )
                        {
                            var backIdx = WE_OnboardingQuiz_FindSlideIdxByPosition( backProgress );
                            if ( backIdx >= 0 )
                            {
                                slideIdx = backIdx;
                            }
                        }
                    }

                    ShowSlide( slideIdx, true );
                }
            }
        }
    }
}

window.addEventListener( "pageshow", WE_OnboardingQuiz_OnPageShowBfCache );

window.addEventListener( 'popstate', function WE_OnboardingQuiz_OnPopState( event )
{
    var stateSlide   = null;
    var popQp        = null;
    var isGiftTarget = false;
    if ( event.state && event.state.slide )
    {
        stateSlide = event.state.slide;
    }
    if ( stateSlide == "gift" )
    {
        isGiftTarget = true;
    }
    else if ( stateSlide == null )
    {
        popQp = ParseQP( );
        if ( popQp.slide == "gift" )
        {
            isGiftTarget = true;
        }
    }
    if ( isGiftTarget )
    {
        try { sessionStorage.removeItem( "we_last_quiz_page" ); } catch ( e ) {}
        try { sessionStorage.removeItem( "we_last_quiz_slide_position" ); } catch ( e ) {}
        try { localStorage.removeItem( "quiz_account_creation" ); } catch ( e ) {}
        try { sessionStorage.removeItem( "quiz_logged_in_skip_register" ); } catch ( e ) {}
        ShowFreeGiftSlide( true );
    }
    else
    {
        var targetPosition = 0;

        if ( event.state && event.state.slide )
        {
            if ( event.state.slide == "gift" )
            {
                ShowFreeGiftSlide( true );
                return;
            }
            targetPosition = parseInt( event.state.slide, 10 );
        }
        else
        {
            var qp = ParseQP( );
            if ( qp.slide == "gift" )
            {
                ShowFreeGiftSlide( true );
                return;
            }
            if ( qp.slide != undefined && qp.slide != "" )
            {
                targetPosition = parseInt( qp.slide, 10 );
            }
        }

        if ( targetPosition && window._onboardingQuizData )
        {
            var popIdx = WE_OnboardingQuiz_FindSlideIdxByPosition( targetPosition );
            if ( popIdx < 0 )
            {
                popIdx = WE_QuizProgress_ResolveIdx( );
            }
            if ( popIdx == -2 )
            {
                ShowFreeGiftSlide( true );
                return;
            }
            if ( popIdx < 0 )
            {
                var popProgress = WE_OnboardingQuiz_ReadProgressPosition( );
                if ( popProgress > 0 )
                {
                    popIdx = WE_OnboardingQuiz_FindSlideIdxByPosition( popProgress );
                }
            }
            if ( popIdx >= 0 )
            {
                ShowSlide( popIdx, true );
            }
            else if ( window._onboardingQuizData && window._onboardingQuizData.slides.length > 0 )
            {
                ShowSlide( 0, true );
            }
        }
        else if ( window._onboardingQuizData && window._onboardingQuizData.slides.length > 0 )
        {
            ShowSlide( 0, true );
        }
    }
} );

const SAVE_EXIT_STORAGE_KEY = "welleasy_onboarding_quiz_progress";

function SaveQuizProgress( )
{
    var quiz       = document.querySelector( ".we-onboarding-quiz" );
    var currentIdx = quiz ? Number( quiz.getAttribute( "data-idx" ) ) : 0;
    var slides     = window._onboardingQuizData && window._onboardingQuizData.slides ? window._onboardingQuizData.slides : [];
    var slideData  = slides[ currentIdx ];
    var giftShown  = document.body.classList.contains( "on-gift-slide" );

    if ( giftShown )
    {
        WE_QuizProgress_WriteGift( );
    }
    else
    {
        if ( slideData && slideData.slideType == "Question" )
        {
            try
            {
                SaveOnboardingQuizAnswers( );
            }
            catch ( e )
            {
                console.error( "SaveQuizProgress answers failed:", e );
            }
        }

        WE_QuizProgress_WriteForSlide( slideData );
    }
}

function HandleSaveAndExitClick( )
{
    SaveQuizProgress( );
    window.location.href = "/pages/lightning-my-aisle";
}

function HandleGiftExitClick( e )
{
    WE_QuizProgress_WriteGift( );
}

function InitSaveAndExitButton( )
{
    var saveExitBtn = document.querySelector( ".we-onboarding-quiz-save-exit:not(.we-free-gift-exit)" );
    var giftExitBtn = document.querySelector( ".we-free-gift-exit" );
    if ( saveExitBtn && !saveExitBtn._weBound )
    {
        saveExitBtn.addEventListener( "click", HandleSaveAndExitClick );
        saveExitBtn._weBound = true;
    }
    if ( giftExitBtn && !giftExitBtn._weBound )
    {
        giftExitBtn.addEventListener( "click", HandleGiftExitClick );
        giftExitBtn._weBound = true;
    }
}
